var _a;
const defineCustomElementOnce = (name, element) => {
  if (customElements.get(name)) return;
  customElements.define(name, element);
};
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$1 = globalThis, e$5 = t$1.ShadowRoot && (void 0 === t$1.ShadyCSS || t$1.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, s$3 = Symbol(), o$3 = /* @__PURE__ */ new WeakMap();
let n$4 = class n {
  constructor(t2, e2, o2) {
    if (this._$cssResult$ = true, o2 !== s$3) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t2, this.t = e2;
  }
  get styleSheet() {
    let t2 = this.o;
    const s4 = this.t;
    if (e$5 && void 0 === t2) {
      const e2 = void 0 !== s4 && 1 === s4.length;
      e2 && (t2 = o$3.get(s4)), void 0 === t2 && ((this.o = t2 = new CSSStyleSheet()).replaceSync(this.cssText), e2 && o$3.set(s4, t2));
    }
    return t2;
  }
  toString() {
    return this.cssText;
  }
};
const r$3 = (t2) => new n$4("string" == typeof t2 ? t2 : t2 + "", void 0, s$3), S$1 = (s4, o2) => {
  if (e$5) s4.adoptedStyleSheets = o2.map((t2) => t2 instanceof CSSStyleSheet ? t2 : t2.styleSheet);
  else for (const e2 of o2) {
    const o3 = document.createElement("style"), n3 = t$1.litNonce;
    void 0 !== n3 && o3.setAttribute("nonce", n3), o3.textContent = e2.cssText, s4.appendChild(o3);
  }
}, c$3 = e$5 ? (t2) => t2 : (t2) => t2 instanceof CSSStyleSheet ? ((t3) => {
  let e2 = "";
  for (const s4 of t3.cssRules) e2 += s4.cssText;
  return r$3(e2);
})(t2) : t2;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { is: i$2, defineProperty: e$4, getOwnPropertyDescriptor: r$2, getOwnPropertyNames: h$2, getOwnPropertySymbols: o$2, getPrototypeOf: n$3 } = Object, a = globalThis, c$2 = a.trustedTypes, l = c$2 ? c$2.emptyScript : "", p = a.reactiveElementPolyfillSupport, d = (t2, s4) => t2, u = { toAttribute(t2, s4) {
  switch (s4) {
    case Boolean:
      t2 = t2 ? l : null;
      break;
    case Object:
    case Array:
      t2 = null == t2 ? t2 : JSON.stringify(t2);
  }
  return t2;
}, fromAttribute(t2, s4) {
  let i3 = t2;
  switch (s4) {
    case Boolean:
      i3 = null !== t2;
      break;
    case Number:
      i3 = null === t2 ? null : Number(t2);
      break;
    case Object:
    case Array:
      try {
        i3 = JSON.parse(t2);
      } catch (t3) {
        i3 = null;
      }
  }
  return i3;
} }, f$2 = (t2, s4) => !i$2(t2, s4), y = { attribute: true, type: String, converter: u, reflect: false, hasChanged: f$2 };
Symbol.metadata ?? (Symbol.metadata = Symbol("metadata")), a.litPropertyMetadata ?? (a.litPropertyMetadata = /* @__PURE__ */ new WeakMap());
class b extends HTMLElement {
  static addInitializer(t2) {
    this._$Ei(), (this.l ?? (this.l = [])).push(t2);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t2, s4 = y) {
    if (s4.state && (s4.attribute = false), this._$Ei(), this.elementProperties.set(t2, s4), !s4.noAccessor) {
      const i3 = Symbol(), r2 = this.getPropertyDescriptor(t2, i3, s4);
      void 0 !== r2 && e$4(this.prototype, t2, r2);
    }
  }
  static getPropertyDescriptor(t2, s4, i3) {
    const { get: e2, set: h2 } = r$2(this.prototype, t2) ?? { get() {
      return this[s4];
    }, set(t3) {
      this[s4] = t3;
    } };
    return { get() {
      return e2 == null ? void 0 : e2.call(this);
    }, set(s5) {
      const r2 = e2 == null ? void 0 : e2.call(this);
      h2.call(this, s5), this.requestUpdate(t2, r2, i3);
    }, configurable: true, enumerable: true };
  }
  static getPropertyOptions(t2) {
    return this.elementProperties.get(t2) ?? y;
  }
  static _$Ei() {
    if (this.hasOwnProperty(d("elementProperties"))) return;
    const t2 = n$3(this);
    t2.finalize(), void 0 !== t2.l && (this.l = [...t2.l]), this.elementProperties = new Map(t2.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(d("finalized"))) return;
    if (this.finalized = true, this._$Ei(), this.hasOwnProperty(d("properties"))) {
      const t3 = this.properties, s4 = [...h$2(t3), ...o$2(t3)];
      for (const i3 of s4) this.createProperty(i3, t3[i3]);
    }
    const t2 = this[Symbol.metadata];
    if (null !== t2) {
      const s4 = litPropertyMetadata.get(t2);
      if (void 0 !== s4) for (const [t3, i3] of s4) this.elementProperties.set(t3, i3);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [t3, s4] of this.elementProperties) {
      const i3 = this._$Eu(t3, s4);
      void 0 !== i3 && this._$Eh.set(i3, t3);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(s4) {
    const i3 = [];
    if (Array.isArray(s4)) {
      const e2 = new Set(s4.flat(1 / 0).reverse());
      for (const s5 of e2) i3.unshift(c$3(s5));
    } else void 0 !== s4 && i3.push(c$3(s4));
    return i3;
  }
  static _$Eu(t2, s4) {
    const i3 = s4.attribute;
    return false === i3 ? void 0 : "string" == typeof i3 ? i3 : "string" == typeof t2 ? t2.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = false, this.hasUpdated = false, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    var _a2;
    this._$ES = new Promise((t2) => this.enableUpdating = t2), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), (_a2 = this.constructor.l) == null ? void 0 : _a2.forEach((t2) => t2(this));
  }
  addController(t2) {
    var _a2;
    (this._$EO ?? (this._$EO = /* @__PURE__ */ new Set())).add(t2), void 0 !== this.renderRoot && this.isConnected && ((_a2 = t2.hostConnected) == null ? void 0 : _a2.call(t2));
  }
  removeController(t2) {
    var _a2;
    (_a2 = this._$EO) == null ? void 0 : _a2.delete(t2);
  }
  _$E_() {
    const t2 = /* @__PURE__ */ new Map(), s4 = this.constructor.elementProperties;
    for (const i3 of s4.keys()) this.hasOwnProperty(i3) && (t2.set(i3, this[i3]), delete this[i3]);
    t2.size > 0 && (this._$Ep = t2);
  }
  createRenderRoot() {
    const t2 = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return S$1(t2, this.constructor.elementStyles), t2;
  }
  connectedCallback() {
    var _a2;
    this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this.enableUpdating(true), (_a2 = this._$EO) == null ? void 0 : _a2.forEach((t2) => {
      var _a3;
      return (_a3 = t2.hostConnected) == null ? void 0 : _a3.call(t2);
    });
  }
  enableUpdating(t2) {
  }
  disconnectedCallback() {
    var _a2;
    (_a2 = this._$EO) == null ? void 0 : _a2.forEach((t2) => {
      var _a3;
      return (_a3 = t2.hostDisconnected) == null ? void 0 : _a3.call(t2);
    });
  }
  attributeChangedCallback(t2, s4, i3) {
    this._$AK(t2, i3);
  }
  _$EC(t2, s4) {
    var _a2;
    const i3 = this.constructor.elementProperties.get(t2), e2 = this.constructor._$Eu(t2, i3);
    if (void 0 !== e2 && true === i3.reflect) {
      const r2 = (void 0 !== ((_a2 = i3.converter) == null ? void 0 : _a2.toAttribute) ? i3.converter : u).toAttribute(s4, i3.type);
      this._$Em = t2, null == r2 ? this.removeAttribute(e2) : this.setAttribute(e2, r2), this._$Em = null;
    }
  }
  _$AK(t2, s4) {
    var _a2;
    const i3 = this.constructor, e2 = i3._$Eh.get(t2);
    if (void 0 !== e2 && this._$Em !== e2) {
      const t3 = i3.getPropertyOptions(e2), r2 = "function" == typeof t3.converter ? { fromAttribute: t3.converter } : void 0 !== ((_a2 = t3.converter) == null ? void 0 : _a2.fromAttribute) ? t3.converter : u;
      this._$Em = e2, this[e2] = r2.fromAttribute(s4, t3.type), this._$Em = null;
    }
  }
  requestUpdate(t2, s4, i3) {
    if (void 0 !== t2) {
      if (i3 ?? (i3 = this.constructor.getPropertyOptions(t2)), !(i3.hasChanged ?? f$2)(this[t2], s4)) return;
      this.P(t2, s4, i3);
    }
    false === this.isUpdatePending && (this._$ES = this._$ET());
  }
  P(t2, s4, i3) {
    this._$AL.has(t2) || this._$AL.set(t2, s4), true === i3.reflect && this._$Em !== t2 && (this._$Ej ?? (this._$Ej = /* @__PURE__ */ new Set())).add(t2);
  }
  async _$ET() {
    this.isUpdatePending = true;
    try {
      await this._$ES;
    } catch (t3) {
      Promise.reject(t3);
    }
    const t2 = this.scheduleUpdate();
    return null != t2 && await t2, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var _a2;
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this._$Ep) {
        for (const [t4, s5] of this._$Ep) this[t4] = s5;
        this._$Ep = void 0;
      }
      const t3 = this.constructor.elementProperties;
      if (t3.size > 0) for (const [s5, i3] of t3) true !== i3.wrapped || this._$AL.has(s5) || void 0 === this[s5] || this.P(s5, this[s5], i3);
    }
    let t2 = false;
    const s4 = this._$AL;
    try {
      t2 = this.shouldUpdate(s4), t2 ? (this.willUpdate(s4), (_a2 = this._$EO) == null ? void 0 : _a2.forEach((t3) => {
        var _a3;
        return (_a3 = t3.hostUpdate) == null ? void 0 : _a3.call(t3);
      }), this.update(s4)) : this._$EU();
    } catch (s5) {
      throw t2 = false, this._$EU(), s5;
    }
    t2 && this._$AE(s4);
  }
  willUpdate(t2) {
  }
  _$AE(t2) {
    var _a2;
    (_a2 = this._$EO) == null ? void 0 : _a2.forEach((t3) => {
      var _a3;
      return (_a3 = t3.hostUpdated) == null ? void 0 : _a3.call(t3);
    }), this.hasUpdated || (this.hasUpdated = true, this.firstUpdated(t2)), this.updated(t2);
  }
  _$EU() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = false;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t2) {
    return true;
  }
  update(t2) {
    this._$Ej && (this._$Ej = this._$Ej.forEach((t3) => this._$EC(t3, this[t3]))), this._$EU();
  }
  updated(t2) {
  }
  firstUpdated(t2) {
  }
}
b.elementStyles = [], b.shadowRootOptions = { mode: "open" }, b[d("elementProperties")] = /* @__PURE__ */ new Map(), b[d("finalized")] = /* @__PURE__ */ new Map(), p == null ? void 0 : p({ ReactiveElement: b }), (a.reactiveElementVersions ?? (a.reactiveElementVersions = [])).push("2.0.4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const n$2 = globalThis, c$1 = n$2.trustedTypes, h$1 = c$1 ? c$1.createPolicy("lit-html", { createHTML: (t2) => t2 }) : void 0, f$1 = "$lit$", v = `lit$${Math.random().toFixed(9).slice(2)}$`, m = "?" + v, _ = `<${m}>`, w = document, lt = () => w.createComment(""), st = (t2) => null === t2 || "object" != typeof t2 && "function" != typeof t2, g = Array.isArray, $ = (t2) => g(t2) || "function" == typeof (t2 == null ? void 0 : t2[Symbol.iterator]), x = "[ 	\n\f\r]", T = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, E = /-->/g, k = />/g, O = RegExp(`>|${x}(?:([^\\s"'>=/]+)(${x}*=${x}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), S = /'/g, j = /"/g, M = /^(?:script|style|textarea|title)$/i, P = (t2) => (i3, ...s4) => ({ _$litType$: t2, strings: i3, values: s4 }), ke$1 = P(1), R = Symbol.for("lit-noChange"), D = Symbol.for("lit-nothing"), V = /* @__PURE__ */ new WeakMap(), I = w.createTreeWalker(w, 129);
function N(t2, i3) {
  if (!g(t2) || !t2.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return void 0 !== h$1 ? h$1.createHTML(i3) : i3;
}
const U = (t2, i3) => {
  const s4 = t2.length - 1, e2 = [];
  let h2, o2 = 2 === i3 ? "<svg>" : 3 === i3 ? "<math>" : "", n3 = T;
  for (let i4 = 0; i4 < s4; i4++) {
    const s5 = t2[i4];
    let r2, l2, c2 = -1, a2 = 0;
    for (; a2 < s5.length && (n3.lastIndex = a2, l2 = n3.exec(s5), null !== l2); ) a2 = n3.lastIndex, n3 === T ? "!--" === l2[1] ? n3 = E : void 0 !== l2[1] ? n3 = k : void 0 !== l2[2] ? (M.test(l2[2]) && (h2 = RegExp("</" + l2[2], "g")), n3 = O) : void 0 !== l2[3] && (n3 = O) : n3 === O ? ">" === l2[0] ? (n3 = h2 ?? T, c2 = -1) : void 0 === l2[1] ? c2 = -2 : (c2 = n3.lastIndex - l2[2].length, r2 = l2[1], n3 = void 0 === l2[3] ? O : '"' === l2[3] ? j : S) : n3 === j || n3 === S ? n3 = O : n3 === E || n3 === k ? n3 = T : (n3 = O, h2 = void 0);
    const u2 = n3 === O && t2[i4 + 1].startsWith("/>") ? " " : "";
    o2 += n3 === T ? s5 + _ : c2 >= 0 ? (e2.push(r2), s5.slice(0, c2) + f$1 + s5.slice(c2) + v + u2) : s5 + v + (-2 === c2 ? i4 : u2);
  }
  return [N(t2, o2 + (t2[s4] || "<?>") + (2 === i3 ? "</svg>" : 3 === i3 ? "</math>" : "")), e2];
};
class B {
  constructor({ strings: t2, _$litType$: i3 }, s4) {
    let e2;
    this.parts = [];
    let h2 = 0, o2 = 0;
    const n3 = t2.length - 1, r2 = this.parts, [l2, a2] = U(t2, i3);
    if (this.el = B.createElement(l2, s4), I.currentNode = this.el.content, 2 === i3 || 3 === i3) {
      const t3 = this.el.content.firstChild;
      t3.replaceWith(...t3.childNodes);
    }
    for (; null !== (e2 = I.nextNode()) && r2.length < n3; ) {
      if (1 === e2.nodeType) {
        if (e2.hasAttributes()) for (const t3 of e2.getAttributeNames()) if (t3.endsWith(f$1)) {
          const i4 = a2[o2++], s5 = e2.getAttribute(t3).split(v), n4 = /([.?@])?(.*)/.exec(i4);
          r2.push({ type: 1, index: h2, name: n4[2], strings: s5, ctor: "." === n4[1] ? Y : "?" === n4[1] ? Z : "@" === n4[1] ? q : G }), e2.removeAttribute(t3);
        } else t3.startsWith(v) && (r2.push({ type: 6, index: h2 }), e2.removeAttribute(t3));
        if (M.test(e2.tagName)) {
          const t3 = e2.textContent.split(v), i4 = t3.length - 1;
          if (i4 > 0) {
            e2.textContent = c$1 ? c$1.emptyScript : "";
            for (let s5 = 0; s5 < i4; s5++) e2.append(t3[s5], lt()), I.nextNode(), r2.push({ type: 2, index: ++h2 });
            e2.append(t3[i4], lt());
          }
        }
      } else if (8 === e2.nodeType) if (e2.data === m) r2.push({ type: 2, index: h2 });
      else {
        let t3 = -1;
        for (; -1 !== (t3 = e2.data.indexOf(v, t3 + 1)); ) r2.push({ type: 7, index: h2 }), t3 += v.length - 1;
      }
      h2++;
    }
  }
  static createElement(t2, i3) {
    const s4 = w.createElement("template");
    return s4.innerHTML = t2, s4;
  }
}
function z(t2, i3, s4 = t2, e2) {
  var _a2, _b;
  if (i3 === R) return i3;
  let h2 = void 0 !== e2 ? (_a2 = s4.o) == null ? void 0 : _a2[e2] : s4.l;
  const o2 = st(i3) ? void 0 : i3._$litDirective$;
  return (h2 == null ? void 0 : h2.constructor) !== o2 && ((_b = h2 == null ? void 0 : h2._$AO) == null ? void 0 : _b.call(h2, false), void 0 === o2 ? h2 = void 0 : (h2 = new o2(t2), h2._$AT(t2, s4, e2)), void 0 !== e2 ? (s4.o ?? (s4.o = []))[e2] = h2 : s4.l = h2), void 0 !== h2 && (i3 = z(t2, h2._$AS(t2, i3.values), h2, e2)), i3;
}
class F {
  constructor(t2, i3) {
    this._$AV = [], this._$AN = void 0, this._$AD = t2, this._$AM = i3;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t2) {
    const { el: { content: i3 }, parts: s4 } = this._$AD, e2 = ((t2 == null ? void 0 : t2.creationScope) ?? w).importNode(i3, true);
    I.currentNode = e2;
    let h2 = I.nextNode(), o2 = 0, n3 = 0, r2 = s4[0];
    for (; void 0 !== r2; ) {
      if (o2 === r2.index) {
        let i4;
        2 === r2.type ? i4 = new et(h2, h2.nextSibling, this, t2) : 1 === r2.type ? i4 = new r2.ctor(h2, r2.name, r2.strings, this, t2) : 6 === r2.type && (i4 = new K(h2, this, t2)), this._$AV.push(i4), r2 = s4[++n3];
      }
      o2 !== (r2 == null ? void 0 : r2.index) && (h2 = I.nextNode(), o2++);
    }
    return I.currentNode = w, e2;
  }
  p(t2) {
    let i3 = 0;
    for (const s4 of this._$AV) void 0 !== s4 && (void 0 !== s4.strings ? (s4._$AI(t2, s4, i3), i3 += s4.strings.length - 2) : s4._$AI(t2[i3])), i3++;
  }
}
class et {
  get _$AU() {
    var _a2;
    return ((_a2 = this._$AM) == null ? void 0 : _a2._$AU) ?? this.v;
  }
  constructor(t2, i3, s4, e2) {
    this.type = 2, this._$AH = D, this._$AN = void 0, this._$AA = t2, this._$AB = i3, this._$AM = s4, this.options = e2, this.v = (e2 == null ? void 0 : e2.isConnected) ?? true;
  }
  get parentNode() {
    let t2 = this._$AA.parentNode;
    const i3 = this._$AM;
    return void 0 !== i3 && 11 === (t2 == null ? void 0 : t2.nodeType) && (t2 = i3.parentNode), t2;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t2, i3 = this) {
    t2 = z(this, t2, i3), st(t2) ? t2 === D || null == t2 || "" === t2 ? (this._$AH !== D && this._$AR(), this._$AH = D) : t2 !== this._$AH && t2 !== R && this._(t2) : void 0 !== t2._$litType$ ? this.$(t2) : void 0 !== t2.nodeType ? this.T(t2) : $(t2) ? this.k(t2) : this._(t2);
  }
  O(t2) {
    return this._$AA.parentNode.insertBefore(t2, this._$AB);
  }
  T(t2) {
    this._$AH !== t2 && (this._$AR(), this._$AH = this.O(t2));
  }
  _(t2) {
    this._$AH !== D && st(this._$AH) ? this._$AA.nextSibling.data = t2 : this.T(w.createTextNode(t2)), this._$AH = t2;
  }
  $(t2) {
    var _a2;
    const { values: i3, _$litType$: s4 } = t2, e2 = "number" == typeof s4 ? this._$AC(t2) : (void 0 === s4.el && (s4.el = B.createElement(N(s4.h, s4.h[0]), this.options)), s4);
    if (((_a2 = this._$AH) == null ? void 0 : _a2._$AD) === e2) this._$AH.p(i3);
    else {
      const t3 = new F(e2, this), s5 = t3.u(this.options);
      t3.p(i3), this.T(s5), this._$AH = t3;
    }
  }
  _$AC(t2) {
    let i3 = V.get(t2.strings);
    return void 0 === i3 && V.set(t2.strings, i3 = new B(t2)), i3;
  }
  k(t2) {
    g(this._$AH) || (this._$AH = [], this._$AR());
    const i3 = this._$AH;
    let s4, e2 = 0;
    for (const h2 of t2) e2 === i3.length ? i3.push(s4 = new et(this.O(lt()), this.O(lt()), this, this.options)) : s4 = i3[e2], s4._$AI(h2), e2++;
    e2 < i3.length && (this._$AR(s4 && s4._$AB.nextSibling, e2), i3.length = e2);
  }
  _$AR(t2 = this._$AA.nextSibling, i3) {
    var _a2;
    for ((_a2 = this._$AP) == null ? void 0 : _a2.call(this, false, true, i3); t2 && t2 !== this._$AB; ) {
      const i4 = t2.nextSibling;
      t2.remove(), t2 = i4;
    }
  }
  setConnected(t2) {
    var _a2;
    void 0 === this._$AM && (this.v = t2, (_a2 = this._$AP) == null ? void 0 : _a2.call(this, t2));
  }
}
class G {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t2, i3, s4, e2, h2) {
    this.type = 1, this._$AH = D, this._$AN = void 0, this.element = t2, this.name = i3, this._$AM = e2, this.options = h2, s4.length > 2 || "" !== s4[0] || "" !== s4[1] ? (this._$AH = Array(s4.length - 1).fill(new String()), this.strings = s4) : this._$AH = D;
  }
  _$AI(t2, i3 = this, s4, e2) {
    const h2 = this.strings;
    let o2 = false;
    if (void 0 === h2) t2 = z(this, t2, i3, 0), o2 = !st(t2) || t2 !== this._$AH && t2 !== R, o2 && (this._$AH = t2);
    else {
      const e3 = t2;
      let n3, r2;
      for (t2 = h2[0], n3 = 0; n3 < h2.length - 1; n3++) r2 = z(this, e3[s4 + n3], i3, n3), r2 === R && (r2 = this._$AH[n3]), o2 || (o2 = !st(r2) || r2 !== this._$AH[n3]), r2 === D ? t2 = D : t2 !== D && (t2 += (r2 ?? "") + h2[n3 + 1]), this._$AH[n3] = r2;
    }
    o2 && !e2 && this.j(t2);
  }
  j(t2) {
    t2 === D ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t2 ?? "");
  }
}
class Y extends G {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t2) {
    this.element[this.name] = t2 === D ? void 0 : t2;
  }
}
class Z extends G {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t2) {
    this.element.toggleAttribute(this.name, !!t2 && t2 !== D);
  }
}
class q extends G {
  constructor(t2, i3, s4, e2, h2) {
    super(t2, i3, s4, e2, h2), this.type = 5;
  }
  _$AI(t2, i3 = this) {
    if ((t2 = z(this, t2, i3, 0) ?? D) === R) return;
    const s4 = this._$AH, e2 = t2 === D && s4 !== D || t2.capture !== s4.capture || t2.once !== s4.once || t2.passive !== s4.passive, h2 = t2 !== D && (s4 === D || e2);
    e2 && this.element.removeEventListener(this.name, this, s4), h2 && this.element.addEventListener(this.name, this, t2), this._$AH = t2;
  }
  handleEvent(t2) {
    var _a2;
    "function" == typeof this._$AH ? this._$AH.call(((_a2 = this.options) == null ? void 0 : _a2.host) ?? this.element, t2) : this._$AH.handleEvent(t2);
  }
}
class K {
  constructor(t2, i3, s4) {
    this.element = t2, this.type = 6, this._$AN = void 0, this._$AM = i3, this.options = s4;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t2) {
    z(this, t2);
  }
}
const Re = n$2.litHtmlPolyfillSupport;
Re == null ? void 0 : Re(B, et), (n$2.litHtmlVersions ?? (n$2.litHtmlVersions = [])).push("3.2.0");
const Q = (t2, i3, s4) => {
  const e2 = (s4 == null ? void 0 : s4.renderBefore) ?? i3;
  let h2 = e2._$litPart$;
  if (void 0 === h2) {
    const t3 = (s4 == null ? void 0 : s4.renderBefore) ?? null;
    e2._$litPart$ = h2 = new et(i3.insertBefore(lt(), t3), t3, void 0, s4 ?? {});
  }
  return h2._$AI(t2), h2;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class h extends b {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this.o = void 0;
  }
  createRenderRoot() {
    var _a2;
    const t2 = super.createRenderRoot();
    return (_a2 = this.renderOptions).renderBefore ?? (_a2.renderBefore = t2.firstChild), t2;
  }
  update(t2) {
    const e2 = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t2), this.o = Q(e2, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var _a2;
    super.connectedCallback(), (_a2 = this.o) == null ? void 0 : _a2.setConnected(true);
  }
  disconnectedCallback() {
    var _a2;
    super.disconnectedCallback(), (_a2 = this.o) == null ? void 0 : _a2.setConnected(false);
  }
  render() {
    return R;
  }
}
h._$litElement$ = true, h["finalized"] = true, (_a = globalThis.litElementHydrateSupport) == null ? void 0 : _a.call(globalThis, { LitElement: h });
const f = globalThis.litElementPolyfillSupport;
f == null ? void 0 : f({ LitElement: h });
(globalThis.litElementVersions ?? (globalThis.litElementVersions = [])).push("4.1.0");
const baseStyles = `/* Modern css reset by piccalilli: https://piccalil.li/blog/a-modern-css-reset/ */
/* stylelint-disable selector-max-universal */
/* Box sizing rules */
*,
*::before,
*::after {
  box-sizing: border-box;
}
/* stylelint-enable selector-max-universal */
/* Remove default margin */
body,
h1,
h2,
h3,
h4,
h5,
h6,
p,
figure,
blockquote,
dl,
dd {
  margin: 0;
}
/* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
ul:where([role="list"]),
ol:where([role="list"]),
ul:where([role="tablist"]),
ol:where([role="tablist"]) {
  list-style: none;
  margin: 0;
  padding: 0;
}
/* Set core root defaults */
html:focus-within {
  scroll-behavior: smooth;
}
/* Set core body defaults */
body {
  min-block-size: 100vh;
  /* stylelint-disable-next-line declaration-property-value-allowed-list */
  line-height: 1.5;
  text-rendering: optimizespeed;
}
/* A elements that don't have a class get default styles */
a:not([class]) {
  -webkit-text-decoration-skip: ink;
          text-decoration-skip-ink: auto;
}
/* Make images easier to work with */
img,
picture {
  display: block;
  max-inline-size: 100%;
}
/* Inherit fonts for inputs and buttons */
input,
button,
textarea,
select {
  font: inherit;
}
/* Remove all animations, transitions and smooth scroll for people that prefer not to see them */
@media (prefers-reduced-motion: reduce) {
  html:focus-within {
    scroll-behavior: auto;
  }
  /* stylelint-disable declaration-no-important, selector-max-universal, time-min-milliseconds,  */
  *,
  *::before,
  *::after {
    background-attachment: scroll !important;
    background-attachment: initial !important;
    animation-duration: 1ms !important;
    animation-delay: -1ms !important;
    animation-iteration-count: 1 !important;
    scroll-behavior: auto !important;
    transition-duration: 1ms !important;
    transition-delay: -1ms !important;
  }
}
/* stylelint-enable declaration-no-important, selector-max-universal, time-min-milliseconds  */
/**
/* This file is for setting minimum base styles and normalizing common tags.
/* Do not style tags like h1, h2, p etc. globally because they rarely have the same styling on every page!
**/
html {
  box-sizing: border-box;
  block-size: 100%;
}
/* stylelint-disable declaration-no-important */
[hidden] {
  display: none !important;
}
/* stylelint-enable declaration-no-important */
body {
  block-size: 100%;
  font: var(--zw-typography-text-m-regular);
  font-feature-settings: "kern" 1, "kern";
  font-kerning: normal;
  text-align: start;
  -webkit-text-size-adjust: 100%;
          text-size-adjust: 100%;
  color: var(--zw-color-on-surface);
}
b,
strong {
  font-weight: 700;
}
i,
em {
  font-style: italic;
}
dfn,
address {
  font-style: normal;
}
abbr[title] {
  border-block-end: 0;
  -webkit-text-decoration: underline;
  text-decoration: underline;
  cursor: help;
}
sub,
sup {
  position: relative;
}
sub {
  inset-block-start: 4px;
}
sup {
  inset-block-start: -6px;
}
hr {
  block-size: 1px;
  margin: 0;
  border: 0;
  padding: 0;
}
button {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  display: inline-block;
  overflow: visible;
  position: relative;
  vertical-align: top;
  margin: 0;
  border: 0;
  padding: 0;
  font: inherit;
  text-align: center;
  text-transform: none;
  background-color: transparent;
  cursor: pointer;
}
button[disabled] {
    cursor: not-allowed;
  }
button:focus,button:hover,button:active {
    outline: 0;
  }
button::-moz-focus-inner {
    border: 0;
    padding: 0;
  }
a {
  -webkit-text-decoration: none;
  text-decoration: none;
  -webkit-text-decoration-skip: objects;
          text-decoration-skip: objects;
  color: inherit;
  background-color: transparent;
  cursor: pointer;
}
a:focus,a:hover,a:active {
    outline: 0;
    -webkit-text-decoration: underline;
    text-decoration: underline;
  }
textarea {
  min-block-size: 5rem;
  resize: vertical;
}
/* Z-Layer Tokens */
:host {
  --zw-z-index-below: var(--z-index-below, -1);
  --zw-z-index-above: var(--z-index-above, 1);
  --zw-z-index-select: var(--z-index-select, 1000);
}
/* Utilities */
.sr-only {
  clip: rect(0, 0, 0, 0);
  overflow: hidden;
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  margin: -1px;
  border-width: 0;
  padding: 0;
  white-space: nowrap;
}
`;
const animations = "@keyframes fade-in-from-top {\n  0% {\n    opacity: 0;\n    transform: translateY(calc(-1 * var(--zw-spacing-8)));\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fade-in-from-bottom {\n  0% {\n    opacity: 0;\n    transform: translateY(calc(1 * var(--zw-spacing-8)));\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fade-out-to-top {\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n    transform: translateY(calc(-1 * var(--zw-spacing-8)));\n  }\n}\n\n@keyframes fade-in-from-left {\n  0% {\n    opacity: 0;\n    transform: translateX(-100%);\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fade-in-from-right {\n  0% {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fade-in {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n";
const repelStyles = ".zw-repel {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n";
const styles$O = ":host {\n  display: block;\n}\n\n.zw-accordion {\n  --zw-accordion-padding: var(--zw-spacing-8);\n\n  padding: var(--zw-accordion-padding);\n}\n\n.zw-accordion--summary {\n  list-style: none;\n  margin-block-end: var(--zw-spacing-16);\n  font: var(--zw-typography-text-l-medium);\n  font-weight: 700;\n  cursor: pointer;\n\n  /* Hides the default styling for safari */\n}\n\n.zw-accordion--summary::-webkit-details-marker {\n    display: none;\n  }\n\n.zw-accordion--icon {\n  transition: transform var(--zw-animation-duration-default) linear;\n}\n\n.zw-accordion[open] .zw-accordion--icon {\n    transform: rotate(180deg);\n  }\n\n.zw-accordion--summary-addon {\n  display: flex;\n  align-items: center;\n  gap: var(--zw-spacing-4);\n}\n\n/* Animation just works for the first time for chromium browsers */\n/* TODO (optional): Provide a JS solution with the WAAPI */\n.zw-accordion--details {\n  animation: fade-out-to-top var(--zw-animation-duration-default);\n}\n.zw-accordion[open] .zw-accordion--details {\n    animation: fade-in-from-top var(--zw-animation-duration-default);\n  }\n";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const o$1 = { attribute: true, type: String, converter: u, reflect: false, hasChanged: f$2 }, r$1 = (t2 = o$1, e2, r2) => {
  const { kind: n3, metadata: i3 } = r2;
  let s4 = globalThis.litPropertyMetadata.get(i3);
  if (void 0 === s4 && globalThis.litPropertyMetadata.set(i3, s4 = /* @__PURE__ */ new Map()), s4.set(r2.name, t2), "accessor" === n3) {
    const { name: o2 } = r2;
    return { set(r3) {
      const n4 = e2.get.call(this);
      e2.set.call(this, r3), this.requestUpdate(o2, n4, t2);
    }, init(e3) {
      return void 0 !== e3 && this.P(o2, void 0, t2), e3;
    } };
  }
  if ("setter" === n3) {
    const { name: o2 } = r2;
    return function(r3) {
      const n4 = this[o2];
      e2.call(this, r3), this.requestUpdate(o2, n4, t2);
    };
  }
  throw Error("Unsupported decorator location: " + n3);
};
function n$1(t2) {
  return (e2, o2) => "object" == typeof o2 ? r$1(t2, e2, o2) : ((t3, e3, o3) => {
    const r2 = e3.hasOwnProperty(o3);
    return e3.constructor.createProperty(o3, r2 ? { ...t3, wrapped: true } : t3), r2 ? Object.getOwnPropertyDescriptor(e3, o3) : void 0;
  })(t2, e2, o2);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function r(r2) {
  return n$1({ ...r2, state: true, attribute: false });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const e$3 = (e2, t2, c2) => (c2.configurable = true, c2.enumerable = true, Reflect.decorate && "object" != typeof t2 && Object.defineProperty(e2, t2, c2), c2);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function e$2(e2, r2) {
  return (n3, s4, i3) => {
    const o2 = (t2) => {
      var _a2;
      return ((_a2 = t2.renderRoot) == null ? void 0 : _a2.querySelector(e2)) ?? null;
    };
    return e$3(n3, s4, { get() {
      return o2(this);
    } });
  };
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function o(o2) {
  return (e2, n3) => {
    const { slot: r2, selector: s4 } = o2 ?? {}, c2 = "slot" + (r2 ? `[name=${r2}]` : ":not([name])");
    return e$3(e2, n3, { get() {
      var _a2;
      const t2 = (_a2 = this.renderRoot) == null ? void 0 : _a2.querySelector(c2), e3 = (t2 == null ? void 0 : t2.assignedElements(o2)) ?? [];
      return void 0 === s4 ? e3 : e3.filter((t3) => t3.matches(s4));
    } });
  };
}
const styles$N = ':host {\n  display: contents;\n}\n\n:host([size="xs"]) {\n  font-size: var(--zw-icon-size-xs);\n}\n\n:host([size="s"]) {\n  font-size: var(--zw-icon-size-s);\n}\n\n:host([size="m"]) {\n  font-size: var(--zw-icon-size-m);\n}\n\n:host([size="l"]) {\n  font-size: var(--zw-icon-size-l);\n}\n\n:host([size="xl"]) {\n  font-size: var(--zw-icon-size-xl);\n}\n\n:host([variant="filled"]) {\n  font-family: "Material Icons Filled", sans-serif;\n}\n\n:host([variant="outlined"]) {\n  font-family: "Material Icons Outlined", sans-serif;\n}\n\n.zw-icon {\n  display: block;\n\n  /* These styles are copied from https://github.com/marella/material-icons/blob/main/iconfont/material-icons.css */\n  font-feature-settings: "liga";\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: normal;\n  /* stylelint-disable-next-line declaration-property-value-allowed-list */\n  line-height: 1;\n  text-rendering: optimizelegibility;\n  text-transform: none;\n  white-space: nowrap;\n  word-wrap: normal;\n  direction: ltr;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n';
var __defProp$K = Object.defineProperty;
var __decorateClass$K = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$K(target, key, result);
  return result;
};
const _Icon = class _Icon extends h {
  constructor() {
    super(...arguments);
    this.size = "l";
    this.variant = "outlined";
  }
  render() {
    return ke$1` <span class="zw-icon"> ${this.name} </span> `;
  }
};
_Icon.styles = [r$3(baseStyles), r$3(styles$N)];
let Icon = _Icon;
__decorateClass$K([
  n$1({ reflect: true })
], Icon.prototype, "name");
__decorateClass$K([
  n$1({ reflect: true })
], Icon.prototype, "size");
__decorateClass$K([
  n$1({ reflect: true })
], Icon.prototype, "variant");
const _Accordion = class _Accordion extends h {
  constructor() {
    super();
    defineCustomElementOnce("zw-icon", Icon);
  }
  summaryHTML() {
    return ke$1`<summary class="zw-repel | zw-accordion--summary">
      <slot name="header"></slot>

      <div class="zw-accordion--icon">
        <zw-icon name="expand_more" variant="filled"></zw-icon>
      </div>
    </summary>`;
  }
  render() {
    return ke$1`<details class="zw-accordion">
      ${this.summaryHTML()}

      <div class="zw-accordion--details">
        <slot></slot>
      </div>
    </details>`;
  }
};
_Accordion.styles = [
  r$3(baseStyles),
  r$3(animations),
  r$3(repelStyles),
  r$3(styles$O)
];
_Accordion.shadowRootOptions = { ...h.shadowRootOptions, delegatesFocus: true };
let Accordion = _Accordion;
const styles$M = ':host {\n  display: inline-block;\n}\n\n:host([size="s"]) {\n  --zw-avatar-size: var(--zw-avatar-size-s);\n  --zw-avatar-font: var(--zw-typography-text-xs-semibold);\n}\n\n:host([size="m"]) {\n  --zw-avatar-size: var(--zw-avatar-size-m);\n  --zw-avatar-font: var(--zw-typography-text-s-semibold);\n}\n\n:host([size="l"]) {\n  --zw-avatar-size: var(--zw-avatar-size-l);\n  --zw-avatar-font: var(--zw-typography-text-m-semibold);\n}\n\n:host([size="xl"]) {\n  --zw-avatar-size: var(--zw-avatar-size-xl);\n  --zw-avatar-font: var(--zw-typography-text-m-semibold);\n}\n\n:host([color="primary"]) {\n  --zw-avatar-color-text: var(--zw-color-on-primary-container);\n  --zw-avatar-color-container: var(--zw-color-primary-container);\n  --zw-avatar-color-container-hover: var(--zw-color-states-primary-container-hover);\n  --zw-avatar-color-container-active: var(--zw-color-states-primary-container-focus-press);\n}\n\n:host([color="secondary"]) {\n  --zw-avatar-color-text: var(--zw-color-on-secondary-container);\n  --zw-avatar-color-container: var(--zw-color-secondary-container);\n  --zw-avatar-color-container-hover: var(--zw-color-states-secondary-container-hover);\n  --zw-avatar-color-container-active: var(--zw-color-states-secondary-container-focus-press);\n}\n\n:host([color="tertiary"]) {\n  --zw-avatar-color-text: var(--zw-color-on-tertiary-container);\n  --zw-avatar-color-container: var(--zw-color-tertiary-container);\n  --zw-avatar-color-container-hover: var(--zw-color-states-tertiary-container-hover);\n  --zw-avatar-color-container-active: var(--zw-color-states-tertiary-container-focus-press);\n}\n\n:host([color="success"]) {\n  --zw-avatar-color-text: var(--zw-color-on-success-container);\n  --zw-avatar-color-container: var(--zw-color-success-container);\n  --zw-avatar-color-container-hover: var(--zw-color-states-success-container-hover);\n  --zw-avatar-color-container-active: var(--zw-color-states-success-container-focus-press);\n}\n\n:host([color="error"]) {\n  --zw-avatar-color-text: var(--zw-color-on-error-container);\n  --zw-avatar-color-container: var(--zw-color-error-container);\n  --zw-avatar-color-container-hover: var(--zw-color-states-error-container-hover);\n  --zw-avatar-color-container-active: var(--zw-color-states-error-container-focus-press);\n}\n\n:host([color="warning"]) {\n  --zw-avatar-color-text: var(--zw-color-on-warning-container);\n  --zw-avatar-color-container: var(--zw-color-warning-container);\n  --zw-avatar-color-container-hover: var(--zw-color-states-warning-container-hover);\n  --zw-avatar-color-container-active: var(--zw-color-states-warning-container-focus-press);\n}\n\n.zw-avatar {\n  display: flex;\n  overflow: hidden;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  inline-size: var(--zw-avatar-size);\n  aspect-ratio: 1;\n  border-radius: var(--zw-border-radius-1000);\n  font: var(--zw-avatar-font);\n  color: var(--zw-avatar-color-text);\n  background-color: var(--zw-avatar-color-container);\n}\n\n.zw-avatar[data-interactive][data-image]::after {\n      content: "";\n      position: absolute;\n      inset: 0;\n      inline-size: 100%;\n      block-size: 100%;\n      border-radius: var(--zw-border-radius-1000);\n      background-color: transparent;\n    }\n\n.zw-avatar[data-interactive]:focus-visible {\n      border: 2px solid var(--zw-color-on-surface);\n    }\n\n.zw-avatar[data-interactive]:hover {\n      background-color: var(--zw-avatar-color-container-hover);\n    }\n\n.zw-avatar[data-interactive][data-image]:hover::after {\n        background-color: var(--zw-color-transparent-transparent-on-surface-6);\n      }\n\n.zw-avatar[data-interactive]:active {\n      background-color: var(--zw-avatar-color-container-active);\n    }\n\n.zw-avatar[data-interactive][data-image]:active::after {\n        background-color: var(--zw-color-transparent-transparent-on-surface-8);\n      }\n\n.zw-avatar:disabled {\n    color: var(--zw-color-on-surface-variant);\n    background-color: var(--zw-color-surface-container-highest);\n  }\n\n.zw-avatar[data-image]:disabled {\n      opacity: 0.3;\n    }\n\n.zw-avatar img {\n    aspect-ratio: 1;\n    -o-object-fit: cover;\n       object-fit: cover;\n  }\n';
var __defProp$J = Object.defineProperty;
var __decorateClass$J = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$J(target, key, result);
  return result;
};
const _Avatar = class _Avatar extends h {
  constructor() {
    super(...arguments);
    this.interactive = false;
    this.size = "m";
    this.disabled = false;
  }
  render() {
    return ke$1`${this.avatarHTML()}`;
  }
  avatarHTML() {
    if (this.interactive)
      return ke$1`<button
        class="zw-avatar"
        type="button"
        ?data-image=${this.imageFile}
        ?data-interactive=${!this.disabled}
        ?disabled=${this.disabled}
      >
        ${this.avatarContentHtml()}
      </button>`;
    return ke$1`<span class="zw-avatar">${this.avatarContentHtml()}</span>`;
  }
  avatarContentHtml() {
    if (this.imageFile) return ke$1`<img src=${this.imageFile} alt=${this.imageAltText} />`;
    return ke$1`<slot></slot>`;
  }
};
_Avatar.styles = [r$3(baseStyles), r$3(styles$M)];
_Avatar.shadowRootOptions = { ...h.shadowRootOptions, delegatesFocus: true };
let Avatar = _Avatar;
__decorateClass$J([
  n$1({ reflect: true, attribute: "image-file" })
], Avatar.prototype, "imageFile");
__decorateClass$J([
  n$1({ reflect: true, attribute: "image-alt-text" })
], Avatar.prototype, "imageAltText");
__decorateClass$J([
  n$1({ type: Boolean, reflect: true })
], Avatar.prototype, "interactive");
__decorateClass$J([
  n$1({ reflect: true })
], Avatar.prototype, "color");
__decorateClass$J([
  n$1({ reflect: true })
], Avatar.prototype, "size");
__decorateClass$J([
  n$1({ type: Boolean, reflect: true })
], Avatar.prototype, "disabled");
const styles$L = ':host {\n  display: contents;\n}\n\n:host([color="primary"]) {\n  --zw-badge-color: var(--zw-color-on-primary);\n  --zw-badge-background-color: var(--zw-color-primary);\n}\n\n:host([color="secondary"]) {\n  --zw-badge-color: var(--zw-color-on-secondary);\n  --zw-badge-background-color: var(--zw-color-secondary);\n}\n\n:host([color="tertiary"]) {\n  --zw-badge-color: var(--zw-color-on-tertiary);\n  --zw-badge-background-color: var(--zw-color-tertiary);\n}\n\n:host([color="error"]) {\n  --zw-badge-color: var(--zw-color-on-error);\n  --zw-badge-background-color: var(--zw-color-error);\n}\n\n:host([color="warning"]) {\n  --zw-badge-color: var(--zw-color-on-warning);\n  --zw-badge-background-color: var(--zw-color-warning);\n}\n\n:host([color="success"]) {\n  --zw-badge-color: var(--zw-color-on-success);\n  --zw-badge-background-color: var(--zw-color-success);\n}\n\n:host([color="info"]) {\n  --zw-badge-color: var(--zw-color-on-info);\n  --zw-badge-background-color: var(--zw-color-info);\n}\n\n:host([color="neutral"]) {\n  --zw-badge-color: var(--zw-color-on-surface);\n  --zw-badge-background-color: var(--zw-color-surface-container-lowest);\n}\n\n:host([color="disabled"]) {\n  --zw-badge-color: var(--zw-color-on-surface-variant);\n  --zw-badge-background-color: var(--zw-color-surface-container-highest);\n}\n\n:host([size="s"]) {\n  --zw-badge-size: var(--zw-icon-size-s);\n  --zw-badge-typography: var(--zw-typography-text-xs-semibold);\n  --zw-badge-padding-inline: var(--zw-spacing-2);\n}\n\n:host([size="m"]) {\n  --zw-badge-size: var(--zw-icon-size-m);\n  --zw-badge-typography: var(--zw-typography-text-s-semibold);\n  --zw-badge-padding-inline: var(--zw-spacing-4);\n}\n\n:host([size="l"]) {\n  --zw-badge-size: var(--zw-icon-size-l);\n  --zw-badge-typography: var(--zw-typography-text-m-semibold);\n  --zw-badge-padding-inline: var(--zw-spacing-4);\n}\n\n.zw-badge {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  min-inline-size: var(--zw-badge-size);\n  block-size: var(--zw-badge-size);\n  border-radius: var(--zw-border-radius-1000);\n  padding-inline: var(--zw-badge-padding-inline);\n  font: var(--zw-badge-typography);\n  font-feature-settings: "tnum";\n  font-variant-numeric: tabular-nums;\n  color: var(--zw-badge-color);\n  background-color: var(--zw-badge-background-color);\n}\n';
var __defProp$I = Object.defineProperty;
var __decorateClass$I = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$I(target, key, result);
  return result;
};
const badgeContent = (number) => number < 100 ? number : "99+";
const _Badge = class _Badge extends h {
  constructor() {
    super(...arguments);
    this.size = "m";
  }
  render() {
    return ke$1` <span class="zw-badge"> ${badgeContent(this.number)} </span> `;
  }
};
_Badge.styles = [r$3(baseStyles), r$3(styles$L)];
let Badge = _Badge;
__decorateClass$I([
  n$1({ reflect: true })
], Badge.prototype, "color");
__decorateClass$I([
  n$1({ reflect: true })
], Badge.prototype, "size");
__decorateClass$I([
  n$1({ type: Number, reflect: true })
], Badge.prototype, "number");
const styles$K = ':host {\n  display: contents;\n}\n\n.zw-breadcrumb-item {\n  --breadcrumb-line-height: 1;\n\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2);\n  line-height: var(--breadcrumb-line-height);\n  color: var(--zw-color-on-surface-variant);\n}\n\n.zw-breadcrumb-item[data-size="xs"] {\n    font: var(--zw-typography-text-xs-regular);\n  }\n\n.zw-breadcrumb-item[data-size="s"] {\n    font: var(--zw-typography-text-s-regular);\n  }\n\n.zw-breadcrumb-item[data-size="m"] {\n    font: var(--zw-typography-text-m-regular);\n  }\n\n.zw-breadcrumb-item--link:focus,.zw-breadcrumb-item--link:focus-visible,.zw-breadcrumb-item--link:hover,.zw-breadcrumb-item--link:active {\n    -webkit-text-decoration: none;\n    text-decoration: none;\n  }\n\n.zw-breadcrumb-item--link:focus-visible,.zw-breadcrumb-item--link:hover {\n    box-shadow: 0 1px 0 0 var(--zw-color-states-on-surface-hover);\n    color: var(--zw-color-states-on-surface-hover);\n  }\n\n.zw-breadcrumb-item--link:active {\n    box-shadow: 0 1px 0 0 var(--zw-color-states-on-surface-focus-press);\n    color: var(--zw-color-states-on-surface-focus-press);\n  }\n\n.zw-breadcrumb-item--current {\n  color: var(--zw-color-on-surface);\n}\n';
var __defProp$H = Object.defineProperty;
var __decorateClass$H = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$H(target, key, result);
  return result;
};
const _BreadcrumbItem = class _BreadcrumbItem extends h {
  constructor() {
    super();
    this.icon = "";
    this.link = "";
    this.size = "xs";
    this.isCurrent = false;
    defineCustomElementOnce("zw-icon", Icon);
  }
  itemHtml() {
    if (this.isCurrent) {
      return ke$1`<span class="zw-breadcrumb-item--current" aria-label=${this.iconAriaLabel}
        >${this.textOrIconHtml()}</span
      >`;
    }
    return ke$1`
      <a class="zw-breadcrumb-item--link" href="${this.link}" aria-label=${this.iconAriaLabel}
        >${this.textOrIconHtml()}</a
      >
      <zw-icon name="chevron_right" size=${this.size} aria-hidden="true"></zw-icon>
    `;
  }
  get iconAriaLabel() {
    if (this.icon) return this.text;
    return D;
  }
  textOrIconHtml() {
    if (!this.icon) return this.text;
    return ke$1`<zw-icon
      name="${this.icon}"
      size=${this.size}
      variant="outlined"
      aria-hidden="true"
    ></zw-icon>`;
  }
  render() {
    return ke$1`<div
      role="listitem"
      aria-current=${this.isCurrent ? "page" : D}
      class="zw-breadcrumb-item"
      data-size=${this.size}
    >
      ${this.itemHtml()}
    </div>`;
  }
};
_BreadcrumbItem.styles = [r$3(baseStyles), r$3(styles$K)];
let BreadcrumbItem = _BreadcrumbItem;
__decorateClass$H([
  n$1({ reflect: true })
], BreadcrumbItem.prototype, "text");
__decorateClass$H([
  n$1({ reflect: true })
], BreadcrumbItem.prototype, "icon");
__decorateClass$H([
  n$1({ reflect: true })
], BreadcrumbItem.prototype, "link");
__decorateClass$H([
  n$1({ reflect: true })
], BreadcrumbItem.prototype, "size");
__decorateClass$H([
  n$1({ reflect: true, type: Boolean, attribute: "is-current" })
], BreadcrumbItem.prototype, "isCurrent");
const styles$J = ".zw-breadcrumbs--list {\n  display: inline-flex;\n  align-items: stretch;\n  gap: var(--zw-spacing-2);\n  margin: 0;\n  padding: 0;\n}\n";
var __defProp$G = Object.defineProperty;
var __decorateClass$G = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$G(target, key, result);
  return result;
};
const _Breadcrumbs = class _Breadcrumbs extends h {
  constructor() {
    super(...arguments);
    this.size = "xs";
  }
  getAssignedItems() {
    return Array.from(this.getElementsByTagName("zw-breadcrumb-item"));
  }
  handleSlotChange() {
    var _a2;
    const items = this.getAssignedItems();
    items.slice(0, -1).forEach((item) => {
      item.removeAttribute("is-current");
    });
    (_a2 = items.at(-1)) == null ? void 0 : _a2.setAttribute("is-current", "");
  }
  update(changedProperties) {
    this.getAssignedItems().forEach((item) => {
      item.setAttribute("size", this.size);
    });
    super.update(changedProperties);
  }
  render() {
    return ke$1`
      <nav class="zw-breadcrumbs" aria-label=${this.ariaLabel || D}>
        <div role="list" class="zw-breadcrumbs--list">
          <slot @slotchange=${this.handleSlotChange}></slot>
        </div>
      </nav>
    `;
  }
};
_Breadcrumbs.styles = [r$3(baseStyles), r$3(styles$J)];
let Breadcrumbs = _Breadcrumbs;
__decorateClass$G([
  n$1({ reflect: true, attribute: "aria-label" })
], Breadcrumbs.prototype, "ariaLabel");
__decorateClass$G([
  n$1({ reflect: true })
], Breadcrumbs.prototype, "size");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const rt = (o2) => void 0 === o2.strings;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t = { ATTRIBUTE: 1, CHILD: 2 }, e$1 = (t2) => (...e2) => ({ _$litDirective$: t2, values: e2 });
let i$1 = class i {
  constructor(t2) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(t2, e2, i3) {
    this.t = t2, this._$AM = e2, this.i = i3;
  }
  _$AS(t2, e2) {
    return this.update(t2, e2);
  }
  update(t2, e2) {
    return this.render(...e2);
  }
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const mt = (i3, t2) => {
  var _a2;
  const e2 = i3._$AN;
  if (void 0 === e2) return false;
  for (const i4 of e2) (_a2 = i4._$AO) == null ? void 0 : _a2.call(i4, t2, false), mt(i4, t2);
  return true;
}, _t = (i3) => {
  let t2, e2;
  do {
    if (void 0 === (t2 = i3._$AM)) break;
    e2 = t2._$AN, e2.delete(i3), i3 = t2;
  } while (0 === (e2 == null ? void 0 : e2.size));
}, wt = (i3) => {
  for (let t2; t2 = i3._$AM; i3 = t2) {
    let e2 = t2._$AN;
    if (void 0 === e2) t2._$AN = e2 = /* @__PURE__ */ new Set();
    else if (e2.has(i3)) break;
    e2.add(i3), gt(t2);
  }
};
function bt(i3) {
  void 0 !== this._$AN ? (_t(this), this._$AM = i3, wt(this)) : this._$AM = i3;
}
function yt(i3, t2 = false, e2 = 0) {
  const s4 = this._$AH, o2 = this._$AN;
  if (void 0 !== o2 && 0 !== o2.size) if (t2) if (Array.isArray(s4)) for (let i4 = e2; i4 < s4.length; i4++) mt(s4[i4], false), _t(s4[i4]);
  else null != s4 && (mt(s4, false), _t(s4));
  else mt(this, i3);
}
const gt = (i3) => {
  i3.type == t.CHILD && (i3._$AP ?? (i3._$AP = yt), i3._$AQ ?? (i3._$AQ = bt));
};
class $t extends i$1 {
  constructor() {
    super(...arguments), this._$AN = void 0;
  }
  _$AT(i3, t2, e2) {
    super._$AT(i3, t2, e2), wt(this), this.isConnected = i3._$AU;
  }
  _$AO(i3, t2 = true) {
    var _a2, _b;
    i3 !== this.isConnected && (this.isConnected = i3, i3 ? (_a2 = this.reconnected) == null ? void 0 : _a2.call(this) : (_b = this.disconnected) == null ? void 0 : _b.call(this)), t2 && (mt(this, i3), _t(this));
  }
  setValue(i3) {
    if (rt(this.t)) this.t._$AI(i3, this);
    else {
      const t2 = [...this.t._$AH];
      t2[this.i] = i3, this.t._$AI(t2, this, 0);
    }
  }
  disconnected() {
  }
  reconnected() {
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const ii = () => new Zt();
class Zt {
}
const qt = /* @__PURE__ */ new WeakMap(), Kt = e$1(class extends $t {
  render(t2) {
    return D;
  }
  update(t2, [i3]) {
    var _a2;
    const s4 = i3 !== this.Y;
    return s4 && void 0 !== this.Y && this.rt(void 0), (s4 || this.lt !== this.ct) && (this.Y = i3, this.ht = (_a2 = t2.options) == null ? void 0 : _a2.host, this.rt(this.ct = t2.element)), D;
  }
  rt(t2) {
    if (this.isConnected || (t2 = void 0), "function" == typeof this.Y) {
      const i3 = this.ht ?? globalThis;
      let s4 = qt.get(i3);
      void 0 === s4 && (s4 = /* @__PURE__ */ new WeakMap(), qt.set(i3, s4)), void 0 !== s4.get(this.Y) && this.Y.call(this.ht, void 0), s4.set(this.Y, t2), void 0 !== t2 && this.Y.call(this.ht, t2);
    } else this.Y.value = t2;
  }
  get lt() {
    var _a2, _b;
    return "function" == typeof this.Y ? (_a2 = qt.get(this.ht ?? globalThis)) == null ? void 0 : _a2.get(this.Y) : (_b = this.Y) == null ? void 0 : _b.value;
  }
  disconnected() {
    this.lt === this.ct && this.rt(void 0);
  }
  reconnected() {
    this.rt(this.ct);
  }
});
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const to = (t2) => t2 ?? D;
var __defProp$F = Object.defineProperty;
var __decorateClass$F = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$F(target, key, result);
  return result;
};
const _BaseButton = class _BaseButton extends h {
  constructor() {
    super(...arguments);
    this.internals = this.attachInternals();
    this.type = "button";
    this.buttonRef = ii();
    this.disabled = false;
  }
  handleClick() {
    if (this.type === "submit" && this.internals.form) {
      const { form } = this.internals;
      const button = this.buttonRef.value;
      this.appendChild(button);
      form.requestSubmit(button);
      this.shadowRoot.appendChild(button);
      if (form.checkValidity()) this.focus();
    }
  }
};
_BaseButton.formAssociated = true;
_BaseButton.shadowRootOptions = { ...h.shadowRootOptions, delegatesFocus: true };
let BaseButton = _BaseButton;
__decorateClass$F([
  n$1({})
], BaseButton.prototype, "type");
__decorateClass$F([
  n$1({ reflect: true, type: Boolean })
], BaseButton.prototype, "disabled");
__decorateClass$F([
  n$1({ reflect: true })
], BaseButton.prototype, "name");
__decorateClass$F([
  n$1({ reflect: true })
], BaseButton.prototype, "value");
const styles$I = ':host {\n  --zw-button-color-disabled: var(--zw-color-surface-container);\n  --zw-button-color-outline: transparent;\n  --zw-button-size: auto;\n\n  display: inline-block;\n}\n\n:host([stretched]) {\n  --zw-button-size: 100%;\n\n  display: block;\n}\n\n:host([size="xs"]) {\n  --zw-button-gap: var(--zw-spacing-4);\n  --zw-button-padding-block: var(--zw-spacing-4);\n  --zw-button-padding-inline: var(--zw-spacing-8);\n  --zw-button-font: var(--zw-typography-button-xs-medium);\n}\n\n:host([size="s"]) {\n  --zw-button-gap: var(--zw-spacing-4);\n  --zw-button-padding-block: var(--zw-spacing-8);\n  --zw-button-padding-inline: var(--zw-spacing-12);\n  --zw-button-font: var(--zw-typography-button-s-medium);\n}\n\n:host([size="m"]) {\n  --zw-button-gap: var(--zw-spacing-8);\n  --zw-button-padding-block: var(--zw-spacing-12);\n  --zw-button-padding-inline: var(--zw-spacing-16);\n  --zw-button-font: var(--zw-typography-button-m-medium);\n}\n\n:host([size="l"]) {\n  --zw-button-gap: var(--zw-spacing-12);\n  --zw-button-padding-block: var(--zw-spacing-16);\n  --zw-button-padding-inline: var(--zw-spacing-24);\n  --zw-button-font: var(--zw-typography-button-l-medium);\n}\n\n:host([icon-only]) {\n  --zw-button-gap: 0;\n  --zw-button-padding-inline: var(--zw-button-padding-block);\n}\n\n:host([color="primary"]) {\n  --zw-button-color-on-type: var(--zw-color-on-primary);\n  --zw-button-color-on-type-container: var(--zw-color-on-primary-container);\n  --zw-button-color-type: var(--zw-color-primary);\n  --zw-button-color-type-hover: var(--zw-color-states-primary-hover);\n  --zw-button-color-type-focus-press: var(--zw-color-states-primary-focus-press);\n  --zw-button-color-type-container: var(--zw-color-primary-container);\n  --zw-button-color-type-container-hover: var(--zw-color-states-primary-container-hover);\n  --zw-button-color-type-container-focus-press: var(\n    --zw-color-states-primary-container-focus-press\n  );\n}\n\n:host([color="secondary"]) {\n  --zw-button-color-on-type: var(--zw-color-on-secondary);\n  --zw-button-color-on-type-container: var(--zw-color-on-secondary-container);\n  --zw-button-color-type: var(--zw-color-secondary);\n  --zw-button-color-type-hover: var(--zw-color-states-secondary-hover);\n  --zw-button-color-type-focus-press: var(--zw-color-states-secondary-focus-press);\n  --zw-button-color-type-container: var(--zw-color-secondary-container);\n  --zw-button-color-type-container-hover: var(--zw-color-states-secondary-container-hover);\n  --zw-button-color-type-container-focus-press: var(\n    --zw-color-states-secondary-container-focus-press\n  );\n}\n\n:host([color="tertiary"]) {\n  --zw-button-color-on-type: var(--zw-color-on-tertiary);\n  --zw-button-color-on-type-container: var(--zw-color-on-tertiary-container);\n  --zw-button-color-type: var(--zw-color-tertiary);\n  --zw-button-color-type-hover: var(--zw-color-states-tertiary-hover);\n  --zw-button-color-type-focus-press: var(--zw-color-states-tertiary-focus-press);\n  --zw-button-color-type-container: var(--zw-color-tertiary-container);\n  --zw-button-color-type-container-hover: var(--zw-color-states-tertiary-container-hover);\n  --zw-button-color-type-container-focus-press: var(\n    --zw-color-states-tertiary-container-focus-press\n  );\n}\n\n:host([color="error"]) {\n  --zw-button-color-on-type: var(--zw-color-on-error);\n  --zw-button-color-on-type-container: var(--zw-color-on-error-container);\n  --zw-button-color-type: var(--zw-color-error);\n  --zw-button-color-type-hover: var(--zw-color-states-error-hover);\n  --zw-button-color-type-focus-press: var(--zw-color-states-error-focus-press);\n  --zw-button-color-type-container: var(--zw-color-error-container);\n  --zw-button-color-type-container-hover: var(--zw-color-states-error-container-hover);\n  --zw-button-color-type-container-focus-press: var(--zw-color-states-error-container-focus-press);\n}\n\n:host([color="warning"]) {\n  --zw-button-color-on-type: var(--zw-color-on-warning);\n  --zw-button-color-on-type-container: var(--zw-color-on-warning-container);\n  --zw-button-color-type: var(--zw-color-warning);\n  --zw-button-color-type-hover: var(--zw-color-states-warning-hover);\n  --zw-button-color-type-focus-press: var(--zw-color-states-warning-focus-press);\n  --zw-button-color-type-container: var(--zw-color-warning-container);\n  --zw-button-color-type-container-hover: var(--zw-color-states-warning-container-hover);\n  --zw-button-color-type-container-focus-press: var(\n    --zw-color-states-warning-container-focus-press\n  );\n}\n\n:host([color="info"]) {\n  --zw-button-color-on-type: var(--zw-color-on-info);\n  --zw-button-color-on-type-container: var(--zw-color-on-info-container);\n  --zw-button-color-type: var(--zw-color-info);\n  --zw-button-color-type-hover: var(--zw-color-states-info-hover);\n  --zw-button-color-type-focus-press: var(--zw-color-states-info-focus-press);\n  --zw-button-color-type-container: var(--zw-color-info-container);\n  --zw-button-color-type-container-hover: var(--zw-color-states-info-container-hover);\n  --zw-button-color-type-container-focus-press: var(--zw-color-states-info-container-focus-press);\n}\n\n:host([color="success"]) {\n  --zw-button-color-on-type: var(--zw-color-on-success);\n  --zw-button-color-on-type-container: var(--zw-color-on-success-container);\n  --zw-button-color-type: var(--zw-color-success);\n  --zw-button-color-type-hover: var(--zw-color-states-success-hover);\n  --zw-button-color-type-focus-press: var(--zw-color-states-success-focus-press);\n  --zw-button-color-type-container: var(--zw-color-success-container);\n  --zw-button-color-type-container-hover: var(--zw-color-states-success-container-hover);\n  --zw-button-color-type-container-focus-press: var(\n    --zw-color-states-success-container-focus-press\n  );\n}\n\n:host([color="neutral"]) {\n  --zw-button-color-on-type: var(--zw-color-inverse-on-surface);\n  --zw-button-color-on-type-container: var(--zw-color-inverse-on-surface);\n  --zw-button-color-type: var(--zw-color-on-surface);\n  --zw-button-color-type-hover: var(--zw-color-states-on-surface-focus-press);\n  --zw-button-color-type-focus-press: var(--zw-color-states-on-surface-focus-press);\n  --zw-button-color-type-container: var(--zw-color-on-surface);\n}\n\n:host([color="neutral-inverse"]) {\n  --zw-button-color-on-type: var(--zw-color-on-surface);\n  --zw-button-color-on-type-container: var(--zw-color-on-surface);\n  --zw-button-color-type: var(--zw-color-inverse-on-surface);\n  --zw-button-color-type-hover: var(--zw-color-states-inverse-on-surface-hover);\n  --zw-button-color-type-focus-press: var(--zw-color-states-inverse-on-surface-focus-press);\n  --zw-button-color-type-container: var(--zw-color-inverse-on-surface);\n  --zw-button-color-type-container-hover: var(--zw-color-states-inverse-on-surface-hover);\n  --zw-button-color-type-container-focus-press: var(\n    --zw-color-states-inverse-on-surface-focus-press\n  );\n}\n\n:host([variant="filled"]) {\n  --zw-button-color-text: var(--zw-button-color-on-type);\n  --zw-button-color-text-hover: var(--zw-button-color-on-type);\n  --zw-button-color-text-focus-press: var(--zw-button-color-on-type);\n  --zw-button-color-container: var(--zw-button-color-type);\n  --zw-button-color-container-hover: var(--zw-button-color-type-hover);\n  --zw-button-color-container-focus-press: var(--zw-button-color-type-focus-press);\n}\n\n:host([variant="outline"]) {\n  --zw-button-color-text: var(--zw-button-color-type);\n  --zw-button-color-text-hover: var(--zw-button-color-on-type);\n  --zw-button-color-text-focus-press: var(--zw-button-color-on-type);\n  --zw-button-color-container-hover: var(--zw-button-color-type-hover);\n  --zw-button-color-container-focus-press: var(--zw-button-color-type-focus-press);\n  --zw-button-color-outline: var(--zw-button-color-type);\n}\n\n:host([variant="ghost"]) {\n  --zw-button-color-text: var(--zw-button-color-type);\n  --zw-button-color-text-hover: var(--zw-button-color-on-type-container);\n  --zw-button-color-text-focus-press: var(--zw-button-color-on-type-container);\n  --zw-button-color-container-hover: var(--zw-button-color-type-container-hover);\n  --zw-button-color-container-focus-press: var(--zw-button-color-type-container-focus-press);\n}\n\n:host([variant="tonal"]) {\n  --zw-button-color-text: var(--zw-button-color-on-type-container);\n  --zw-button-color-text-hover: var(--zw-button-color-on-type-container);\n  --zw-button-color-text-focus-press: var(--zw-button-color-on-type-container);\n  --zw-button-color-container: var(--zw-button-color-type-container);\n  --zw-button-color-container-hover: var(--zw-button-color-type-container-hover);\n  --zw-button-color-container-focus-press: var(--zw-button-color-type-container-focus-press);\n}\n\n:host([variant="icon-only"]) {\n  --zw-button-color-text: var(--zw-button-color-type);\n  --zw-button-color-text-hover: var(--zw-button-color-on-type-container);\n  --zw-button-color-text-focus-press: var(--zw-button-color-on-type-container);\n  --zw-button-color-disabled: transparent;\n  --zw-button-padding-block: 0;\n  --zw-button-padding-inline: 0;\n}\n\n/* The following variants have to be handled as exceptions due to deviating neutral and neutral-inverse styles */\n:host([color="neutral"][variant="ghost"]) {\n  --zw-button-color-text-hover: var(--zw-color-inverse-on-surface);\n  --zw-button-color-container-hover: var(--zw-color-states-on-surface-hover);\n  --zw-button-color-container-focus-press: var(--zw-color-states-on-surface-focus-press);\n}\n\n:host([color="neutral"][variant="tonal"]) {\n  --zw-button-color-text-hover: var(--zw-color-inverse-on-surface);\n  --zw-button-color-container-hover: var(--zw-color-states-on-surface-hover);\n  --zw-button-color-container-focus-press: var(--zw-color-states-on-surface-focus-press);\n}\n\n:host([color="neutral"][variant="icon-only"]) {\n  --zw-button-color-text-hover: var(--zw-color-states-on-surface-hover);\n  --zw-button-color-text-focus-press: var(--zw-color-states-on-surface-focus-press);\n}\n\n:host([color="neutral-inverse"][variant="icon-only"]) {\n  --zw-button-color-text-hover: var(--zw-color-states-inverse-on-surface-hover);\n  --zw-button-color-text-focus-press: var(--zw-color-states-inverse-on-surface-focus-press);\n}\n\n.zw-button {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--zw-button-gap);\n  inline-size: var(--zw-button-size);\n  border: 2px solid transparent;\n  border-radius: var(--zw-border-radius-1000);\n  padding-block: var(--zw-button-padding-block);\n  padding-inline: var(--zw-button-padding-inline);\n  font: var(--zw-button-font);\n  color: var(--zw-button-color-text);\n  background-color: var(--zw-button-color-container);\n  align-content: center;\n  justify-content: center;\n  place-content: center;\n}\n\n.zw-button:focus,.zw-button:hover,.zw-button:active {\n    -webkit-text-decoration: none;\n    text-decoration: none;\n  }\n\n.zw-button:focus-visible {\n    border: 2px solid var(--zw-color-on-surface);\n    color: var(--zw-button-color-text-focus-press);\n    background-color: var(--zw-button-color-container-focus-press);\n  }\n\n.zw-button:hover {\n    color: var(--zw-button-color-text-hover);\n    background-color: var(--zw-button-color-container-hover);\n  }\n\n.zw-button:active {\n    color: var(--zw-button-color-text-focus-press);\n    background-color: var(--zw-button-color-container-focus-press);\n  }\n\n.zw-button:not(:focus-visible):not(:hover):not(:active):not(:disabled) {\n    outline: 1px solid var(--zw-button-color-outline);\n    outline-offset: -2px;\n  }\n\n.zw-button:disabled {\n    color: var(--zw-color-on-surface-variant);\n    background-color: var(--zw-button-color-disabled);\n  }\n';
var __defProp$E = Object.defineProperty;
var __decorateClass$E = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$E(target, key, result);
  return result;
};
const _Button = class _Button extends BaseButton {
  constructor() {
    super();
    this.variant = "filled";
    this.color = "primary";
    this.size = "m";
    this.stretched = false;
    this.iconOnly = false;
    defineCustomElementOnce("zw-icon", Icon);
  }
  render() {
    if (this.href) {
      return this.linkHTML();
    }
    return this.buttonHTML();
  }
  buttonHTML() {
    return ke$1`<button
      name=${to(this.name)}
      value=${to(this.value)}
      class="zw-button"
      part="base"
      ?disabled=${this.disabled}
      type=${this.type}
      aria-label=${to(this.ariaLabel)}
      @click=${this.handleClick}
      ${Kt(this.buttonRef)}
    >
      <slot></slot>
    </button>`;
  }
  linkHTML() {
    return ke$1`<a
      class="zw-button"
      part="base"
      aria-label=${to(this.ariaLabel)}
      href=${to(this.href)}
      target=${to(this.target)}
      rel=${to(this.rel)}
      download=${to(this.download)}
    >
      <slot></slot>
    </a>`;
  }
};
_Button.styles = [r$3(baseStyles), r$3(styles$I)];
let Button = _Button;
__decorateClass$E([
  n$1({ reflect: true })
], Button.prototype, "variant");
__decorateClass$E([
  n$1({ reflect: true })
], Button.prototype, "color");
__decorateClass$E([
  n$1({ reflect: true })
], Button.prototype, "href");
__decorateClass$E([
  n$1({ reflect: true })
], Button.prototype, "target");
__decorateClass$E([
  n$1({ reflect: true })
], Button.prototype, "rel");
__decorateClass$E([
  n$1({ reflect: true })
], Button.prototype, "download");
__decorateClass$E([
  n$1({ reflect: true })
], Button.prototype, "size");
__decorateClass$E([
  n$1({ reflect: true, type: Boolean })
], Button.prototype, "stretched");
__decorateClass$E([
  n$1({ reflect: true, type: Boolean })
], Button.prototype, "iconOnly");
const styles$H = ':host {\n  --zw-card-inline-size: 360px;\n\n  display: block;\n}\n\n.zw-card {\n  display: block;\n  overflow: hidden;\n  inline-size: var(--zw-card-inline-size);\n  border: 1px solid var(--zw-color-outline-variant-low);\n  border-radius: var(--zw-border-radius-12);\n  box-shadow: var(--zw-elevation-bottom-s);\n  background-color: var(--zw-color-surface-container-lowest);\n}\n\n.zw-card:focus,.zw-card:hover,.zw-card:active {\n    -webkit-text-decoration: none;\n    text-decoration: none;\n  }\n\n.zw-card[data-interactive]:focus-visible {\n      border: 2px solid var(--zw-color-on-surface);\n      background-color: var(--zw-color-surface-container);\n    }\n\n.zw-card[data-interactive]:hover {\n      box-shadow: var(--zw-elevation-bottom-m);\n      background-color: var(--zw-color-surface-container-low);\n    }\n\n.zw-card[data-interactive]:active {\n      box-shadow: var(--zw-elevation-bottom-l);\n      background-color: var(--zw-color-surface-container);\n    }\n\n.zw-card[data-interactive]:disabled,.zw-card[data-interactive][aria-disabled] {\n      box-shadow: var(--zw-elevation-bottom-s);\n      color: var(--zw-color-on-surface-variant);\n      background-color: var(--zw-color-surface-container-lowest);\n    }\n\n::slotted([slot="header"]) {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--zw-spacing-16);\n  font: var(--zw-typography-text-m-semibold);\n}\n\n::slotted([slot="text-content"]) {\n  padding: var(--zw-spacing-16);\n  text-align: start;\n}\n';
var __defProp$D = Object.defineProperty;
var __decorateClass$D = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$D(target, key, result);
  return result;
};
const _Card = class _Card extends h {
  constructor() {
    super(...arguments);
    this.interactive = false;
    this.disabled = false;
  }
  render() {
    if (this.interactive && this.href) return this.linkHTML();
    if (this.interactive) return this.buttonHTML();
    return ke$1`<div class="zw-card">${this.innerComponentHTML()}</div>`;
  }
  innerComponentHTML() {
    return ke$1`<slot name="header"></slot><slot name="media"></slot
      ><slot name="text-content"></slot>`;
  }
  linkHTML() {
    return ke$1`<a
      class="zw-card"
      aria-label=${to(this.ariaLabel)}
      href=${this.disabled ? D : this.href}
      ?aria-disabled=${this.disabled}
      data-interactive
    >
      ${this.innerComponentHTML()}
    </a>`;
  }
  buttonHTML() {
    return ke$1`<button
      class="zw-card"
      type="button"
      aria-label=${to(this.ariaLabel)}
      ?disabled=${this.disabled}
      data-interactive
    >
      ${this.innerComponentHTML()}
    </button>`;
  }
};
_Card.styles = [r$3(baseStyles), r$3(styles$H)];
_Card.shadowRootOptions = { ...h.shadowRootOptions, delegatesFocus: true };
let Card = _Card;
__decorateClass$D([
  n$1({ type: Boolean, reflect: true })
], Card.prototype, "interactive");
__decorateClass$D([
  n$1({ type: Boolean, reflect: true })
], Card.prototype, "disabled");
__decorateClass$D([
  n$1({ reflect: true })
], Card.prototype, "href");
let idCount = 0;
const getUniqueId = (prefix) => {
  idCount += 1;
  return `${prefix}-${idCount}`;
};
const hasSlotContent = (element, slotName) => element.querySelector(`[slot=${slotName}]`);
const styles$G = ".zw-hint {\n  margin-block-start: var(--zw-spacing-8);\n  font: var(--zw-typography-text-s-regular);\n  color: var(--zw-color-on-surface-variant);\n}\n";
var __defProp$C = Object.defineProperty;
var __decorateClass$C = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$C(target, key, result);
  return result;
};
const HintMixin = (superClass) => {
  const _HintMixinClass = class _HintMixinClass extends superClass {
    hintHTML({ showErrorMessage }) {
      if (showErrorMessage) return null;
      if (!this.hint && !hasSlotContent(this, "hint")) return null;
      return ke$1`
        <div class="zw-hint">
          <slot name="hint">${to(this.hint)}</slot>
        </div>
      `;
    }
  };
  _HintMixinClass.styles = [r$3(styles$G)];
  let HintMixinClass = _HintMixinClass;
  __decorateClass$C([
    n$1({ reflect: true })
  ], HintMixinClass.prototype, "hint");
  return HintMixinClass;
};
const styles$F = ".zw-error-icon {\n  color: var(--zw-color-error);\n}\n\n.zw-error-icon[data-disabled] {\n    color: var(--zw-color-on-surface-variant);\n    cursor: not-allowed;\n  }\n\n.zw-error {\n  margin-block-start: var(--zw-spacing-8);\n  font: var(--zw-typography-text-s-semibold);\n  color: var(--zw-color-error);\n}\n";
var __defProp$B = Object.defineProperty;
var __decorateClass$B = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$B(target, key, result);
  return result;
};
const ErrorMixin = (superClass) => {
  const _ErrorMixinClass = class _ErrorMixinClass extends superClass {
    constructor() {
      super(...arguments);
      this.errored = false;
    }
    get showErrorMessage() {
      return !!(this.errored && this.errorMessage);
    }
    errorIconHTML({ size, disabled }) {
      if (!this.errored) return null;
      return ke$1`<zw-icon
        class="zw-error-icon"
        ?data-disabled=${disabled}
        name="error"
        size=${size}
        variant="filled"
      ></zw-icon>`;
    }
    errorMessageHTML() {
      if (!this.showErrorMessage) return null;
      return ke$1`<div class="zw-error">${this.errorMessage}</div>`;
    }
  };
  _ErrorMixinClass.styles = [r$3(styles$F)];
  let ErrorMixinClass = _ErrorMixinClass;
  __decorateClass$B([
    n$1({ reflect: true, type: Boolean })
  ], ErrorMixinClass.prototype, "errored");
  __decorateClass$B([
    n$1({ reflect: true, attribute: "error-message" })
  ], ErrorMixinClass.prototype, "errorMessage");
  return ErrorMixinClass;
};
const styles$E = '/* Keep the styles similar to the RadioButton component */\n\n:host {\n  --zw-checkbox-color: var(--zw-color-on-surface);\n  --zw-checkbox-text-color: var(--zw-color-on-surface);\n  --zw-checkbox-outline-color: var(--zw-color-on-surface);\n  --zw-checkbox-line-height: 1.25;\n\n  display: inline-flex;\n  align-items: center;\n}\n\n:host([color="primary"]) {\n  --zw-checkbox-checked-color: var(--zw-color-primary);\n  --zw-checkbox-hover-color: var(--zw-color-primary-container);\n  --zw-checkbox-active-color: var(--zw-color-states-primary-focus-press);\n}\n\n:host([color="secondary"]) {\n  --zw-checkbox-checked-color: var(--zw-color-secondary);\n  --zw-checkbox-hover-color: var(--zw-color-secondary-container);\n  --zw-checkbox-active-color: var(--zw-color-states-secondary-focus-press);\n}\n\n:host([errored]) {\n  --zw-checkbox-color: var(--zw-color-error);\n  --zw-checkbox-checked-color: var(--zw-color-error);\n  --zw-checkbox-hover-color: var(--zw-color-error-container);\n  --zw-checkbox-active-color: var(--zw-color-states-error-focus-press);\n}\n\n:host([disabled]) {\n  --zw-checkbox-color: var(--zw-color-on-surface-variant);\n  --zw-checkbox-checked-color: var(--zw-color-on-surface-variant);\n}\n\n.zw-checkbox--label {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--zw-spacing-8);\n\n  /* Create a new stacking context, so checkbox does not blend into other components */\n  isolation: isolate;\n  padding-inline-end: var(--zw-spacing-2);\n  font: var(--zw-typography-text-m-regular);\n\n  /* Line height should match checkbox size */\n  line-height: var(--zw-checkbox-line-height);\n  color: var(--zw-checkbox-text-color);\n}\n\n.zw-checkbox--input:disabled + .zw-checkbox--label {\n    cursor: not-allowed;\n  }\n\n.zw-checkbox--input:focus-visible + .zw-checkbox--label {\n    outline: 2px solid var(--zw-checkbox-outline-color);\n    border-radius: var(--zw-border-radius-4);\n  }\n\n.zw-checkbox--icon {\n  position: relative;\n  z-index: var(--zw-z-index-above);\n}\n\n.zw-checkbox--input:not(:disabled):hover ~ .zw-checkbox--label > .zw-checkbox--icon::before,.zw-checkbox--input:not(:disabled):active ~ .zw-checkbox--label > .zw-checkbox--icon::before {\n    content: "";\n    position: absolute;\n    z-index: var(--zw-z-index-below);\n    inset-block-start: 50%;\n    inset-inline-start: 50%;\n    border-radius: var(--zw-border-radius-1000);\n    padding: var(--zw-spacing-16);\n    transform: translate(-50%, -50%);\n  }\n\n.zw-checkbox--input:not(:disabled):hover ~ .zw-checkbox--label > .zw-checkbox--icon::before {\n    background-color: var(--zw-checkbox-hover-color);\n  }\n\n.zw-checkbox--icon-checked {\n  color: var(--zw-checkbox-checked-color);\n}\n\n.zw-checkbox--input:not(:disabled):active ~ .zw-checkbox--label .zw-checkbox--icon-checked {\n    color: var(--zw-checkbox-active-color);\n  }\n\n.zw-checkbox--icon-unchecked {\n  color: var(--zw-checkbox-color);\n}\n\n.zw-checkbox--input:not(:disabled):active ~ .zw-checkbox--label .zw-checkbox--icon-unchecked {\n    color: var(--zw-checkbox-active-color);\n  }\n';
var __defProp$A = Object.defineProperty;
var __decorateClass$A = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$A(target, key, result);
  return result;
};
const HintElement$6 = HintMixin(h);
const HintAndErrorElement = ErrorMixin(HintElement$6);
const _Checkbox = class _Checkbox extends HintAndErrorElement {
  constructor() {
    super();
    this.internals = this.attachInternals();
    this.value = "on";
    this.color = "primary";
    this.disabled = false;
    this.indeterminate = false;
    this.name = "";
    this.required = false;
    this.readonly = false;
    this.checked = false;
    this.checkboxId = getUniqueId("zw-checkbox");
    defineCustomElementOnce("zw-icon", Icon);
  }
  firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    const { input } = this;
    if (!input) return;
    if (this.internals.setFormValue && this.checked) this.internals.setFormValue(this.value);
    if (this.internals.setValidity)
      this.internals.setValidity(input.validity, input.validationMessage, input);
  }
  update(changedProperties) {
    super.update(changedProperties);
    const { input } = this;
    if (!input) return;
    if (changedProperties.has("checked")) {
      input.checked = this.checked;
      if (this.internals.setValidity)
        this.internals.setValidity(input.validity, input.validationMessage, input);
    }
    if (changedProperties.has("value")) {
      input.value = this.value;
      if (this.internals.setValidity)
        this.internals.setValidity(input.validity, input.validationMessage, input);
    }
  }
  handleClick(event) {
    if (this.readonly) {
      event.preventDefault();
    }
  }
  handleChange() {
    if (this.readonly) return;
    const { checked, indeterminate } = this.input;
    this.checked = checked;
    this.indeterminate = indeterminate;
    this.internals.setFormValue(this.checked ? this.value : null);
    this.dispatchEvent(
      new Event("change", {
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    return ke$1` <div class="zw-checkbox">
      ${this.inputHTML()} ${this.labelHTML()}
      ${this.hintHTML({ showErrorMessage: this.showErrorMessage })} ${this.errorMessageHTML()}
    </div>`;
  }
  inputHTML() {
    return ke$1`<input
      id=${this.checkboxId}
      class="zw-checkbox--input | sr-only"
      type="checkbox"
      ?disabled=${this.disabled}
      ?readonly=${this.readonly}
      @change=${this.handleChange}
      @click=${this.handleClick}
    />`;
  }
  labelHTML() {
    return ke$1`<label class="zw-checkbox--label" for=${this.checkboxId}>
      <div class="zw-checkbox--icon">${this.iconHTML()}</div>
      <span>
        <slot>${this.label}</slot>
      </span>
    </label>`;
  }
  getIconName() {
    if (!this.checked) return "check_box_outline_blank";
    return this.indeterminate ? "indeterminate_check_box" : "check_box";
  }
  iconHTML() {
    const classes = this.checked ? "zw-checkbox--icon-checked" : "zw-checkbox--icon-unchecked";
    return ke$1`<zw-icon class=${classes} name=${this.getIconName()} size="m" variant="filled">
    </zw-icon>`;
  }
};
_Checkbox.styles = [
  r$3(baseStyles),
  r$3(styles$E),
  HintElement$6.styles,
  HintAndErrorElement.styles
];
_Checkbox.formAssociated = true;
let Checkbox = _Checkbox;
__decorateClass$A([
  e$2("input")
], Checkbox.prototype, "input");
__decorateClass$A([
  n$1({ reflect: true })
], Checkbox.prototype, "value");
__decorateClass$A([
  n$1({ reflect: true })
], Checkbox.prototype, "color");
__decorateClass$A([
  n$1({ type: Boolean, reflect: true })
], Checkbox.prototype, "disabled");
__decorateClass$A([
  n$1({ type: Boolean, reflect: true })
], Checkbox.prototype, "indeterminate");
__decorateClass$A([
  n$1({ reflect: true, type: String })
], Checkbox.prototype, "name");
__decorateClass$A([
  n$1({ reflect: true })
], Checkbox.prototype, "label");
__decorateClass$A([
  n$1({ type: Boolean, reflect: true })
], Checkbox.prototype, "required");
__decorateClass$A([
  n$1({ type: Boolean, reflect: true })
], Checkbox.prototype, "readonly");
__decorateClass$A([
  n$1({ type: Boolean, reflect: true, attribute: "checked" })
], Checkbox.prototype, "checked");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Rt = e$1(class extends i$1 {
  constructor(s4) {
    var _a2;
    if (super(s4), s4.type !== t.ATTRIBUTE || "class" !== s4.name || ((_a2 = s4.strings) == null ? void 0 : _a2.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
  }
  render(t2) {
    return " " + Object.keys(t2).filter((s4) => t2[s4]).join(" ") + " ";
  }
  update(t2, [s4]) {
    var _a2, _b;
    if (void 0 === this.st) {
      this.st = /* @__PURE__ */ new Set(), void 0 !== t2.strings && (this.nt = new Set(t2.strings.join(" ").split(/\s/).filter((t3) => "" !== t3)));
      for (const t3 in s4) s4[t3] && !((_a2 = this.nt) == null ? void 0 : _a2.has(t3)) && this.st.add(t3);
      return this.render(s4);
    }
    const i3 = t2.element.classList;
    for (const t3 of this.st) t3 in s4 || (i3.remove(t3), this.st.delete(t3));
    for (const t3 in s4) {
      const r2 = !!s4[t3];
      r2 === this.st.has(t3) || ((_b = this.nt) == null ? void 0 : _b.has(t3)) || (r2 ? (i3.add(t3), this.st.add(t3)) : (i3.remove(t3), this.st.delete(t3)));
    }
    return R;
  }
});
const styles$D = '.zw-label {\n  --zw-label-color: var(--zw-color-on-surface);\n\n  display: inline-block;\n  margin-block-end: var(--zw-label-gap);\n  font: var(--zw-label-font);\n  color: var(--zw-label-color);\n}\n.zw-label[data-size="s"] {\n    --zw-label-font: var(--zw-typography-text-xs-semibold);\n    --zw-label-gap: var(--zw-spacing-4);\n  }\n.zw-label[data-size="m"] {\n    --zw-label-font: var(--zw-typography-text-s-semibold);\n    --zw-label-gap: var(--zw-spacing-8);\n  }\n.zw-label[data-size="l"] {\n    --zw-label-font: var(--zw-typography-text-m-semibold);\n    --zw-label-gap: var(--zw-spacing-8);\n  }\n.zw-label[data-disabled] {\n    --zw-label-color: var(--zw-color-on-surface-variant);\n  }\n';
var __defProp$z = Object.defineProperty;
var __decorateClass$z = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$z(target, key, result);
  return result;
};
const LabelMixin = (superClass) => {
  const _LabelMixinClass = class _LabelMixinClass extends superClass {
    constructor() {
      super(...arguments);
      this.hiddenLabel = false;
    }
    labelHtml({
      tag = "label",
      forId,
      required,
      size,
      disabled
    }) {
      const classes = Rt({
        "zw-label": true,
        "zw-repel": !!this.labelAdditions,
        "sr-only": this.hiddenLabel
      });
      if (tag === "legend") {
        return ke$1`<legend class=${classes} ?data-disabled=${disabled} data-size=${size}>
          ${this.innerLabelHTML(required)}
        </legend>`;
      }
      return ke$1`<label for=${forId} class=${classes} data-size=${size} ?data-disabled=${disabled}>
        ${this.innerLabelHTML(required)}
      </label>`;
    }
    // Overwrite this method in the component to add additional content in a line with the label
    labelAdditions() {
      return null;
    }
    innerLabelHTML(required) {
      return ke$1`${this.label}${required ? " *" : null} ${this.labelAdditions()}`;
    }
  };
  _LabelMixinClass.styles = [r$3(styles$D), r$3(repelStyles)];
  let LabelMixinClass = _LabelMixinClass;
  __decorateClass$z([
    n$1({ reflect: true })
  ], LabelMixinClass.prototype, "label");
  __decorateClass$z([
    n$1({ reflect: true, type: Boolean, attribute: "hidden-label" })
  ], LabelMixinClass.prototype, "hiddenLabel");
  return LabelMixinClass;
};
const styles$C = "/* Keep the styles similar to the RadioButtonGroup component */\n\n.zw-checkbox-group {\n  margin: 0;\n  border: 0;\n  padding: 0;\n}\n\n.zw-checkbox-group--items {\n  display: flex;\n  gap: var(--zw-spacing-8);\n}\n\n:host([inline]) .zw-checkbox-group--items {\n    gap: var(--zw-spacing-24);\n  }\n\n:host(:not([inline])) .zw-checkbox-group--items {\n    flex-direction: column;\n  }\n";
var __defProp$y = Object.defineProperty;
var __decorateClass$y = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$y(target, key, result);
  return result;
};
const HintElement$5 = HintMixin(h);
const ErrorElement$5 = ErrorMixin(HintElement$5);
const LabeledElement$4 = LabelMixin(ErrorElement$5);
const _CheckboxGroup = class _CheckboxGroup extends LabeledElement$4 {
  constructor() {
    super(...arguments);
    this.size = "m";
    this.inline = false;
    this.required = false;
    this.disabled = false;
  }
  render() {
    return ke$1`
      <fieldset class="zw-checkbox-group" ?disabled=${this.disabled}>
        ${this.labelHtml({
      tag: "legend",
      required: this.required,
      size: this.size,
      disabled: this.disabled
    })}

        <div class="zw-checkbox-group--items">
          <slot></slot>
        </div>
        ${this.hintHTML({ showErrorMessage: this.showErrorMessage })} ${this.errorMessageHTML()}
      </fieldset>
    `;
  }
};
_CheckboxGroup.styles = [
  r$3(baseStyles),
  r$3(styles$C),
  HintElement$5.styles,
  ErrorElement$5.styles,
  LabeledElement$4.styles
];
let CheckboxGroup = _CheckboxGroup;
__decorateClass$y([
  n$1({ reflect: true })
], CheckboxGroup.prototype, "size");
__decorateClass$y([
  n$1({ reflect: true, type: Boolean })
], CheckboxGroup.prototype, "inline");
__decorateClass$y([
  n$1({ reflect: true, type: Boolean })
], CheckboxGroup.prototype, "required");
__decorateClass$y([
  n$1({ reflect: true, type: Boolean })
], CheckboxGroup.prototype, "disabled");
const styles$B = ':host {\n  --zw-chip-background-color: var(--zw-color-surface-container);\n  --zw-chip-color: var(--zw-color-on-surface);\n\n  display: inline-block;\n}\n\n:host([size="s"]) {\n  --zw-chip-font: var(--zw-typography-text-s-medium);\n  --zw-chip-padding: var(--zw-spacing-2) var(--zw-spacing-8);\n}\n\n:host([size="m"]) {\n  --zw-chip-font: var(--zw-typography-text-m-medium);\n  --zw-chip-padding: var(--zw-spacing-4) var(--zw-spacing-12);\n}\n\n:host([size="l"]) {\n  --zw-chip-font: var(--zw-typography-text-l-medium);\n  --zw-chip-padding: var(--zw-spacing-8) var(--zw-spacing-16);\n}\n\n.zw-chip {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: var(--zw-spacing-4);\n  inline-size: -moz-fit-content;\n  inline-size: fit-content;\n  outline: 1px solid transparent;\n  border-radius: var(--zw-border-radius-1000);\n  padding: var(--zw-chip-padding);\n  font: var(--zw-chip-font);\n  white-space: nowrap;\n  color: var(--zw-chip-color);\n  background-color: var(--zw-chip-background-color);\n}\n\n.zw-chip:focus-visible {\n    outline: 2px solid var(--zw-color-on-surface);\n  }\n\n.zw-chip:hover {\n    --zw-chip-background-color: var(--zw-color-surface-container-high);\n\n    outline: 1px solid var(--zw-color-outline-variant-low);\n  }\n\n.zw-chip:active {\n    --zw-chip-background-color: var(--zw-color-surface-container-highest);\n\n    outline: 1px solid var(--zw-color-outline-variant-low);\n  }\n\n.zw-chip:disabled {\n    --zw-chip-color: var(--zw-color-on-surface-variant);\n    --zw-chip-background-color: var(--zw-color-surface-container);\n\n    outline: none;\n  }\n';
var __defProp$x = Object.defineProperty;
var __decorateClass$x = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$x(target, key, result);
  return result;
};
const _Chip = class _Chip extends h {
  constructor() {
    super(...arguments);
    this.size = "m";
    this.disabled = false;
  }
  render() {
    return ke$1`
      <button type="button" class="zw-chip" ?disabled=${this.disabled}>
        <slot></slot>
      </button>
    `;
  }
};
_Chip.styles = [r$3(baseStyles), r$3(styles$B)];
let Chip = _Chip;
__decorateClass$x([
  n$1({ reflect: true })
], Chip.prototype, "size");
__decorateClass$x([
  n$1({ type: Boolean, reflect: true })
], Chip.prototype, "disabled");
var Key = /* @__PURE__ */ ((Key2) => {
  Key2["ArrowDown"] = "ArrowDown";
  Key2["ArrowUp"] = "ArrowUp";
  Key2["Backspace"] = "Backspace";
  Key2["Enter"] = "Enter";
  Key2["Escape"] = "Escape";
  Key2["Space"] = " ";
  Key2["Tab"] = "Tab";
  return Key2;
})(Key || {});
var __defProp$w = Object.defineProperty;
var __decorateClass$w = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$w(target, key, result);
  return result;
};
const InputMixin = (superClass) => {
  const _InputMixinClass = class _InputMixinClass extends superClass {
    constructor() {
      super(...arguments);
      this.internals = this.attachInternals();
      this.value = "";
      this.name = "";
      this.type = "";
      this.disabled = false;
      this.required = false;
    }
    getValidityFlags() {
      const { input } = this;
      if (!input) return void 0;
      return input.validity;
    }
    getValidityMessage() {
      const { input } = this;
      if (!input) return void 0;
      return input.validationMessage;
    }
    getAnchor() {
      return this.input || void 0;
    }
    updateInputValue() {
      if (this.input) {
        this.input.value = this.value;
      }
    }
    updateFormValue() {
      if (this.internals.setFormValue) {
        this.internals.setFormValue(this.value);
      }
    }
    resetFormValue() {
      if (this.internals.setFormValue) {
        this.internals.setFormValue(null);
      }
    }
    updateValidity() {
      if (this.internals.setValidity) {
        const flags = this.getValidityFlags();
        const message = this.getValidityMessage();
        const anchor = this.getAnchor();
        this.internals.setValidity(flags, message, anchor);
      }
    }
    firstUpdated(changedProperties) {
      super.firstUpdated(changedProperties);
      this.updateFormValue();
      this.updateValidity();
    }
    update(changedProperties) {
      super.update(changedProperties);
      if (changedProperties.has("value")) {
        this.updateInputValue();
        this.updateFormValue();
        this.updateValidity();
      }
      if (changedProperties.has("required") || changedProperties.has("type")) {
        this.updateValidity();
      }
      if (changedProperties.has("disabled")) {
        if (this.disabled) {
          this.resetFormValue();
        } else {
          this.updateFormValue();
        }
        this.updateValidity();
      }
    }
  };
  _InputMixinClass.formAssociated = true;
  let InputMixinClass = _InputMixinClass;
  __decorateClass$w([
    n$1()
  ], InputMixinClass.prototype, "value");
  __decorateClass$w([
    n$1({ reflect: true })
  ], InputMixinClass.prototype, "name");
  __decorateClass$w([
    n$1({ reflect: true })
  ], InputMixinClass.prototype, "type");
  __decorateClass$w([
    n$1({ reflect: true, type: Boolean })
  ], InputMixinClass.prototype, "disabled");
  __decorateClass$w([
    n$1({ reflect: true, type: Boolean })
  ], InputMixinClass.prototype, "required");
  return InputMixinClass;
};
const styles$A = ':host {\n  --zw-text-field-max-inline-size: none;\n  --zw-text-field-color-input-text-hover: var(--zw-color-on-info-container);\n  --zw-text-field-color-border: var(--zw-color-outline);\n  --zw-text-field-color-border-focus-active: var(--zw-color-on-surface);\n\n  display: block;\n}\n\n:host([color="primary"]) {\n  --zw-text-field-color-input-container-hover: var(--zw-color-primary-container);\n}\n\n:host([color="secondary"]) {\n  --zw-text-field-color-input-container-hover: var(--zw-color-secondary-container);\n}\n\n:host([size="s"]) {\n  --zw-text-field-font-input: var(--zw-typography-text-s-regular);\n  --zw-text-field-padding-input: var(--zw-spacing-8);\n  --zw-text-field-size-icon: var(--zw-icon-size-s);\n}\n\n:host([size="m"]) {\n  --zw-text-field-font-input: var(--zw-typography-text-m-regular);\n  --zw-text-field-padding-input: var(--zw-spacing-12);\n  --zw-text-field-size-icon: var(--zw-icon-size-m);\n}\n\n:host([size="l"]) {\n  --zw-text-field-font-input: var(--zw-typography-text-l-regular);\n  --zw-text-field-padding-input: var(--zw-spacing-16);\n  --zw-text-field-size-icon: var(--zw-icon-size-l);\n}\n\n.zw-text-field {\n  --zw-text-field-gap-input: var(--zw-spacing-8);\n\n  /* The padding of the input needs to be adjusted because of the variable\n  existence of absolute positioned icons */\n  --zw-text-field-padding-with-icon-base: calc(\n    var(--zw-text-field-padding-input) + var(--zw-text-field-size-icon) +\n      var(--zw-text-field-gap-input)\n  );\n  --zw-text-field-padding-with-two-icons-base: calc(\n    var(--zw-text-field-padding-input) + 2 * var(--zw-text-field-size-icon) + 2 *\n      var(--zw-text-field-gap-input)\n  );\n  --zw-text-field-padding-left-input: var(--zw-text-field-padding-input);\n  --zw-text-field-padding-right-input: var(--zw-text-field-padding-input);\n  --zw-text-field-position-icon: var(--zw-text-field-padding-input);\n\n  inline-size: 100%;\n  max-inline-size: var(--zw-text-field-max-inline-size);\n}\n\n.zw-text-field[data-has-icon] {\n    --zw-text-field-padding-left-input: var(--zw-text-field-padding-with-icon-base);\n  }\n\n.zw-text-field[data-has-payment-method] {\n    --payment-method-icon-aspect-ratio: calc(34 / 24);\n    --zw-text-field-padding-left-input: calc(\n      var(--zw-text-field-padding-input) + var(--payment-method-icon-aspect-ratio) *\n        var(--zw-text-field-size-icon) + var(--zw-text-field-gap-input)\n    );\n  }\n\n.zw-text-field[data-errored] {\n    --zw-text-field-color-input-text-hover: var(--zw-color-on-error-container);\n    --zw-text-field-color-input-container-hover: var(--zw-color-error-container);\n    --zw-text-field-color-border: var(--zw-color-error);\n    --zw-text-field-color-border-focus-active: var(--zw-color-error);\n    --zw-text-field-padding-right-input: var(--zw-text-field-padding-with-icon-base);\n  }\n\n.zw-text-field[data-errored]:has(input[type="search"]) {\n      --zw-text-field-padding-right-input: var(--zw-text-field-padding-with-two-icons-base);\n    }\n\n.zw-text-field:has(input[type="search"]) {\n    --zw-text-field-padding-right-input: var(--zw-text-field-padding-with-icon-base);\n  }\n\n.zw-text-field:has(input:disabled) {\n    --zw-text-field-color-border: var(--zw-color-outline);\n    --zw-text-field-opacity-payment-method-icon: 0.3;\n  }\n\n.zw-text-field[data-errored]:has(input:disabled) {\n    --zw-text-field-color-border: var(--zw-color-error);\n  }\n\n.zw-text-field--input-container {\n  display: flex;\n  align-items: center;\n  gap: var(--zw-text-field-gap-input);\n  position: relative;\n  border-radius: var(--zw-border-radius-4);\n  color: var(--zw-color-on-surface);\n  background-color: var(--zw-color-surface-container-lowest);\n}\n\n.zw-text-field--input-container:hover {\n    color: var(--zw-text-field-color-input-text-hover);\n    background-color: var(--zw-text-field-color-input-container-hover);\n  }\n\n.zw-text-field--input-container > .zw-text-field--input:disabled {\n    color: var(--zw-color-on-surface-variant);\n    background-color: var(--zw-color-surface-container);\n    cursor: not-allowed;\n  }\n\n.zw-text-field--input {\n  overflow: hidden;\n  inline-size: 100%;\n  border: 1px solid var(--zw-text-field-color-border);\n  border-radius: var(--zw-border-radius-4);\n  padding-block: var(--zw-text-field-padding-input);\n  padding-inline-end: var(--zw-text-field-padding-right-input);\n  padding-inline-start: var(--zw-text-field-padding-left-input);\n  font: var(--zw-text-field-font-input);\n  color: var(--zw-color-on-surface);\n  background-color: transparent;\n}\n\n.zw-text-field--input:focus-visible {\n    outline: 2px solid var(--zw-text-field-color-border-focus-active);\n    outline-offset: -1px;\n  }\n\n.zw-text-field--input:enabled:active {\n    border-color: var(--zw-text-field-color-border-focus-active);\n  }\n\n/* Removes the native x button in chrome */\n\n.zw-text-field--input[type="search"]::-webkit-search-decoration,.zw-text-field--input[type="search"]::-webkit-search-cancel-button,.zw-text-field--input[type="search"]::-webkit-search-results-button,.zw-text-field--input[type="search"]::-webkit-search-results-decoration {\n    display: none;\n  }\n\n.zw-text-field--icon {\n  display: inline-flex;\n  position: absolute;\n  inset-inline-start: var(--zw-text-field-position-icon);\n  color: var(--zw-color-on-surface-variant);\n}\n\n.zw-text-field--payment-method-icon {\n  opacity: var(--zw-text-field-opacity-payment-method-icon);\n  display: inline-flex;\n  position: absolute;\n  inset-inline-start: var(--zw-text-field-position-icon);\n}\n\n.zw-text-field--trailing-icons-container {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--zw-text-field-gap-input);\n  position: absolute;\n  inset-inline-end: var(--zw-text-field-position-icon);\n}\n\n.zw-text-field--reset-button {\n  opacity: 0.6;\n  display: none;\n}\n\n.zw-text-field:hover .zw-text-field--reset-button,.zw-text-field:focus-within .zw-text-field--reset-button {\n    display: inline-flex;\n  }\n';
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class le extends i$1 {
  constructor(i3) {
    if (super(i3), this.it = D, i3.type !== t.CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
  }
  render(t2) {
    if (t2 === D || null == t2) return this._t = void 0, this.it = t2;
    if (t2 === R) return t2;
    if ("string" != typeof t2) throw Error(this.constructor.directiveName + "() called with a non-string value");
    if (t2 === this.it) return this._t;
    this.it = t2;
    const i3 = [t2];
    return i3.raw = i3, this._t = { _$litType$: this.constructor.resultType, strings: i3, values: [] };
  }
}
le.directiveName = "unsafeHTML", le.resultType = 1;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class pe extends le {
}
pe.directiveName = "unsafeSVG", pe.resultType = 2;
const fe = e$1(pe);
const styles$z = ':host([size="s"]) {\n  --zw-payment-method-icon-size: var(--zw-icon-size-s);\n}\n\n:host([size="m"]) {\n  --zw-payment-method-icon-size: var(--zw-icon-size-m);\n}\n\n:host([size="l"]) {\n  --zw-payment-method-icon-size: var(--zw-icon-size-l);\n}\n\n.zw-payment-method-icon {\n  aspect-ratio: 34 / 24;\n  block-size: var(--zw-payment-method-icon-size);\n}\n';
const amex = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 34 24" height="100%">\n  <rect width="33" height="23" x=".5" y=".5" fill="#1F72CD" rx="3.5"/>\n  <path fill="#fff" fill-rule="evenodd" d="m6.095 8.5-3.18 7.247h3.808l.472-1.156h1.079l.472 1.156h4.192v-.882l.373.882h2.168l.374-.9v.9h8.718l1.06-1.126.992 1.126 4.478.01-3.191-3.613L31.101 8.5h-4.408L25.66 9.605 24.7 8.5h-9.484l-.814 1.87-.834-1.87h-3.8v.852L9.345 8.5h-3.25Zm.737 1.029H8.69l2.11 4.914V9.53h2.033l1.63 3.523 1.502-3.523h2.023v5.2h-1.23l-.011-4.075-1.795 4.075H13.85l-1.805-4.075v4.075H9.512l-.48-1.166H6.438l-.48 1.165H4.602l2.231-5.199Zm17.288 0h-5.006v5.197h4.928l1.589-1.722 1.531 1.722h1.6l-2.326-2.583 2.327-2.614H27.23l-1.58 1.703-1.531-1.703Zm-16.385.88-.854 2.077h1.708l-.854-2.077Zm12.615 1.146v-.95h3.124l1.363 1.518-1.424 1.526H20.35v-1.036h2.731v-1.058H20.35Z" clip-rule="evenodd"/>\n  <rect width="33" height="23" x=".5" y=".5" stroke="#F2F4F7" rx="3.5"/>\n</svg>\n';
const applePay = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 34 24" height="100%">\n  <rect width="33" height="23" x=".5" y=".5" fill="#fff" rx="3.5"/>\n  <path fill="#000" fill-rule="evenodd" d="M9.45 8.343c-.286.352-.743.63-1.2.59-.056-.476.167-.981.429-1.294.285-.361.784-.62 1.189-.639.047.496-.138.981-.419 1.343Zm.413.684c-.402-.024-.77.126-1.066.248-.19.078-.352.144-.475.144-.138 0-.306-.07-.495-.148-.248-.103-.53-.22-.827-.214-.68.01-1.313.411-1.66 1.05-.714 1.28-.186 3.173.504 4.213.338.516.742 1.08 1.275 1.061.234-.01.402-.084.577-.16.2-.09.41-.182.735-.182.315 0 .514.09.706.176.182.082.357.161.617.156.551-.01.899-.515 1.236-1.03.365-.554.525-1.094.55-1.176l.002-.01-.013-.006a1.853 1.853 0 0 1-1.062-1.693c-.009-1 .739-1.507.856-1.586l.014-.01c-.475-.734-1.217-.813-1.474-.833Zm3.82 6.29V7.59h2.782c1.436 0 2.44 1.03 2.44 2.537s-1.023 2.548-2.478 2.548h-1.594v2.642h-1.15Zm1.15-6.716h1.327c1 0 1.57.555 1.57 1.531 0 .977-.57 1.537-1.574 1.537h-1.323V8.6Zm7.872 5.789c-.304.604-.975.986-1.698.986-1.07 0-1.817-.664-1.817-1.665 0-.991.723-1.561 2.06-1.646l1.436-.089v-.426c0-.63-.395-.972-1.099-.972-.58 0-1.003.313-1.089.789h-1.037c.034-1.002.937-1.73 2.16-1.73 1.317 0 2.174.718 2.174 1.834v3.846h-1.066v-.927h-.024Zm-1.389.07c-.613 0-1.003-.308-1.003-.779 0-.486.376-.768 1.094-.813l1.28-.084v.436c0 .724-.59 1.24-1.37 1.24Zm6.012 1.159c-.461 1.353-.989 1.8-2.111 1.8-.086 0-.371-.01-.438-.03v-.927c.071.01.247.02.338.02.509 0 .794-.224.97-.803l.105-.343-1.95-5.625h1.203l1.355 4.565h.024L28.18 9.71h1.17l-2.022 5.908Z" clip-rule="evenodd"/>\n  <rect width="33" height="23" x=".5" y=".5" stroke="#F2F4F7" rx="3.5"/>\n</svg>\n';
const googlePay = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 34 24" height="100%">\n  <rect width="33" height="23" x=".5" y=".5" fill="#fff" rx="3.5"/>\n  <path fill="#3C4043" fill-rule="evenodd" d="M16.058 15.528v-2.935h1.515c.62 0 1.144-.208 1.571-.618l.103-.104c.78-.85.728-2.172-.103-2.958a2.162 2.162 0 0 0-1.571-.63H15.14v7.245h.917Zm0-3.825v-2.53h1.538c.33 0 .643.127.877.358.495.486.507 1.294.028 1.797a1.19 1.19 0 0 1-.905.376h-1.538Zm7.465-.745c-.393-.364-.928-.549-1.606-.549-.871 0-1.526.324-1.959.965l.809.514c.296-.439.7-.658 1.213-.658.324 0 .637.121.882.34.24.209.376.509.376.827v.213c-.353-.196-.797-.3-1.344-.3-.637 0-1.15.15-1.531.457-.382.306-.575.71-.575 1.224-.012.468.187.913.54 1.213.36.324.815.486 1.35.486.632 0 1.133-.284 1.515-.85h.04v.688h.876v-3.056c0-.641-.193-1.15-.586-1.514Zm-2.488 3.657a.753.753 0 0 1-.302-.607c0-.271.125-.496.37-.675.25-.18.564-.272.934-.272.512-.006.911.11 1.196.34 0 .394-.154.735-.456 1.023a1.446 1.446 0 0 1-1.03.434 1.11 1.11 0 0 1-.712-.243Zm5.044 3.09 3.064-7.134h-.997L26.73 14.13h-.017l-1.453-3.559h-.996l2.01 4.64-1.139 2.495h.945Z" clip-rule="evenodd"/>\n  <path fill="#4285F4" d="M12.893 11.958c0-.283-.023-.566-.068-.844H8.958v1.6h2.215a1.928 1.928 0 0 1-.82 1.266v1.04h1.322c.774-.722 1.218-1.791 1.218-3.062Z"/>\n  <path fill="#34A853" d="M8.959 16.025c1.104 0 2.038-.37 2.716-1.005l-1.321-1.04c-.37.254-.843.398-1.395.398-1.07 0-1.976-.733-2.3-1.715H5.296v1.074a4.09 4.09 0 0 0 3.662 2.288Z"/>\n  <path fill="#FBBC04" d="M6.658 12.663a2.544 2.544 0 0 1 0-1.595V10h-1.36a4.177 4.177 0 0 0 0 3.731l1.36-1.068Z"/>\n  <path fill="#EA4335" d="M8.959 9.352a2.19 2.19 0 0 1 1.571.624l1.173-1.19a3.926 3.926 0 0 0-2.744-1.08c-1.55 0-2.967.89-3.662 2.293l1.361 1.075c.325-.988 1.23-1.722 2.3-1.722Z"/>\n  <rect width="33" height="23" x=".5" y=".5" stroke="#F2F4F7" rx="3.5"/>\n</svg>\n';
const klarna = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 34 24" height="100%">\n  <rect width="33" height="23" x=".5" y=".5" fill="#FEB4C7" rx="3.5"/>\n  <path fill="#17120F" fill-rule="evenodd" d="M5.27 15.38H3.885V9h1.383v6.38ZM8.722 9H7.37c0 1.174-.51 2.252-1.4 2.957l-.536.425 2.078 2.998H9.22l-1.912-2.76c.907-.954 1.415-2.239 1.415-3.62Zm2.207 6.378H9.623V9h1.307v6.377Zm3.947-4.411v.282a2.104 2.104 0 0 0-1.237-.404c-1.214 0-2.199 1.042-2.199 2.327 0 1.286.985 2.328 2.2 2.328.458 0 .884-.15 1.236-.404v.282h1.248v-4.411h-1.248Zm-.004 2.205c0 .627-.506 1.135-1.13 1.135-.625 0-1.131-.508-1.131-1.135 0-.626.506-1.134 1.13-1.134.625 0 1.131.508 1.131 1.134Zm13.17-1.923v-.282h1.247v4.41h-1.248v-.281a2.105 2.105 0 0 1-1.237.404c-1.214 0-2.199-1.042-2.199-2.328 0-1.285.985-2.327 2.2-2.327.458 0 .884.15 1.236.404Zm-1.135 3.058c.624 0 1.13-.508 1.13-1.135 0-.626-.506-1.134-1.13-1.134-.625 0-1.13.508-1.13 1.134 0 .627.505 1.135 1.13 1.135Zm2.924.335c0-.458.35-.829.783-.829.432 0 .783.371.783.83 0 .457-.35.828-.783.828-.433 0-.783-.371-.783-.829Zm-7.444-3.794c-.498 0-.97.164-1.285.616v-.497H19.86v4.41h1.258V13.06c0-.67.425-1 .937-1 .548 0 .864.347.864.99v2.328h1.246v-2.805c0-1.027-.771-1.725-1.776-1.725Zm-4.332.119v.574c.25-.344.716-.574 1.223-.574v1.284h-.015c-.494 0-1.206.373-1.206 1.068v2.059h-1.28v-4.411h1.278Z" clip-rule="evenodd"/>\n  <rect width="33" height="23" x=".5" y=".5" stroke="#F2F4F7" rx="3.5"/>\n</svg>\n';
const mastercard = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 34 24" height="100%">\n  <rect width="33" height="23" x=".5" y=".5" fill="#fff" rx="3.5"/>\n  <path fill="#ED0006" fill-rule="evenodd" d="M17.179 16.83a6.803 6.803 0 0 1-4.398 1.6c-3.745 0-6.781-3-6.781-6.7s3.036-6.7 6.78-6.7c1.679 0 3.215.603 4.399 1.6a6.802 6.802 0 0 1 4.398-1.6c3.745 0 6.781 3 6.781 6.7s-3.036 6.7-6.78 6.7a6.802 6.802 0 0 1-4.399-1.6Z" clip-rule="evenodd"/>\n  <path fill="#F9A000" fill-rule="evenodd" d="M17.179 16.83a6.653 6.653 0 0 0 2.382-5.1c0-2.042-.924-3.87-2.382-5.1a6.802 6.802 0 0 1 4.398-1.6c3.745 0 6.78 3 6.78 6.7s-3.035 6.7-6.78 6.7a6.802 6.802 0 0 1-4.398-1.6Z" clip-rule="evenodd"/>\n  <path fill="#FF5E00" fill-rule="evenodd" d="M17.179 16.83a6.653 6.653 0 0 0 2.382-5.1c0-2.042-.924-3.87-2.382-5.1a6.653 6.653 0 0 0-2.382 5.1c0 2.042.924 3.87 2.382 5.1Z" clip-rule="evenodd"/>\n  <rect width="33" height="23" x=".5" y=".5" stroke="#F2F4F7" rx="3.5"/>\n</svg>\n';
const paypal = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 34 24" height="100%">\n  <rect width="33" height="23" x=".5" y=".5" fill="#fff" rx="3.5"/>\n  <path fill="#28356A" fill-rule="evenodd" d="M14.614 18.448 14.835 17l-.492-.012h-2.348l1.632-10.693a.143.143 0 0 1 .046-.084.13.13 0 0 1 .087-.033h3.959c1.314 0 2.221.282 2.694.84.223.262.364.536.432.837.072.316.073.693.003 1.153l-.005.034v.295l.222.13c.187.102.336.22.45.354.19.224.313.508.364.845.054.347.036.76-.052 1.227-.1.538-.265 1.006-.486 1.389a2.821 2.821 0 0 1-.77.872c-.294.216-.643.38-1.037.484a5.018 5.018 0 0 1-1.297.155h-.308a.916.916 0 0 0-.602.229.972.972 0 0 0-.314.579l-.024.13-.39 2.555-.017.093c-.005.03-.013.045-.025.055a.063.063 0 0 1-.04.015h-1.903Z" clip-rule="evenodd"/>\n  <path fill="#298FC2" fill-rule="evenodd" d="M21.276 9.075a7.3 7.3 0 0 1-.04.24c-.523 2.77-2.31 3.727-4.59 3.727h-1.162a.57.57 0 0 0-.557.494l-.764 5.003a.304.304 0 0 0 .294.355h2.06a.501.501 0 0 0 .49-.431l.02-.108.388-2.545.025-.14a.5.5 0 0 1 .49-.432h.307c1.996 0 3.559-.838 4.016-3.261.19-1.013.091-1.858-.413-2.453a1.976 1.976 0 0 0-.564-.45Z" clip-rule="evenodd"/>\n  <path fill="#22284F" fill-rule="evenodd" d="M20.73 8.85a3.991 3.991 0 0 0-.509-.117 6.25 6.25 0 0 0-1.023-.077h-3.103a.48.48 0 0 0-.214.05.51.51 0 0 0-.276.383l-.66 4.321-.019.126a.57.57 0 0 1 .558-.494h1.161c2.282 0 4.068-.957 4.59-3.727a6.17 6.17 0 0 0 .04-.24 2.729 2.729 0 0 0-.546-.225Z" clip-rule="evenodd"/>\n  <path fill="#28356A" fill-rule="evenodd" d="M15.605 9.089a.508.508 0 0 1 .276-.382.48.48 0 0 1 .214-.05h3.103c.367 0 .71.024 1.024.077a4.544 4.544 0 0 1 .508.116l.117.037c.154.053.297.116.429.188.155-1.024-.001-1.721-.537-2.353-.59-.695-1.656-.992-3.02-.992H13.76a.572.572 0 0 0-.56.494l-1.648 10.804a.348.348 0 0 0 .335.406h2.445l1.273-8.345Z" clip-rule="evenodd"/>\n  <rect width="33" height="23" x=".5" y=".5" stroke="#F2F4F7" rx="3.5"/>\n</svg>\n';
const sepa = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 34 24" height="100%">\n  <rect width="33" height="23" x=".5" y=".5" fill="#fff" rx="3.5"/>\n  <path fill="#10298E" fill-rule="evenodd" d="M19.342 11.488h1.113c.353-.013.568-.041.645-.085.105-.06.176-.18.211-.36.023-.119.034-.297.034-.533 0-.29-.022-.504-.067-.644-.064-.196-.218-.315-.462-.359a3.505 3.505 0 0 0-.346-.01h-1.128v1.991Zm-1.786 3.353V8h3.327c.456 0 .804.038 1.044.115.547.177.914.539 1.102 1.086.097.287.145.72.145 1.296 0 .694-.053 1.193-.16 1.497-.213.6-.652.946-1.316 1.036-.078.013-.41.025-.995.035l-.297.01h-1.064v1.766h-1.786ZM8.59 10.182h1.661c.01-.15.016-.264.016-.34 0-.921-.361-1.482-1.084-1.683-.296-.081-.793-.123-1.49-.123-.443 0-.846.017-1.209.05-.436.036-.794.157-1.074.363-.191.134-.33.33-.416.59-.086.258-.129.602-.129 1.031 0 .563.08.985.239 1.263.18.327.543.543 1.087.648.206.036.575.074 1.106.113.661.046 1.032.082 1.111.108.213.066.32.25.32.55 0 .135-.013.245-.038.33a.493.493 0 0 1-.301.3c-.086.032-.285.049-.596.049h-.611a.951.951 0 0 1-.415-.093c-.166-.086-.248-.277-.248-.574v-.142H4.856c0 .557.04.954.12 1.193.143.43.44.714.888.854.366.115 1.015.172 1.945.172.557 0 .972-.026 1.243-.079.646-.124 1.062-.42 1.247-.89.102-.255.153-.658.153-1.209 0-.239-.011-.454-.034-.644a1.252 1.252 0 0 0-.359-.772c-.255-.252-.667-.408-1.235-.467-.179-.02-.627-.054-1.345-.103l-.335-.025a.76.76 0 0 1-.354-.098c-.125-.079-.187-.243-.187-.492 0-.275.07-.454.21-.536.14-.082.428-.123.862-.123.447 0 .72.071.818.214.064.096.096.284.096.565Zm-3.727 6.016.25-.026c.014.087.045.15.09.191a.27.27 0 0 0 .186.06c.083 0 .145-.017.187-.053a.163.163 0 0 0 .062-.127.122.122 0 0 0-.026-.079.21.21 0 0 0-.092-.057c-.03-.01-.098-.03-.204-.056a.682.682 0 0 1-.288-.13.344.344 0 0 1-.117-.262.342.342 0 0 1 .213-.318.62.62 0 0 1 .25-.045c.159 0 .279.036.359.108.08.072.123.168.127.288l-.257.01c-.01-.066-.034-.115-.07-.144-.036-.03-.09-.045-.163-.045a.285.285 0 0 0-.174.048.096.096 0 0 0-.04.08c0 .032.012.058.037.08.033.028.11.057.235.087a1.2 1.2 0 0 1 .276.095.36.36 0 0 1 .14.133c.034.056.05.126.05.208 0 .076-.02.146-.06.212a.366.366 0 0 1-.171.146.697.697 0 0 1-.276.047c-.16 0-.284-.038-.37-.115a.509.509 0 0 1-.154-.336Zm1.298-.519h.244v.947H6.16v-.947Zm0-.36h.244v.23H6.16v-.23Zm1.138 1.307h.244v-.59a.81.81 0 0 0-.013-.168.247.247 0 0 0-.148-.182.363.363 0 0 0-.45.132v-.139h-.226v.947h.244v-.43c0-.106.006-.178.018-.218a.19.19 0 0 1 .181-.13.14.14 0 0 1 .084.025.14.14 0 0 1 .05.07c.011.03.016.097.016.199v.484Zm.738-.494c0 .101.018.175.056.222.037.047.084.07.139.07a.188.188 0 0 0 .149-.072c.04-.048.06-.12.06-.213 0-.099-.019-.172-.058-.22a.183.183 0 0 0-.147-.071.175.175 0 0 0-.143.07c-.038.047-.056.118-.056.214Zm-.219.556.277.032c.004.035.015.059.032.072.023.02.06.029.11.029.063 0 .11-.01.142-.03a.121.121 0 0 0 .049-.063.394.394 0 0 0 .011-.115l.001-.138a.336.336 0 0 1-.567-.01.562.562 0 0 1-.085-.319c0-.159.037-.28.11-.364a.354.354 0 0 1 .278-.126c.113 0 .207.052.28.155v-.132h.227v.851a.87.87 0 0 1-.027.251.311.311 0 0 1-.075.13.33.33 0 0 1-.13.075.661.661 0 0 1-.204.027c-.156 0-.267-.028-.332-.083a.264.264 0 0 1-.098-.211l.001-.03Zm1.401-1.37h-.244v1.308h.244V15.32Zm.85.756c-.002-.074-.02-.13-.055-.168a.165.165 0 0 0-.127-.058.167.167 0 0 0-.132.06.24.24 0 0 0-.052.166h.366Zm-.013.254.242.041a.408.408 0 0 1-.148.209.426.426 0 0 1-.253.072c-.16 0-.279-.054-.356-.162a.556.556 0 0 1-.09-.328c0-.157.039-.28.119-.37.08-.09.18-.134.302-.134.137 0 .245.047.325.14.079.094.117.238.113.43H9.7a.258.258 0 0 0 .058.175.184.184 0 0 0 .142.062c.038 0 .07-.01.097-.032a.197.197 0 0 0 .06-.103Zm1.053-1.01v1.308h.963v-.22h-.707v-.356H12v-.22h-.634v-.29h.682v-.221h-.939Zm1.835 1.308v-.142a.367.367 0 0 1-.472.123.246.246 0 0 1-.106-.117.542.542 0 0 1-.033-.21v-.6h.244v.435c0 .133.004.215.013.245.01.03.025.054.049.071a.147.147 0 0 0 .09.026.186.186 0 0 0 .112-.035.178.178 0 0 0 .067-.087c.012-.035.018-.12.018-.256v-.4h.244v.947h-.226Zm.518 0h.244v-.293c0-.16.007-.267.02-.317.014-.05.033-.086.057-.105a.133.133 0 0 1 .087-.03c.035 0 .073.014.114.042l.075-.22a.302.302 0 0 0-.16-.047c-.04 0-.075.01-.106.031a.417.417 0 0 0-.104.127v-.135h-.226v.947Zm.944-.473c0 .094.022.166.065.216.043.05.097.076.16.076a.203.203 0 0 0 .16-.076c.044-.05.065-.122.065-.218a.32.32 0 0 0-.064-.215.203.203 0 0 0-.16-.075.204.204 0 0 0-.161.075c-.043.05-.065.123-.065.217Zm-.249-.014c0-.083.02-.164.06-.242a.417.417 0 0 1 .169-.18.488.488 0 0 1 .244-.06.45.45 0 0 1 .342.14.493.493 0 0 1 .133.353.5.5 0 0 1-.134.358.447.447 0 0 1-.339.142.52.52 0 0 1-.241-.06.398.398 0 0 1-.174-.173.594.594 0 0 1-.06-.278Zm2-.226v-.374h.122c.093 0 .154.003.184.01a.175.175 0 0 1 .103.058c.027.03.04.07.04.118 0 .04-.01.073-.029.103a.168.168 0 0 1-.08.064.636.636 0 0 1-.201.02h-.14Zm-.257-.594v1.307h.256v-.493h.167c.116 0 .204-.006.265-.018a.364.364 0 0 0 .24-.191.438.438 0 0 0 .043-.203.415.415 0 0 0-.074-.254.332.332 0 0 0-.182-.128 1.443 1.443 0 0 0-.305-.02h-.41Zm1.737.853c-.031.011-.08.024-.148.039a.435.435 0 0 0-.131.044.106.106 0 0 0-.048.088.13.13 0 0 0 .135.13.205.205 0 0 0 .125-.045.157.157 0 0 0 .058-.083.517.517 0 0 0 .009-.123v-.05Zm-.327-.205-.219-.041a.356.356 0 0 1 .128-.204.457.457 0 0 1 .27-.066c.109 0 .19.013.242.04.053.026.091.06.112.1.022.042.033.117.033.226l-.003.293c0 .083.004.144.012.184.008.04.022.082.044.127h-.242a.829.829 0 0 1-.032-.102.44.44 0 0 1-.133.094.37.37 0 0 1-.15.032.307.307 0 0 1-.224-.08.269.269 0 0 1-.082-.201c0-.054.012-.101.037-.143a.247.247 0 0 1 .104-.097.803.803 0 0 1 .194-.059c.114-.021.192-.042.236-.061v-.026c0-.048-.012-.083-.035-.104-.023-.02-.067-.031-.131-.031a.171.171 0 0 0-.102.026.184.184 0 0 0-.059.093Zm1-.288h-.259l.35.95a.367.367 0 0 1-.062.132c-.028.035-.07.052-.127.052a.523.523 0 0 1-.103-.012l.023.196a.622.622 0 0 0 .262 0 .288.288 0 0 0 .093-.042.271.271 0 0 0 .066-.071c.02-.03.04-.072.061-.127l.383-1.078h-.252l-.215.673-.22-.673Zm.877 0h.224v.13a.357.357 0 0 1 .287-.153c.06 0 .11.013.154.038a.284.284 0 0 1 .106.113.431.431 0 0 1 .131-.113.313.313 0 0 1 .15-.038c.067 0 .125.014.171.043.047.028.082.07.105.124.017.04.025.106.025.197v.606h-.244v-.542c0-.094-.008-.155-.025-.182a.114.114 0 0 0-.103-.054.162.162 0 0 0-.096.032.178.178 0 0 0-.065.095.696.696 0 0 0-.02.196v.455h-.244v-.52a.744.744 0 0 0-.013-.179.113.113 0 0 0-.04-.06.125.125 0 0 0-.074-.019.173.173 0 0 0-.101.031.172.172 0 0 0-.064.09.695.695 0 0 0-.02.196v.461h-.244v-.947Zm2.139.227c.035.038.053.094.055.168h-.366a.24.24 0 0 1 .052-.165.167.167 0 0 1 .132-.061c.05 0 .092.02.127.058Zm.284.463-.242-.041a.196.196 0 0 1-.06.103.148.148 0 0 1-.096.032.184.184 0 0 1-.142-.062.259.259 0 0 1-.059-.174h.611c.004-.194-.034-.337-.113-.43a.402.402 0 0 0-.325-.14.388.388 0 0 0-.302.133.536.536 0 0 0-.12.37c0 .132.03.241.091.328.077.108.196.162.356.162a.427.427 0 0 0 .253-.072.409.409 0 0 0 .148-.209Zm1.098.257h-.244v-.484a.783.783 0 0 0-.015-.199.14.14 0 0 0-.05-.07.14.14 0 0 0-.085-.025.19.19 0 0 0-.181.13.849.849 0 0 0-.019.218v.43h-.244v-.947h.227v.14a.363.363 0 0 1 .45-.133c.044.02.077.046.1.076a.283.283 0 0 1 .048.106c.009.04.013.095.013.169v.59Zm.72-.747v-.2h-.166v-.337l-.244.148v.19h-.11v.2h.11v.413c0 .089.002.148.008.177a.236.236 0 0 0 .034.098.173.173 0 0 0 .077.059.293.293 0 0 0 .117.023.466.466 0 0 0 .191-.038l-.02-.194a.298.298 0 0 1-.097.024.066.066 0 0 1-.04-.012.055.055 0 0 1-.021-.032.984.984 0 0 1-.005-.136v-.383h.166Zm.137.48.244-.039c.01.049.031.085.063.11a.209.209 0 0 0 .133.038c.063 0 .11-.012.142-.036a.081.081 0 0 0 .032-.067.067.067 0 0 0-.018-.048.191.191 0 0 0-.082-.033c-.197-.045-.322-.086-.374-.123a.246.246 0 0 1-.11-.213c0-.083.032-.152.095-.208.063-.056.161-.084.294-.084.126 0 .22.021.281.063a.322.322 0 0 1 .128.186l-.23.044a.146.146 0 0 0-.056-.085.204.204 0 0 0-.118-.029c-.065 0-.111.01-.14.028a.06.06 0 0 0-.027.051c0 .018.008.033.024.046a.9.9 0 0 0 .228.07c.13.031.22.069.272.113.051.045.077.107.077.187a.292.292 0 0 1-.106.225c-.07.063-.174.095-.312.095a.502.502 0 0 1-.297-.079.36.36 0 0 1-.143-.212Zm2.165-.734.178.485h-.349l.171-.485Zm.372 1.001h.276l-.512-1.307h-.27l-.49 1.307h.27l.105-.296h.511l.11.296Zm.695 0h-.244v-.947h.226v.135a.415.415 0 0 1 .105-.127.184.184 0 0 1 .105-.03c.055 0 .108.015.16.047l-.074.219a.21.21 0 0 0-.115-.041.133.133 0 0 0-.087.029c-.024.02-.042.054-.056.105a1.52 1.52 0 0 0-.02.317v.293Zm1.002-.72c.035.038.053.094.055.168h-.366a.24.24 0 0 1 .052-.165.167.167 0 0 1 .132-.061c.05 0 .092.02.127.058Zm.283.463-.241-.041a.198.198 0 0 1-.06.103.148.148 0 0 1-.096.032.184.184 0 0 1-.142-.062.259.259 0 0 1-.06-.174h.612c.003-.194-.034-.337-.114-.43a.403.403 0 0 0-.324-.14.388.388 0 0 0-.302.133.535.535 0 0 0-.12.37c0 .132.03.241.09.328.078.108.196.162.357.162a.426.426 0 0 0 .253-.072.408.408 0 0 0 .147-.209Zm.77-.197c-.032.011-.081.024-.148.039a.436.436 0 0 0-.132.044.106.106 0 0 0-.048.088.13.13 0 0 0 .135.13.205.205 0 0 0 .125-.045.157.157 0 0 0 .058-.083.517.517 0 0 0 .01-.123v-.05Zm-.328-.205-.219-.041a.356.356 0 0 1 .128-.204.457.457 0 0 1 .27-.066c.109 0 .19.013.243.04.053.026.09.06.112.1.021.042.032.117.032.226l-.002.293c0 .083.003.144.011.184.008.04.023.082.044.127H28.9a.904.904 0 0 1-.031-.102.44.44 0 0 1-.134.094.37.37 0 0 1-.15.032.307.307 0 0 1-.224-.08.27.27 0 0 1-.082-.201c0-.054.013-.101.037-.143a.247.247 0 0 1 .105-.097.806.806 0 0 1 .193-.059c.114-.021.192-.042.236-.061v-.026c0-.048-.011-.083-.035-.104-.023-.02-.066-.031-.13-.031a.171.171 0 0 0-.103.026.184.184 0 0 0-.059.093Zm-2.73-6.606.837 2.965h-1.648l.812-2.965ZM24.6 13.659h2.387l.34 1.182h1.81L27.116 8h-2.693l-1.994 6.841h1.848l.32-1.182Z" clip-rule="evenodd"/>\n  <path fill="#FFBE00" fill-rule="evenodd" d="M15.092 8.962c.736 0 1.393.35 1.825.898l.385-.85a3.32 3.32 0 0 0-2.325-.95c-1.407 0-2.61.877-3.104 2.117h-.75l-.444.98h.966a3.46 3.46 0 0 0 .004.608h-.485l-.443.98h1.175a3.346 3.346 0 0 0 3.081 2.057c.698 0 1.346-.215 1.882-.584v-1.2a2.317 2.317 0 0 1-1.767.827 2.335 2.335 0 0 1-1.97-1.1h2.462l.443-.98H12.76a2.56 2.56 0 0 1-.014-.608H16.3l.443-.98h-3.69a2.341 2.341 0 0 1 2.038-1.215Z" clip-rule="evenodd"/>\n  <rect width="33" height="23" x=".5" y=".5" stroke="#F2F4F7" rx="3.5"/>\n</svg>\n';
const sofort = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 34 24" height="100%">\n  <rect width="33" height="23" x=".5" y=".5" fill="#F884A1" rx="3.5"/>\n  <path fill="#fff" fill-rule="evenodd" d="m19.784 9.436.94-4.818a1.067 1.067 0 0 0-.719-1.243c-.581-.15-1.167.2-1.316.79l-.852 3.001-.671-2.955a1.07 1.07 0 0 0-.445-.678 1.017 1.017 0 0 0-.787-.154c-.533.117-.88.757-.747 1.339l.396 3.348c-.344-.353-.746-.462-1.212-.184l-.06.041c-.425.298-.511.906-.238 1.46a.918.918 0 0 0-.614.286l-.04.046c-.393.416-.316 1.118.173 1.621l.397.408c.044 1.882 1.532 3.201 3.286 3.201.02 0 .04-.003.06-.008 2.376-.025 3.42-1.482 3.599-3.692.056-.698-.069-1.176-.331-1.463-.146-.158-.3-.233-.416-.25l-.403-.096Zm-.425-.102.937-4.807a.621.621 0 0 0-.408-.72.647.647 0 0 0-.78.479l-1.086 3.833a.217.217 0 0 1-.27.154.22.22 0 0 1-.158-.205l-.856-3.766a.626.626 0 0 0-.259-.395.59.59 0 0 0-.456-.087c-.283.062-.493.453-.408.802l.004.025.49 4.154.307.473a.915.915 0 0 1 .56-.365c.194-.042.392-.038.582-.005.047.007.083.017.103.023l.01.002 1.688.405Zm-3.136.45-.482-.74a.222.222 0 0 1-.04-.061l-.227-.349c-.279-.42-.55-.565-.873-.374l-.044.033c-.25.18-.283.603-.024 1.01l.953 1.46c.17.258.509.324.76.15l.048-.03a.519.519 0 0 0 .162-.178c-.24-.252-.299-.564-.233-.92Zm.674.728a.221.221 0 0 0-.108-.088c-.182-.18-.19-.406-.104-.7.065-.217.19-.329.388-.375.13-.029.27-.025.408 0l.04.008c.02.004.033.006.04.009l2.545.611.048.017a.41.41 0 0 1 .13.095c.17.187.266.54.218 1.123-.166 2.037-1.087 3.3-3.275 3.28a.214.214 0 0 0-.037.003c-1.326-.036-2.448-.928-2.71-2.246l.327.335a.966.966 0 0 0 1.39-.021l.044-.046c.301-.323.353-.8.157-1.177a1.02 1.02 0 0 0 .085-.053l.049-.034a.991.991 0 0 0 .273-.29c.147.08.324.149.535.207l.61.146c-.453.262-.736.748-.768 1.492a.221.221 0 0 0 .206.237.223.223 0 0 0 .23-.212c.033-.673.287-1.035.695-1.193.218-.083.456-.1.666-.079l.053.008c.278.054.367-.374.089-.44l-1.676-.387a1.895 1.895 0 0 1-.548-.23Zm-3.123-.527a.484.484 0 0 1 .637-.061l.711 1.092a.976.976 0 0 0 .831.444.57.57 0 0 1-.031.745l-.04.046a.531.531 0 0 1-.768.008l-1.211-1.234c-.335-.345-.38-.77-.17-.994l.04-.046Zm-1.616 9.18c0 .694-.525 1.168-1.211 1.168-.481 0-.893-.225-1.147-.582l.472-.486c.141.187.376.39.683.39.286 0 .484-.174.484-.457 0-.3-.234-.374-.601-.482-.675-.204-.95-.566-.95-1.035 0-.59.437-1.098 1.123-1.098.432 0 .832.208 1.01.611l-.57.37c-.109-.183-.258-.303-.46-.303-.238 0-.388.166-.388.378 0 .254.218.333.566.437.545.166.99.444.99 1.089Zm.246-.158c0 .727.59 1.326 1.317 1.326s1.316-.599 1.316-1.326c0-.728-.59-1.326-1.316-1.326-.727 0-1.317.598-1.317 1.326Zm1.317.66c.351 0 .63-.286.63-.66 0-.374-.279-.661-.63-.661-.356 0-.63.287-.63.66 0 .38.278.662.63.662Zm3.017-3.038v.665c-.384-.017-.663.183-.663.623v.27c.154-.166.372-.249.642-.249v.674c-.38.008-.642.258-.642.607v1.047h-.686v-2.39c0-.674.412-1.247 1.248-1.247h.1Zm1.498 3.704a1.325 1.325 0 0 1-1.317-1.326c0-.728.59-1.326 1.317-1.326s1.316.598 1.316 1.326c0 .727-.59 1.326-1.316 1.326Zm.63-1.326c0 .374-.275.66-.63.66-.351 0-.63-.282-.63-.66 0-.374.279-.661.63-.661s.63.287.63.66Zm1.724-.969v-.287h-.666v2.515h.687V19.12c0-.416.238-.648.65-.648v-.757c-.311-.013-.533.095-.67.324Zm1.753.328v.616c0 .44.279.636.663.623v.666h-.102c-.84 0-1.247-.574-1.247-1.248v-2.078h.686v.395c0 .34.27.598.642.607v.669c-.274 0-.488-.083-.642-.25Zm1.482 1.942a.47.47 0 0 0 .46-.474.47.47 0 0 0-.46-.474.467.467 0 0 0-.46.474c0 .262.206.474.46.474Z" clip-rule="evenodd"/>\n  <rect width="33" height="23" x=".5" y=".5" stroke="#F2F4F7" rx="3.5"/>\n</svg>\n';
const stripe = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 34 24" height="100%">\n  <rect width="33" height="23" x=".5" y=".5" fill="#fff" rx="3.5"/>\n  <path fill="#6461FC" fill-rule="evenodd" d="m18.268 8.142-1.727.381V7.082l1.727-.374v1.434Zm3.592.798c-.674 0-1.108.325-1.349.552l-.09-.439h-1.513v8.24l1.72-.375.007-2c.248.184.612.445 1.218.445 1.232 0 2.353-1.017 2.353-3.257-.006-2.05-1.142-3.166-2.346-3.166Zm-.413 4.869c-.406 0-.647-.148-.812-.332l-.007-2.622c.18-.205.427-.346.82-.346.625 0 1.059.72 1.059 1.646 0 .947-.427 1.654-1.06 1.654Zm8.182-1.632c0-1.81-.854-3.237-2.484-3.237-1.638 0-2.629 1.428-2.629 3.223 0 2.126 1.17 3.2 2.849 3.2.819 0 1.438-.19 1.906-.459v-1.413c-.468.24-1.005.389-1.686.389-.668 0-1.26-.24-1.335-1.075h3.365l.005-.229c.004-.138.009-.302.009-.4Zm-3.4-.672c0-.798.475-1.13.909-1.13.42 0 .867.332.867 1.13h-1.776Zm-9.688-2.444h1.727v6.182h-1.727V9.061Zm-1.961 0 .11.522c.406-.763 1.211-.607 1.431-.522v1.625c-.213-.078-.901-.177-1.307.367v4.19h-1.72V9.061h1.486Zm-3.33-1.534-1.68.368-.006 5.66c0 1.045.764 1.816 1.782 1.816.564 0 .977-.107 1.204-.234v-1.434c-.22.092-1.307.417-1.307-.629v-2.508h1.307V9.06h-1.307l.006-1.533Zm-4.067 2.947c-.365 0-.585.106-.585.381 0 .301.379.434.85.598.766.267 1.774.62 1.779 1.925 0 1.265-.984 1.992-2.416 1.992-.591 0-1.238-.12-1.878-.402v-1.682c.578.325 1.307.565 1.878.565.386 0 .66-.106.66-.43 0-.334-.41-.486-.906-.67-.755-.28-1.708-.634-1.708-1.81 0-1.252.93-2 2.326-2 .571 0 1.135.091 1.706.324v1.661a3.758 3.758 0 0 0-1.706-.452Z" clip-rule="evenodd"/>\n  <rect width="33" height="23" x=".5" y=".5" stroke="#F2F4F7" rx="3.5"/>\n</svg>\n';
const visa = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 34 24" height="100%">\n  <rect width="33" height="23" x=".5" y=".5" fill="#fff" rx="3.5"/>\n  <path fill="#172B85" fill-rule="evenodd" d="M10.75 15.858H8.69L7.147 9.792c-.073-.279-.229-.525-.458-.642A6.573 6.573 0 0 0 4.8 8.51v-.234h3.318c.458 0 .802.35.859.758l.801 4.376 2.059-5.134h2.002l-3.089 7.583Zm4.234 0H13.04l1.602-7.583h1.945l-1.602 7.583Zm4.119-5.482c.057-.409.4-.642.801-.642a3.535 3.535 0 0 1 1.888.35l.344-1.633a4.8 4.8 0 0 0-1.774-.35c-1.888 0-3.262 1.05-3.262 2.507 0 1.11.973 1.692 1.66 2.042.743.35 1.03.584.972.934 0 .524-.572.758-1.143.758a4.788 4.788 0 0 1-2.003-.467l-.343 1.634c.687.29 1.43.408 2.117.408 2.117.058 3.432-.992 3.432-2.567 0-1.983-2.69-2.1-2.69-2.974Zm9.497 5.482-1.545-7.583h-1.659a.862.862 0 0 0-.8.583l-2.861 7h2.002l.4-1.108h2.46l.23 1.108H28.6Zm-2.917-5.54.571 2.857h-1.602l1.03-2.858Z" clip-rule="evenodd"/>\n  <rect width="33" height="23" x=".5" y=".5" stroke="#F2F4F7" rx="3.5"/>\n</svg>\n';
const svgByPaymentMethod = {
  amex,
  "apple-pay": applePay,
  "google-pay": googlePay,
  klarna,
  mastercard,
  paypal,
  sepa,
  sofort,
  stripe,
  visa
};
const getSvgStringByPaymentMethod = (paymentMethod) => {
  const svg = svgByPaymentMethod[paymentMethod];
  if (svg) return svg;
  throw new Error(`Payment method ${paymentMethod} is not supported`);
};
var __defProp$v = Object.defineProperty;
var __decorateClass$v = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$v(target, key, result);
  return result;
};
const _PaymentMethodIcon = class _PaymentMethodIcon extends h {
  constructor() {
    super(...arguments);
    this.size = "m";
  }
  get svg() {
    return getSvgStringByPaymentMethod(this.name);
  }
  render() {
    return ke$1` <div class="zw-payment-method-icon">${fe(this.svg)}</div> `;
  }
};
_PaymentMethodIcon.styles = [r$3(baseStyles), r$3(styles$z)];
let PaymentMethodIcon = _PaymentMethodIcon;
__decorateClass$v([
  n$1({ reflect: true })
], PaymentMethodIcon.prototype, "name");
__decorateClass$v([
  n$1({ reflect: true })
], PaymentMethodIcon.prototype, "size");
var __defProp$u = Object.defineProperty;
var __decorateClass$u = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$u(target, key, result);
  return result;
};
const HintElement$4 = HintMixin(h);
const ErrorElement$4 = ErrorMixin(HintElement$4);
const LabeledElement$3 = LabelMixin(ErrorElement$4);
const InputElement$1 = InputMixin(LabeledElement$3);
const _TextField = class _TextField extends InputElement$1 {
  constructor() {
    super();
    this.onKeyUp = (event) => {
      const { form } = this.internals;
      if (form && event.key === Key.Enter) {
        form.requestSubmit();
      }
    };
    this.inputId = getUniqueId("zw-text-field");
    this.color = "primary";
    this.size = "m";
    this.paymentMethod = "";
    this.disabled = false;
    this.required = false;
    this.readonly = false;
    this.type = "text";
    this.value = "";
    defineCustomElementOnce("zw-icon", Icon);
    defineCustomElementOnce("zw-payment-method-icon", PaymentMethodIcon);
    defineCustomElementOnce("zw-button", Button);
  }
  render() {
    return ke$1`
      <div
        class="zw-text-field"
        ?data-errored=${this.errored}
        ?data-has-icon=${this.icon && !this.paymentMethod}
        ?data-has-payment-method=${this.paymentMethod}
      >
        ${this.labelHtml({
      forId: this.inputId,
      required: this.required,
      size: this.size,
      disabled: this.disabled
    })}
        <div class="zw-text-field--input-container">
          ${this.beforeInputHtml()} ${this.inputHtml()} ${this.afterInputHTML()}
        </div>
        ${this.hintHTML({ showErrorMessage: this.showErrorMessage })} ${this.errorMessageHTML()}
      </div>
    `;
  }
  beforeInputHtml() {
    if (this.paymentMethod) return this.paymentMethodIconHtml();
    if (this.icon) return this.iconHtml();
    return null;
  }
  paymentMethodIconHtml() {
    return ke$1`<zw-payment-method-icon
      class="zw-text-field--payment-method-icon"
      size=${this.size}
      name=${this.paymentMethod}
    ></zw-payment-method-icon>`;
  }
  iconHtml() {
    return ke$1`<zw-icon
      name=${this.icon}
      class="zw-text-field--icon"
      size=${this.size}
    ></zw-icon>`;
  }
  inputHtml() {
    return ke$1` <input
      type=${this.type}
      id=${this.inputId}
      class="zw-text-field--input"
      .value=${this.value}
      autocapitalize=${to(this.autocapitalize || void 0)}
      autocomplete=${to(this.autocomplete || void 0)}
      min=${to(this.min || void 0)}
      max=${to(this.max || void 0)}
      minlength=${to(this.minlength || void 0)}
      maxlength=${to(this.maxlength || void 0)}
      pattern=${to(this.pattern || void 0)}
      placeholder=${to(this.placeholder || void 0)}
      ?disabled=${this.disabled}
      ?required=${this.required}
      ?readonly=${this.readonly}
      @input="${this.handleInput}"
      @change="${this.handleChangeEvent}"
      @keyup="${this.onKeyUp}"
    />`;
  }
  afterInputHTML() {
    const afterInputHTML = this.afterInputSlotHTML();
    const errorIconHtml = this.errorIconHTML({ size: this.size, disabled: this.disabled });
    const emptySlot = this.querySelector("[slot=after-input]") === null;
    if (!afterInputHTML && !errorIconHtml && emptySlot) return null;
    return ke$1` <div class="zw-text-field--trailing-icons-container">
      <slot name="after-input">${afterInputHTML}</slot> ${errorIconHtml}
    </div>`;
  }
  afterInputSlotHTML() {
    if (this.type !== "search") return null;
    if (this.disabled) return null;
    if (!this.value || !this.value.length) return null;
    return ke$1`<zw-button
      style="--zw-button-padding-block: 0; --zw-button-padding-inline: 0;"
      class="zw-text-field--reset-button"
      size="xs"
      color="neutral"
      variant="ghost"
      aria-label=${to(this.resetButtonLabel)}
      icon-only
      @click=${this.resetInput}
    >
      <zw-icon name="clear" size=${this.size}></zw-icon>
    </zw-button>`;
  }
  handleInput() {
    const { input } = this;
    if (!input) return;
    const { value } = input;
    this.value = value;
    if (this.internals.setFormValue) this.internals.setFormValue(value);
    if (this.internals.setValidity)
      this.internals.setValidity(input.validity, input.validationMessage, input);
  }
  resetInput(event) {
    event.preventDefault();
    event.stopPropagation();
    const { input } = this;
    if (!input) return;
    input.value = "";
    input.focus();
    const inputEvent = new InputEvent("input", { bubbles: true, composed: true });
    input.dispatchEvent(inputEvent);
  }
  handleChangeEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    const { input } = this;
    if (!input) return;
    const changeEvent = new Event("change", { bubbles: true, composed: true });
    this.dispatchEvent(changeEvent);
  }
};
_TextField.styles = [
  r$3(baseStyles),
  r$3(styles$A),
  HintElement$4.styles,
  ErrorElement$4.styles,
  LabeledElement$3.styles,
  InputElement$1.styles
];
_TextField.formAssociated = true;
let TextField = _TextField;
__decorateClass$u([
  e$2("input")
], TextField.prototype, "input");
__decorateClass$u([
  n$1({ reflect: true })
], TextField.prototype, "color");
__decorateClass$u([
  n$1({ reflect: true, attribute: "reset-button-label" })
], TextField.prototype, "resetButtonLabel");
__decorateClass$u([
  n$1({ reflect: true })
], TextField.prototype, "size");
__decorateClass$u([
  n$1({ reflect: true })
], TextField.prototype, "icon");
__decorateClass$u([
  n$1({ reflect: true, attribute: "payment-method" })
], TextField.prototype, "paymentMethod");
__decorateClass$u([
  n$1()
], TextField.prototype, "autocomplete");
__decorateClass$u([
  n$1({ type: Boolean })
], TextField.prototype, "disabled");
__decorateClass$u([
  n$1()
], TextField.prototype, "min");
__decorateClass$u([
  n$1()
], TextField.prototype, "max");
__decorateClass$u([
  n$1()
], TextField.prototype, "minlength");
__decorateClass$u([
  n$1()
], TextField.prototype, "maxlength");
__decorateClass$u([
  n$1()
], TextField.prototype, "pattern");
__decorateClass$u([
  n$1()
], TextField.prototype, "placeholder");
__decorateClass$u([
  n$1({ type: Boolean })
], TextField.prototype, "required");
__decorateClass$u([
  n$1({ type: Boolean })
], TextField.prototype, "readonly");
__decorateClass$u([
  n$1()
], TextField.prototype, "type");
__decorateClass$u([
  n$1()
], TextField.prototype, "value");
var __defProp$t = Object.defineProperty;
var __decorateClass$t = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$t(target, key, result);
  return result;
};
class DatetimeField extends TextField {
  constructor() {
    super(...arguments);
    this.type = "datetime-local";
  }
}
__decorateClass$t([
  n$1({ reflect: true })
], DatetimeField.prototype, "type");
const styles$y = ':host {\n  display: block;\n}\n\n:host([orientation="vertical"]) {\n  block-size: 100%;\n}\n\n:host([size="s"]) {\n  /* 1px */\n  --zw-divider-size: 0.0625rem;\n}\n\n:host([size="m"]) {\n  /* 2px */\n  --zw-divider-size: var(--zw-spacing-2);\n}\n\n:host([size="l"]) {\n  /* 3px */\n  --zw-divider-size: 0.1875rem;\n}\n\n:host([color="primary"]) {\n  --zw-divider-color: var(--zw-color-primary);\n}\n\n:host([color="on-surface"]) {\n  --zw-divider-color: var(--zw-color-on-surface);\n}\n\n:host([color="outline"]) {\n  --zw-divider-color: var(--zw-color-outline);\n}\n\n:host([color="outline-variant-high"]) {\n  --zw-divider-color: var(--zw-color-outline);\n}\n\n:host([color="outline-variant-low"]) {\n  --zw-divider-color: var(--zw-color-outline);\n}\n\n.zw-divider {\n  inline-size: var(--zw-divider-inline-size, 100%);\n  block-size: var(--zw-divider-block-size, 100%);\n  background-color: var(--zw-divider-color);\n}\n\n.zw-divider[aria-orientation="horizontal"] {\n    --zw-divider-block-size: var(--zw-divider-size);\n  }\n\n.zw-divider[aria-orientation="vertical"] {\n    --zw-divider-inline-size: var(--zw-divider-size);\n  }\n';
var __defProp$s = Object.defineProperty;
var __decorateClass$s = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$s(target, key, result);
  return result;
};
const _Divider = class _Divider extends h {
  constructor() {
    super(...arguments);
    this.color = "primary";
    this.orientation = "horizontal";
    this.size = "m";
  }
  render() {
    return ke$1`
      <div class="zw-divider" role="separator" aria-orientation="${this.orientation}"></div>
    `;
  }
};
_Divider.styles = [r$3(baseStyles), r$3(styles$y)];
let Divider = _Divider;
__decorateClass$s([
  n$1({ reflect: true })
], Divider.prototype, "color");
__decorateClass$s([
  n$1({ reflect: true })
], Divider.prototype, "orientation");
__decorateClass$s([
  n$1({ reflect: true })
], Divider.prototype, "size");
const preventScrolling = () => {
  const body = document.querySelector("body");
  if (body) {
    body.style.overflow = "hidden";
    body.style.scrollbarGutter = "stable";
  }
};
const allowScrolling = () => {
  const body = document.querySelector("body");
  if (body) {
    body.style.overflow = "initial";
    body.style.scrollbarGutter = "initial";
  }
};
const styles$x = ':host {\n  --zw-drawer-box-shadow-right: inset -1px 0 0 0 var(--zw-color-surface-container-highest);\n  --zw-drawer-box-shadow-left: inset 1px 0 0 0 var(--zw-color-surface-container-highest);\n  --zw-drawer-inline-size: 19.375rem;\n\n  display: block;\n}\n\n:host([color="primary"]) {\n  --zw-drawer-color: var(--zw-color-primary-container);\n}\n\n:host([color="neutral"]) {\n  --zw-drawer-color: var(--zw-color-surface);\n}\n\n.zw-drawer {\n  inset: unset;\n  inset-block: 0;\n  inline-size: var(--zw-drawer-inline-size);\n  block-size: 100%;\n  max-block-size: 100%;\n  border: none;\n  padding: 0;\n  background-color: var(--zw-drawer-color);\n}\n\n.zw-drawer[open][data-position="left"] {\n      animation: fade-in-from-left var(--zw-animation-duration-default) forwards;\n    }\n\n.zw-drawer[open][data-position="right"] {\n      animation: fade-in-from-right var(--zw-animation-duration-default) forwards;\n    }\n\n.zw-drawer[open]::backdrop {\n      animation: fade-in var(--zw-animation-duration-default) forwards;\n    }\n\n.zw-drawer[data-position="left"] {\n    inset-inline-start: 0;\n    box-shadow: var(--zw-drawer-box-shadow-right);\n  }\n\n.zw-drawer[data-position="right"] {\n    inset-inline-end: 0;\n    box-shadow: var(--zw-drawer-box-shadow-left);\n  }\n\n.zw-drawer::backdrop {\n    background-color: var(--zw-color-transparent-transparent-on-surface-9);\n  }\n';
var __defProp$r = Object.defineProperty;
var __decorateClass$r = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$r(target, key, result);
  return result;
};
const _Drawer = class _Drawer extends h {
  constructor() {
    super(...arguments);
    this.open = false;
    this.position = "left";
    this.disableScrollPrevention = false;
  }
  getTrigger() {
    return this.triggerSlotElements[0];
  }
  firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    if (this.open) {
      this.openDrawer();
    }
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has("open")) {
      if (this.open) {
        this.openDrawer();
      } else {
        this.closeDrawer();
      }
    }
  }
  onBackdropClick(event) {
    if (event.target !== this.drawer) return;
    const rect = this.drawer.getBoundingClientRect();
    const clickInsideDialog = rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width;
    if (clickInsideDialog === false) this.closeDrawer();
  }
  handleTriggerKeydown(event) {
    if (event.key === Key.Enter || event.key === Key.Space) {
      this.openDrawer();
    }
  }
  handleDrawerKeydown(event) {
    if (this.open && event.key === Key.Escape) {
      this.closeDrawer();
    }
  }
  openDrawer() {
    this.drawer.showModal();
    if (!this.disableScrollPrevention) preventScrolling();
    this.open = true;
  }
  closeDrawer() {
    this.drawer.close();
    if (!this.disableScrollPrevention) allowScrolling();
    this.open = false;
  }
  render() {
    return ke$1`
      ${this.triggerHTML()}
      <dialog
        class="zw-drawer"
        data-position=${this.position}
        @keydown=${this.handleDrawerKeydown}
        @click=${this.onBackdropClick}
      >
        <slot></slot>
      </dialog>
    `;
  }
  triggerHTML() {
    if (!hasSlotContent(this, "trigger")) return null;
    return ke$1`
      <slot name="trigger" @click=${this.openDrawer} @keydown=${this.handleTriggerKeydown}></slot>
    `;
  }
};
_Drawer.styles = [r$3(baseStyles), r$3(animations), r$3(styles$x)];
let Drawer = _Drawer;
__decorateClass$r([
  n$1({ reflect: true })
], Drawer.prototype, "color");
__decorateClass$r([
  n$1({ type: Boolean, reflect: true })
], Drawer.prototype, "open");
__decorateClass$r([
  n$1({ reflect: true })
], Drawer.prototype, "position");
__decorateClass$r([
  n$1({ reflect: true, type: Boolean, attribute: "disable-scroll-prevention" })
], Drawer.prototype, "disableScrollPrevention");
__decorateClass$r([
  e$2(".zw-drawer")
], Drawer.prototype, "drawer");
__decorateClass$r([
  o({ slot: "trigger" })
], Drawer.prototype, "triggerSlotElements");
const styles$w = '.zw-dropdown {\n  display: inline-block;\n}\n\n::slotted([slot="trigger"]) {\n  display: inline-block;\n}\n';
const focusPreviousElement = (focusableElements, index) => {
  const previousFocusableElement = focusableElements[index - 1];
  if (previousFocusableElement) previousFocusableElement.focus();
  else focusableElements[focusableElements.length - 1].focus();
};
const focusNextElement = (focusableElements, index) => {
  const nextIndex = (index + 1) % focusableElements.length;
  focusableElements[nextIndex].focus();
};
const focusFirstElement = (focusableElements) => {
  const firstFocusableElement = focusableElements[0];
  if (firstFocusableElement) firstFocusableElement.focus();
};
const focusLastElement = (focusableElements) => {
  const lastFocusableElement = focusableElements[focusableElements.length - 1];
  if (lastFocusableElement) lastFocusableElement.focus();
};
const handleFocusableElements = (event, focusableElements) => {
  const { key } = event;
  const currentlyFocusableElements = focusableElements.filter(
    (element) => !element.hasAttribute("disabled") || element.getAttribute("disabled") === "false"
  );
  const index = currentlyFocusableElements.findIndex((element) => element === event.target);
  switch (key) {
    case "ArrowLeft":
    case "ArrowUp": {
      event.preventDefault();
      focusPreviousElement(currentlyFocusableElements, index);
      break;
    }
    case "ArrowRight":
    case "ArrowDown": {
      event.preventDefault();
      focusNextElement(currentlyFocusableElements, index);
      break;
    }
    case "Home": {
      event.preventDefault();
      focusFirstElement(currentlyFocusableElements);
      break;
    }
    case "End": {
      event.preventDefault();
      focusLastElement(currentlyFocusableElements);
      break;
    }
  }
};
const useKeyboardHandler = (dropdown) => {
  const onMenuKeyDown = (event) => {
    if ((event.key === Key.Tab || event.key === Key.Escape) && dropdown.isOpen()) {
      dropdown.close({ focusTrigger: event.key === Key.Escape });
    }
  };
  const onTriggerKeyDown = (event) => {
    var _a2;
    if (event.key === Key.ArrowDown) {
      if (dropdown.isOpen()) {
        (_a2 = dropdown.items()[0]) == null ? void 0 : _a2.focus();
      }
    }
  };
  const setupEventHandling = () => {
    var _a2;
    (_a2 = dropdown.menu) == null ? void 0 : _a2.addEventListener("keydown", onMenuKeyDown);
    dropdown.getTrigger().addEventListener("keydown", onTriggerKeyDown);
    const items = dropdown.items();
    items.forEach((item) => {
      item.setAttribute("tabindex", "-1");
      item.addEventListener("keydown", (event) => {
        handleFocusableElements(event, items);
      });
    });
  };
  return {
    setupEventHandling
  };
};
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v2) => ({
  x: v2,
  y: v2
});
const oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
const oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  return ["top", "bottom"].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ["left", "right"];
  const rl = ["right", "left"];
  const tb = ["top", "bottom"];
  const bt2 = ["bottom", "top"];
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case "left":
    case "right":
      return isStart ? tb : bt2;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list = list.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x: x2,
    y: y2,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y2,
    left: x2,
    right: x2 + width,
    bottom: y2 + height,
    x: x2,
    y: y2
  };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x: x2,
    y: y2
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i3 = 0; i3 < validMiddleware.length; i3++) {
    const {
      name,
      fn
    } = validMiddleware[i3];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x: x2,
      y: y2,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x2 = nextX != null ? nextX : x2;
    y2 = nextY != null ? nextY : y2;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x: x2,
          y: y2
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i3 = -1;
    }
  }
  return {
    x: x2,
    y: y2,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x: x2,
    y: y2,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x: x2,
    y: y2,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
const arrow$1 = (options) => ({
  name: "arrow",
  options,
  async fn(state) {
    const {
      x: x2,
      y: y2,
      placement,
      rects,
      platform: platform2,
      elements,
      middlewareData
    } = state;
    const {
      element,
      padding = 0
    } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x: x2,
      y: y2
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform2.getDimensions(element);
    const isYAxis = axis === "y";
    const minProp = isYAxis ? "top" : "left";
    const maxProp = isYAxis ? "bottom" : "right";
    const clientProp = isYAxis ? "clientHeight" : "clientWidth";
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
    if (!clientSize || !await (platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);
    const min$1 = minPadding;
    const max2 = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset2 = clamp(min$1, center, max2);
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset2 && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max2 : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset2,
        centerOffset: center - offset2 - alignmentOffset,
        ...shouldAddOffset && {
          alignmentOffset
        }
      },
      reset: shouldAddOffset
    };
  }
});
const flip$1 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d2) => d2.overflows[0] <= 0).sort((a2, b2) => a2.overflows[1] - b2.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d2) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis(d2.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d2) => [d2.placement, d2.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a2, b2) => a2[1] - b2[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
async function convertValueToCoords(state, options) {
  const {
    placement,
    platform: platform2,
    elements
  } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = ["left", "top"].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...rawValue
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
const offset$1 = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x: x2,
        y: y2,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x2 + diffCoords.x,
        y: y2 + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
const shift$1 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    async fn(state) {
      const {
        x: x2,
        y: y2,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref) => {
            let {
              x: x3,
              y: y3
            } = _ref;
            return {
              x: x3,
              y: y3
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x: x2,
        y: y2
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x2,
          y: limitedCoords.y - y2
        }
      };
    }
  };
};
function hasWindow() {
  return typeof window !== "undefined";
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement$1(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !["inline", "contents"].includes(display);
}
function isTableElement(element) {
  return ["table", "td", "th"].includes(getNodeName(element));
}
function isTopLayer(element) {
  return [":popover-open", ":modal"].some((selector) => {
    try {
      return element.matches(selector);
    } catch (e2) {
      return false;
    }
  });
}
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css = isElement(elementOrCss) ? getComputedStyle(elementOrCss) : elementOrCss;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((value) => css[value] ? css[value] !== "none" : false) || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((value) => (css.willChange || "").includes(value)) || ["paint", "layout", "strict", "content"].some((value) => (css.contain || "").includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement$1(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports) return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node) {
  return ["html", "body", "#document"].includes(getNodeName(node));
}
function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement$1(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
function getCssDimensions(element) {
  const css = getComputedStyle(element);
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement$1(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement$1(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $: $2
  } = getCssDimensions(domElement);
  let x2 = ($2 ? round(rect.width) : rect.width) / width;
  let y2 = ($2 ? round(rect.height) : rect.height) / height;
  if (!x2 || !Number.isFinite(x2)) {
    x2 = 1;
  }
  if (!y2 || !Number.isFinite(y2)) {
    y2 = 1;
  }
  return {
    x: x2,
    y: y2
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x2 = (clientRect.left + visualOffsets.x) / scale.x;
  let y2 = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x2 *= iframeScale.x;
      y2 *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x2 += left;
      y2 += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x: x2,
    y: y2
  });
}
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
  if (ignoreScrollbarX === void 0) {
    ignoreScrollbarX = false;
  }
  const htmlRect = documentElement.getBoundingClientRect();
  const x2 = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : (
    // RTL <body> scrollbar.
    getWindowScrollBarX(documentElement, htmlRect)
  ));
  const y2 = htmlRect.top + scroll.scrollTop;
  return {
    x: x2,
    y: y2
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement$1(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll, true) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x2 = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y2 = -scroll.scrollTop;
  if (getComputedStyle(body).direction === "rtl") {
    x2 += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x: x2,
    y: y2
  };
}
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x2 = 0;
  let y2 = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x2 = visualViewport.offsetLeft;
      y2 = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x2,
    y: y2
  };
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement$1(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x2 = left * scale.x;
  const y2 = top * scale.y;
  return {
    width,
    height,
    x: x2,
    y: y2
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && ["absolute", "fixed"].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x2 = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y2 = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x: x2,
    y: y2,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement$1(element) || getComputedStyle(element).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement$1(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}
const getElementRects = async function(data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element) {
  return getComputedStyle(element).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function rectsAreEqual(a2, b2) {
  return a2.x === b2.x && a2.y === b2.y && a2.width === b2.width && a2.height === b2.height;
}
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const {
      left,
      top,
      width,
      height
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) {
        refresh();
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e2) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
const offset = offset$1;
const shift = shift$1;
const flip = flip$1;
const arrow = arrow$1;
const computePosition = (reference, floating, options) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};
const useToggleDropdown = (dropdown) => {
  let cleanup = () => {
  };
  const updatePosition2 = () => {
    if (!dropdown.menu) return;
    computePosition(dropdown.getTrigger(), dropdown.menu, {
      placement: "bottom-start",
      middleware: [offset(12), flip()],
      strategy: "fixed"
    }).then(({ x: x2, y: y2 }) => {
      dropdown.setMenuPosition(x2, y2);
    });
  };
  let removeClickOutsideHandler = () => {
  };
  const onClickOutside = (event) => {
    if (!dropdown.menu) return;
    if (event.composedPath().includes(dropdown.menu) || event.composedPath().includes(dropdown.getTrigger()))
      return;
    dropdown.close();
  };
  const open = (focusFirstItem) => {
    var _a2;
    if (!dropdown.menu) return;
    dropdown.setMenuVisibility(true);
    dropdown.getTrigger().setAttribute("aria-expanded", "true");
    if (focusFirstItem) (_a2 = dropdown.items()[0]) == null ? void 0 : _a2.focus();
    const clickOutsideHandler = onClickOutside.bind(dropdown);
    document.addEventListener("click", clickOutsideHandler);
    removeClickOutsideHandler = () => document.removeEventListener("click", clickOutsideHandler);
    cleanup = autoUpdate(dropdown.getTrigger(), dropdown.menu, updatePosition2.bind(dropdown));
  };
  const close = (options = { focusTrigger: false }) => {
    if (!dropdown.menu) return;
    dropdown.setMenuVisibility(false);
    dropdown.getTrigger().setAttribute("aria-expanded", "false");
    if (options.focusTrigger) dropdown.getTrigger().focus();
    cleanup();
    removeClickOutsideHandler();
  };
  const isOpen = () => {
    var _a2;
    return !((_a2 = dropdown.menu) == null ? void 0 : _a2.hidden);
  };
  const toggleDropdown = (focusFirstItemOnOpen) => {
    if (!dropdown.menu) return;
    if (!dropdown.isOpen()) {
      dropdown.open(focusFirstItemOnOpen);
    } else {
      dropdown.close();
    }
  };
  const setupToggleDropdown = () => {
    if (!dropdown.getTrigger()) return;
    dropdown.getTrigger().addEventListener("click", (event) => {
      const triggeredByKeyboard = event.detail === 0;
      toggleDropdown(triggeredByKeyboard);
    });
  };
  return {
    open,
    close,
    isOpen,
    setupToggleDropdown
  };
};
const addA11yAttributes = (dropdown) => {
  if (!dropdown.menu) return;
  const menuId = getUniqueId("menu");
  const triggerButton = dropdown.getTrigger();
  const menuWrapper = dropdown.menu;
  if (!menuWrapper) return;
  const triggerId = triggerButton.getAttribute("id") || getUniqueId("trigger");
  triggerButton.setAttribute("id", triggerId);
  triggerButton.setAttribute("aria-controls", menuId);
  triggerButton.setAttribute("aria-haspopup", "true");
  menuWrapper.setAttribute("id", menuId);
  menuWrapper.setAttribute("aria-labelledby", triggerId);
};
var __defProp$q = Object.defineProperty;
var __decorateClass$q = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$q(target, key, result);
  return result;
};
const _Dropdown = class _Dropdown extends h {
  constructor() {
    super();
    this.keyboardHandler = useKeyboardHandler(this);
    this.setupEventHandling = this.keyboardHandler.setupEventHandling;
    this.useToggleDropdown = useToggleDropdown(this);
    this.open = this.useToggleDropdown.open;
    this.close = this.useToggleDropdown.close;
    this.isOpen = this.useToggleDropdown.isOpen;
    this.setupToggleDropdown = this.useToggleDropdown.setupToggleDropdown;
    this.getTrigger = () => this.triggerSlotElements[0];
    this.setMenuVisibility = (visible) => {
      var _a2;
      (_a2 = this.menu) == null ? void 0 : _a2.toggleAttribute("hidden", !visible);
    };
    this.setMenuPosition = (x2, y2) => {
      if (!this.menu) return;
      this.menu.style.left = `${x2}px`;
      this.menu.style.top = `${y2}px`;
    };
    defineCustomElementOnce("zw-icon", Icon);
  }
  items() {
    var _a2;
    return Array.from(((_a2 = this.menu) == null ? void 0 : _a2.querySelectorAll("[data-dropdown-item]")) || []);
  }
  teleportMenu() {
    if (!this.menu || !this.target) return;
    const target = document.querySelector(this.target);
    if (!target) {
      console.warn(
        "Target for dropdown not found. Make sure the target attribute is set correctly."
      );
      return;
    }
    target.appendChild(this.menu);
  }
  disconnectedCallback() {
    var _a2;
    super.disconnectedCallback();
    this.close();
    (_a2 = this.menu) == null ? void 0 : _a2.remove();
  }
  setupDropdown() {
    if (!this.menu) return;
    this.setupEventHandling();
    this.setupToggleDropdown();
    addA11yAttributes(this);
    this.close();
  }
  handleMenuSlotChange(event) {
    const target = event == null ? void 0 : event.target;
    if (!target || this.menu !== void 0) return;
    this.menu = Array.from(target.assignedElements())[0];
    this.teleportMenu();
    this.setupDropdown();
  }
  render() {
    return ke$1`
      <div class="zw-dropdown">
        <slot name="trigger" @slotchange=${this.setupDropdown}> </slot>
        <slot name="menu" @slotchange=${this.handleMenuSlotChange}> </slot>
      </div>
    `;
  }
};
_Dropdown.styles = [r$3(baseStyles), r$3(styles$w)];
let Dropdown = _Dropdown;
__decorateClass$q([
  n$1()
], Dropdown.prototype, "target");
__decorateClass$q([
  o({ slot: "trigger" })
], Dropdown.prototype, "triggerSlotElements");
const styles$v = ".zw-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: var(--zw-spacing-8);\n  inline-size: 100%;\n  padding-block: var(--zw-spacing-8);\n  padding-inline: var(--zw-spacing-24);\n  font: var(--zw-typography-text-m-semibold);\n  background-color: var(--zw-color-surface-container-lowest);\n}\n.zw-dropdown-item:focus-visible {\n    outline: 2px solid var(--zw-color-on-surface);\n    outline-offset: -2px;\n    -webkit-text-decoration: none;\n    text-decoration: none;\n    background-color: var(--zw-color-states-surface-focus-press);\n  }\n.zw-dropdown-item:hover {\n    -webkit-text-decoration: none;\n    text-decoration: none;\n    background-color: var(--zw-color-states-surface-hover);\n  }\n.zw-dropdown-item:active {\n    -webkit-text-decoration: none;\n    text-decoration: none;\n    background-color: var(--zw-color-states-surface-focus-press);\n  }\n";
var __defProp$p = Object.defineProperty;
var __decorateClass$p = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$p(target, key, result);
  return result;
};
const _DropdownItem = class _DropdownItem extends BaseButton {
  constructor() {
    super();
    defineCustomElementOnce("zw-icon", Icon);
  }
  iconHTML() {
    if (this.icon) return ke$1`<zw-icon name="${this.icon}" variant="outlined" size="m"></zw-icon>`;
    return D;
  }
  innerComponentHTML() {
    return ke$1`
      ${this.iconHTML()}
      <slot> </slot>
    `;
  }
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("data-dropdown-item", "");
  }
  render() {
    if (this.href)
      return ke$1`<a href="${this.href}" class="zw-dropdown-item" role="menuitem">
        ${this.innerComponentHTML()}
      </a>`;
    return ke$1` <button
      type=${this.type}
      name=${to(this.name)}
      value=${to(this.value)}
      class="zw-dropdown-item"
      role="menuitem"
      @click=${this.handleClick}
      ${Kt(this.buttonRef)}
    >
      ${this.innerComponentHTML()}
    </button>`;
  }
};
_DropdownItem.styles = [r$3(baseStyles), r$3(styles$v)];
let DropdownItem = _DropdownItem;
__decorateClass$p([
  n$1()
], DropdownItem.prototype, "href");
__decorateClass$p([
  n$1()
], DropdownItem.prototype, "icon");
const styles$u = ":host {\n  display: block;\n}\n\n:host([divide]:not(:first-child)) {\n  border-block-start: 1px solid var(--zw-color-outline-variant-low);\n}\n\n.zw-dropdown-item-group--title {\n  inline-size: 100%;\n  padding-block: var(--zw-spacing-8);\n  padding-inline: var(--zw-spacing-24);\n  font: var(--zw-typography-text-s-regular);\n  color: var(--zw-color-on-surface-variant);\n  background-color: var(--zw-color-surface-container-lowest);\n}\n";
var __defProp$o = Object.defineProperty;
var __decorateClass$o = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$o(target, key, result);
  return result;
};
const _DropdownItemGroup = class _DropdownItemGroup extends h {
  constructor() {
    super(...arguments);
    this.title = "";
    this.labelHTML = () => this.title ? ke$1`<div class="zw-dropdown-item-group--title">${this.title}</div>` : null;
  }
  render() {
    return ke$1` <div class="zw-dropdown-item-group" role="group" ?data-divide=${this.divide}>
      ${this.labelHTML()}
      <slot></slot>
    </div>`;
  }
};
_DropdownItemGroup.styles = [r$3(baseStyles), r$3(styles$u)];
_DropdownItemGroup.shadowRootOptions = { ...h.shadowRootOptions };
let DropdownItemGroup = _DropdownItemGroup;
__decorateClass$o([
  n$1({ type: String })
], DropdownItemGroup.prototype, "title");
__decorateClass$o([
  n$1({ type: Boolean })
], DropdownItemGroup.prototype, "divide");
const styles$t = ":host {\n  display: block;\n  position: fixed;\n}\n\n.zw-dropdown-menu {\n  inline-size: -moz-fit-content;\n  inline-size: fit-content;\n  border-radius: var(--zw-border-radius-4);\n  box-shadow: var(--zw-elevation-bottom-m);\n}\n";
const _DropdownMenu = class _DropdownMenu extends h {
  render() {
    return ke$1`<div class="zw-dropdown-menu" role="menu"><slot></slot></div>`;
  }
};
_DropdownMenu.styles = [r$3(baseStyles), r$3(styles$t)];
_DropdownMenu.shadowRootOptions = { ...h.shadowRootOptions, delegatesFocus: true };
let DropdownMenu = _DropdownMenu;
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let s$2 = class s extends Event {
  constructor(s4, t2, e2, o2) {
    super("context-request", { bubbles: true, composed: true }), this.context = s4, this.contextTarget = t2, this.callback = e2, this.subscribe = o2 ?? false;
  }
};
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function n2(n3) {
  return n3;
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let s$1 = class s2 {
  constructor(t2, s4, i3, h2) {
    if (this.subscribe = false, this.provided = false, this.value = void 0, this.t = (t3, s5) => {
      this.unsubscribe && (this.unsubscribe !== s5 && (this.provided = false, this.unsubscribe()), this.subscribe || this.unsubscribe()), this.value = t3, this.host.requestUpdate(), this.provided && !this.subscribe || (this.provided = true, this.callback && this.callback(t3, s5)), this.unsubscribe = s5;
    }, this.host = t2, void 0 !== s4.context) {
      const t3 = s4;
      this.context = t3.context, this.callback = t3.callback, this.subscribe = t3.subscribe ?? false;
    } else this.context = s4, this.callback = i3, this.subscribe = h2 ?? false;
    this.host.addController(this);
  }
  hostConnected() {
    this.dispatchRequest();
  }
  hostDisconnected() {
    this.unsubscribe && (this.unsubscribe(), this.unsubscribe = void 0);
  }
  dispatchRequest() {
    this.host.dispatchEvent(new s$2(this.context, this.host, this.t, this.subscribe));
  }
};
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class s3 {
  get value() {
    return this.o;
  }
  set value(s4) {
    this.setValue(s4);
  }
  setValue(s4, t2 = false) {
    const i3 = t2 || !Object.is(s4, this.o);
    this.o = s4, i3 && this.updateObservers();
  }
  constructor(s4) {
    this.subscriptions = /* @__PURE__ */ new Map(), this.updateObservers = () => {
      for (const [s5, { disposer: t2 }] of this.subscriptions) s5(this.o, t2);
    }, void 0 !== s4 && (this.value = s4);
  }
  addCallback(s4, t2, i3) {
    if (!i3) return void s4(this.value);
    this.subscriptions.has(s4) || this.subscriptions.set(s4, { disposer: () => {
      this.subscriptions.delete(s4);
    }, consumerHost: t2 });
    const { disposer: h2 } = this.subscriptions.get(s4);
    s4(this.value, h2);
  }
  clearCallbacks() {
    this.subscriptions.clear();
  }
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class e extends Event {
  constructor(t2, s4) {
    super("context-provider", { bubbles: true, composed: true }), this.context = t2, this.contextTarget = s4;
  }
}
class i2 extends s3 {
  constructor(s4, e2, i3) {
    var _a2, _b;
    super(void 0 !== e2.context ? e2.initialValue : i3), this.onContextRequest = (t2) => {
      if (t2.context !== this.context) return;
      const s5 = t2.contextTarget ?? t2.composedPath()[0];
      s5 !== this.host && (t2.stopPropagation(), this.addCallback(t2.callback, s5, t2.subscribe));
    }, this.onProviderRequest = (s5) => {
      if (s5.context !== this.context) return;
      if ((s5.contextTarget ?? s5.composedPath()[0]) === this.host) return;
      const e3 = /* @__PURE__ */ new Set();
      for (const [s6, { consumerHost: i4 }] of this.subscriptions) e3.has(s6) || (e3.add(s6), i4.dispatchEvent(new s$2(this.context, i4, s6, true)));
      s5.stopPropagation();
    }, this.host = s4, void 0 !== e2.context ? this.context = e2.context : this.context = e2, this.attachListeners(), (_b = (_a2 = this.host).addController) == null ? void 0 : _b.call(_a2, this);
  }
  attachListeners() {
    this.host.addEventListener("context-request", this.onContextRequest), this.host.addEventListener("context-provider", this.onProviderRequest);
  }
  hostConnected() {
    this.host.dispatchEvent(new e(this.context, this.host));
  }
}
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function c({ context: c2, subscribe: e2 }) {
  return (o2, n3) => {
    "object" == typeof n3 ? n3.addInitializer(function() {
      new s$1(this, { context: c2, callback: (t2) => {
        o2.set.call(this, t2);
      }, subscribe: e2 });
    }) : o2.constructor.addInitializer((o3) => {
      new s$1(o3, { context: c2, callback: (t2) => {
        o3[n3] = t2;
      }, subscribe: e2 });
    });
  };
}
const FileUploadContext = n2("file-upload");
const styles$s = ':host {\n  display: inline-block;\n}\n\n.zw-file-drop-zone {\n  --file-drop-zone-border-color: var(--zw-color-outline);\n  --file-drop-zone-border-type: dashed;\n\n  inline-size: 100%;\n  border: 1px var(--file-drop-zone-border-type) var(--file-drop-zone-border-color);\n  border-radius: var(--zw-border-radius-4);\n  padding: var(--zw-spacing-24);\n}\n\n.zw-file-drop-zone:focus {\n    outline: 2px solid var(--file-drop-zone-border-color);\n    outline-offset: -2px;\n  }\n\n.zw-file-drop-zone:hover {\n    background-color: var(--file-drop-zone-interaction-background-color);\n  }\n\n.zw-file-drop-zone:disabled {\n    color: var(--zw-color-on-surface-variant);\n    background-color: var(--zw-color-surface-container);\n  }\n\n.zw-file-drop-zone[data-color="primary"] {\n    --file-drop-zone-interaction-background-color: var(--zw-color-primary-container);\n  }\n\n.zw-file-drop-zone[data-color="secondary"] {\n    --file-drop-zone-interaction-background-color: var(--zw-color-secondary-container);\n  }\n\n.zw-file-drop-zone[data-errored] {\n    --file-drop-zone-border-color: var(--zw-color-error);\n    --file-drop-zone-border-type: solid;\n    --file-drop-zone-interaction-background-color: var(--zw-color-error-container);\n  }\n\n.zw-file-drop-zone[data-dragover] {\n    --file-drop-zone-border-type: solid;\n\n    background-color: var(--file-drop-zone-interaction-background-color);\n  }\n';
const checkFileTypes = (items, accept) => {
  if (!accept) return true;
  const acceptRegexList = accept.split(",").map((entry) => new RegExp(entry.trim()));
  return items.every((item) => acceptRegexList.some((regex) => regex.test(item.type)));
};
const validateFileList = (dataTransfer, { multiple, accept }) => {
  const items = Array.from(dataTransfer.items || []);
  return (multiple || items.length <= 1) && checkFileTypes(items, accept);
};
var __defProp$n = Object.defineProperty;
var __decorateClass$n = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$n(target, key, result);
  return result;
};
const _FileDropZone = class _FileDropZone extends h {
  constructor() {
    super(...arguments);
    this.invalidFilesInDropZone = false;
    this.dragover = false;
    this.color = "primary";
    this.onDragLeave = (event) => {
      this.onDragEvent(event, () => {
        this.dragover = false;
        this.invalidFilesInDropZone = false;
      });
    };
    this.onDragOver = (event) => {
      this.onDragEvent(event, () => {
        const preventValidation = this.dragover || this.invalidFilesInDropZone;
        if (preventValidation) return;
        this.dragover = true;
        if (event.dataTransfer && !validateFileList(event.dataTransfer, this.contextForFileListValidation())) {
          this.invalidFilesInDropZone = true;
        }
      });
    };
  }
  onDragEvent(event, handleEvent) {
    if (this.fileUploadContext.disabled) return;
    event.preventDefault();
    if (handleEvent) handleEvent(event);
  }
  onDrop(event) {
    event.preventDefault();
    this.dragover = false;
    this.invalidFilesInDropZone = false;
    if (!event.dataTransfer || !validateFileList(event.dataTransfer, this.contextForFileListValidation()))
      return;
    this.dispatchFileDropEvent(event.dataTransfer.files);
  }
  contextForFileListValidation() {
    return {
      multiple: this.fileUploadContext.multiple,
      accept: this.fileUploadContext.accept
    };
  }
  dispatchFileDropEvent(files) {
    const event = new CustomEvent("file-drop", {
      detail: {
        files
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(event);
  }
  dispatchTriggerFileInputEvent() {
    const customEvent = new CustomEvent("trigger-file-input", { bubbles: true, composed: true });
    this.dispatchEvent(customEvent);
  }
  render() {
    return ke$1`
      <button
        type="button"
        data-color=${this.color}
        ?data-dragover=${this.dragover}
        ?data-errored=${this.fileUploadContext.errored || this.invalidFilesInDropZone}
        ?disabled=${this.fileUploadContext.disabled}
        class="zw-file-drop-zone"
        @drop=${this.onDrop}
        @dragenter=${this.onDragEvent}
        @dragleave=${this.onDragLeave}
        @dragover=${this.onDragOver}
        @click=${this.dispatchTriggerFileInputEvent}
        aria-label=${to(this.ariaLabel)}
      >
        <slot>${this.description}</slot>
      </button>
    `;
  }
};
_FileDropZone.styles = [r$3(baseStyles), r$3(styles$s)];
let FileDropZone = _FileDropZone;
__decorateClass$n([
  c({ context: FileUploadContext, subscribe: true })
], FileDropZone.prototype, "fileUploadContext");
__decorateClass$n([
  r()
], FileDropZone.prototype, "invalidFilesInDropZone");
__decorateClass$n([
  r()
], FileDropZone.prototype, "dragover");
__decorateClass$n([
  n$1()
], FileDropZone.prototype, "description");
__decorateClass$n([
  n$1()
], FileDropZone.prototype, "color");
const stackStyles = "/* stylelint-disable selector-max-universal, selector-max-combinators */\n.zw-stack {\n  --stack-spacing: var(--zw-spacing-24);\n\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n.zw-stack > * {\n    margin-block: 0;\n  }\n.zw-stack > * + * {\n    margin-block-start: var(--stack-spacing);\n  }\n";
const appendFormData = (files, formData, name) => {
  for (let i3 = 0; i3 < files.length; i3 += 1) {
    const file = files.item(i3);
    if (file) formData.append(name, file);
  }
};
const fileListToFormData = (files, name) => {
  const formData = new FormData();
  appendFormData(files, formData, name);
  return formData;
};
const mergeFileListAndFormData = (files, formData, name) => {
  const newFormData = new FormData();
  appendFormData(files, newFormData, name);
  Array.from(formData.entries()).forEach(([, value]) => {
    newFormData.append(name, value);
  });
  return newFormData;
};
const styles$r = "/* stylelint-disable no-empty-source */\n";
const getFilesFromFormData = (formData) => {
  const files = [];
  formData.forEach((value) => {
    if (value instanceof File) {
      files.push(value);
    }
  });
  return files;
};
const styles$q = ":host {\n  display: block;\n}\n\n:host(:empty) {\n  display: none;\n}\n\n.zw-file-upload-list {\n  --stack-spacing: var(--zw-spacing-12);\n}\n\n.zw-file-upload-list--item {\n  display: flex;\n  align-items: center;\n  gap: var(--zw-spacing-12);\n  border: 1px solid var(--zw-color-outline);\n  border-radius: var(--zw-border-radius-4);\n  padding: var(--zw-spacing-12);\n  background-color: var(--zw-color-surface-container-lowest);\n}\n\n.zw-file-upload-list--item-name {\n  overflow: hidden;\n  flex: 1;\n  font: var(--zw-typography-text-m-medium);\n  text-overflow: ellipsis;\n}\n";
var __defProp$m = Object.defineProperty;
var __decorateClass$m = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$m(target, key, result);
  return result;
};
const _FileUploadList = class _FileUploadList extends h {
  constructor() {
    super();
    this.removeAriaLabel = "Remove file";
    this.listItemHTML = (name, index) => ke$1`<li part="item" class="zw-file-upload-list--item">
      <zw-icon name="description"></zw-icon>
      <span part="item-name" class="zw-file-upload-list--item-name">${name}</span>
      <zw-button
        size="m"
        color="neutral"
        icon-only
        variant="icon-only"
        aria-label="${this.removeAriaLabel}"
        @click=${() => this.dispatchDeleteFileEvent(index)}
        ?disabled=${this.fileUploadContext.disabled}
      >
        <zw-icon name="close"></zw-icon>
      </zw-button>
    </li>`;
    defineCustomElementOnce("zw-button", Button);
    defineCustomElementOnce("zw-icon", Icon);
  }
  dispatchDeleteFileEvent(index) {
    const deleteEvent = new CustomEvent("delete-file", {
      detail: {
        index
      },
      bubbles: true
    });
    this.dispatchEvent(deleteEvent);
  }
  files() {
    var _a2;
    const formData = (_a2 = this.fileUploadContext) == null ? void 0 : _a2.value;
    if (!formData) return [];
    return getFilesFromFormData(formData);
  }
  render() {
    const files = this.files();
    if (files.length === 0) return D;
    return ke$1`<ul role="list" class="zw-stack | zw-file-upload-list">
      ${files.map((file, index) => this.listItemHTML(file.name, index))}
    </ul>`;
  }
};
_FileUploadList.styles = [r$3(baseStyles), r$3(stackStyles), r$3(styles$q)];
let FileUploadList = _FileUploadList;
__decorateClass$m([
  c({ context: FileUploadContext, subscribe: true })
], FileUploadList.prototype, "fileUploadContext");
__decorateClass$m([
  n$1({ reflect: true, attribute: "remove-aria-label" })
], FileUploadList.prototype, "removeAriaLabel");
var __defProp$l = Object.defineProperty;
var __decorateClass$l = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$l(target, key, result);
  return result;
};
const InputElement = InputMixin(h);
const HintElement$3 = HintMixin(InputElement);
const ErrorElement$3 = ErrorMixin(HintElement$3);
const LabeledElement$2 = LabelMixin(ErrorElement$3);
const _FileUpload = class _FileUpload extends LabeledElement$2 {
  constructor() {
    super();
    this.fileUploadContext = new i2(this, {
      context: FileUploadContext
    });
    this.value = null;
    this.required = false;
    this.multiple = false;
    this.color = "primary";
    this.inputId = getUniqueId("zw-file-upload");
    this.onDeleteFile = (event) => {
      if (!this.value) return;
      const fileIndex = event.detail.index;
      const files = getFilesFromFormData(this.value);
      const newFormData = new FormData();
      files.filter((_2, index) => index !== fileIndex).forEach((file) => {
        newFormData.append(this.name, file);
      });
      this.value = newFormData;
      this.dispatchChangeEvent();
    };
    this.triggerInput = () => {
      this.input.click();
    };
    this.onTriggerClick = (event) => {
      if (this.disabled) return;
      const { target } = event;
      if (target instanceof Element && target.hasAttribute("data-trigger-file-upload")) {
        this.triggerInput();
      }
    };
    this.onFileDrop = (event) => {
      const droppedFiles = event.detail.files;
      this.value = this.value ? mergeFileListAndFormData(droppedFiles, this.value, this.name) : fileListToFormData(droppedFiles, this.name);
      this.dispatchChangeEvent();
    };
    defineCustomElementOnce("zw-file-upload-list", FileUploadList);
    defineCustomElementOnce("zw-file-drop-zone", FileDropZone);
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("click", this.onTriggerClick);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener("click", this.onTriggerClick);
  }
  updateFormValue() {
    if (!this.value && this.internals.setFormValue) {
      this.internals.setFormValue(new File([], ""));
    } else {
      super.updateFormValue();
    }
    this.fileUploadContext.setValue({
      multiple: this.multiple,
      disabled: this.disabled,
      errored: this.errored,
      accept: this.accept,
      value: this.value
    });
  }
  // Overriding the method from the InputMixin
  // The file input element uses the files property instead of the value property
  updateInputValue() {
    if (!this.value) return;
    const files = getFilesFromFormData(this.value);
    const dt = new DataTransfer();
    files.forEach((entry) => {
      dt.items.add(entry);
    });
    this.input.files = dt.files;
  }
  dispatchChangeEvent() {
    this.dispatchEvent(
      new Event("change", {
        bubbles: true,
        composed: true
      })
    );
  }
  handleChange() {
    const { input } = this;
    if (!input.files) return;
    this.value = fileListToFormData(input.files, this.name);
    this.dispatchChangeEvent();
  }
  filesUploaded() {
    if (!this.value) return false;
    return getFilesFromFormData(this.value).length > 0;
  }
  render() {
    return ke$1`
      <div class="zw-file-upload">
        ${this.labelHtml({
      forId: this.inputId,
      required: this.required,
      size: "m",
      disabled: this.disabled
    })}
        ${this.inputHTML()} ${this.slotHTML()}
        ${this.hintHTML({ showErrorMessage: this.showErrorMessage })} ${this.errorMessageHTML()}
      </div>
    `;
  }
  inputHTML() {
    return ke$1`<input
      class="sr-only"
      id=${this.inputId}
      type="file"
      @change="${this.handleChange}"
      accept=${to(this.accept)}
      capture=${to(this.capture)}
      ?multiple=${this.multiple}
      ?required=${this.required}
      ?disabled=${this.disabled}
    />`;
  }
  defaultDropZoneHTML() {
    return ke$1`<div class="zw-stack">
      <zw-file-drop-zone
        description=${to(this.description)}
        color=${this.color}
      ></zw-file-drop-zone>
      ${this.filesUploaded() ? ke$1`<zw-file-upload-list></zw-file-upload-list>` : D}
    </div>`;
  }
  slotHTML() {
    return ke$1`<slot
      @delete-file=${this.onDeleteFile}
      @file-drop=${this.onFileDrop}
      @trigger-file-input=${this.triggerInput}
    >
      ${this.defaultDropZoneHTML()}
    </slot>`;
  }
};
_FileUpload.styles = [
  r$3(baseStyles),
  r$3(stackStyles),
  r$3(styles$r),
  HintElement$3.styles,
  ErrorElement$3.styles,
  LabeledElement$2.styles
];
let FileUpload = _FileUpload;
__decorateClass$l([
  e$2("input")
], FileUpload.prototype, "input");
__decorateClass$l([
  n$1()
], FileUpload.prototype, "value");
__decorateClass$l([
  n$1({ reflect: true, type: Boolean })
], FileUpload.prototype, "required");
__decorateClass$l([
  n$1({ reflect: true, type: Boolean })
], FileUpload.prototype, "multiple");
__decorateClass$l([
  n$1({ reflect: true, type: String })
], FileUpload.prototype, "capture");
__decorateClass$l([
  n$1({ reflect: true })
], FileUpload.prototype, "accept");
__decorateClass$l([
  n$1()
], FileUpload.prototype, "description");
__decorateClass$l([
  n$1()
], FileUpload.prototype, "color");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const $e = Symbol.for(""), xe = (t2) => {
  if ((t2 == null ? void 0 : t2.r) === $e) return t2 == null ? void 0 : t2._$litStatic$;
}, er = (t2, ...r2) => ({ _$litStatic$: r2.reduce((r3, e2, a2) => r3 + ((t3) => {
  if (void 0 !== t3._$litStatic$) return t3._$litStatic$;
  throw Error(`Value passed to 'literal' function must be a 'literal' result: ${t3}. Use 'unsafeStatic' to pass non-literal values, but
            take care to ensure page security.`);
})(e2) + t2[a2 + 1], t2[0]), r: $e }), Te = /* @__PURE__ */ new Map(), Ee = (t2) => (r2, ...e2) => {
  const a2 = e2.length;
  let o2, s4;
  const i3 = [], l2 = [];
  let n3, u2 = 0, c2 = false;
  for (; u2 < a2; ) {
    for (n3 = r2[u2]; u2 < a2 && void 0 !== (s4 = e2[u2], o2 = xe(s4)); ) n3 += o2 + r2[++u2], c2 = true;
    u2 !== a2 && l2.push(s4), i3.push(n3), u2++;
  }
  if (u2 === a2 && i3.push(r2[a2]), c2) {
    const t3 = i3.join("$$lit$$");
    void 0 === (r2 = Te.get(t3)) && (i3.raw = i3, Te.set(t3, r2 = i3)), e2 = l2;
  }
  return t2(r2, ...e2);
}, ke = Ee(ke$1);
const styles$p = ':host {\n  display: block;\n}\n\n.zw-heading[data-weight="regular"][data-size="4xs"] {\n      font: var(--zw-typography-display-4xs-regular);\n    }\n\n.zw-heading[data-weight="regular"][data-size="3xs"] {\n      font: var(--zw-typography-display-3xs-regular);\n    }\n\n.zw-heading[data-weight="regular"][data-size="2xs"] {\n      font: var(--zw-typography-display-2xs-regular);\n    }\n\n.zw-heading[data-weight="regular"][data-size="xs"] {\n      font: var(--zw-typography-display-xs-regular);\n    }\n\n.zw-heading[data-weight="regular"][data-size="s"] {\n      font: var(--zw-typography-display-s-regular);\n    }\n\n.zw-heading[data-weight="regular"][data-size="m"] {\n      font: var(--zw-typography-display-m-regular);\n    }\n\n.zw-heading[data-weight="regular"][data-size="l"] {\n      font: var(--zw-typography-display-l-regular);\n    }\n\n.zw-heading[data-weight="regular"][data-size="xl"] {\n      font: var(--zw-typography-display-xl-regular);\n    }\n\n.zw-heading[data-weight="bold"][data-size="4xs"] {\n      font: var(--zw-typography-display-4xs-bold);\n    }\n\n.zw-heading[data-weight="bold"][data-size="3xs"] {\n      font: var(--zw-typography-display-3xs-bold);\n    }\n\n.zw-heading[data-weight="bold"][data-size="2xs"] {\n      font: var(--zw-typography-display-2xs-bold);\n    }\n\n.zw-heading[data-weight="bold"][data-size="xs"] {\n      font: var(--zw-typography-display-xs-bold);\n    }\n\n.zw-heading[data-weight="bold"][data-size="s"] {\n      font: var(--zw-typography-display-s-bold);\n    }\n\n.zw-heading[data-weight="bold"][data-size="m"] {\n      font: var(--zw-typography-display-m-bold);\n    }\n\n.zw-heading[data-weight="bold"][data-size="l"] {\n      font: var(--zw-typography-display-l-bold);\n    }\n\n.zw-heading[data-weight="bold"][data-size="xl"] {\n      font: var(--zw-typography-display-xl-bold);\n    }\n\n.zw-heading[data-centered] {\n    text-align: center;\n  }\n\n.zw-heading[data-balanced] {\n    text-wrap: balance;\n  }\n';
var __defProp$k = Object.defineProperty;
var __decorateClass$k = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$k(target, key, result);
  return result;
};
const _Heading = class _Heading extends h {
  constructor() {
    super(...arguments);
    this.weight = "bold";
  }
  literalTag() {
    if (this.tag === "h1") return er`h1`;
    if (this.tag === "h2") return er`h2`;
    if (this.tag === "h3") return er`h3`;
    if (this.tag === "h4") return er`h4`;
    if (this.tag === "h5") return er`h5`;
    if (this.tag === "h6") return er`h6`;
    throw new Error(`Invalid tag: ${this.tag}`);
  }
  render() {
    return ke`<${this.literalTag()}
      class="zw-heading"
      data-size="${this.size}"
      data-weight="${this.weight}"
      ?data-centered="${this.centered}"
      ?data-balanced="${this.balanced}">
        <slot></slot>
      </${this.literalTag()}>`;
  }
};
_Heading.styles = [r$3(baseStyles), r$3(styles$p)];
let Heading = _Heading;
__decorateClass$k([
  n$1({ type: String })
], Heading.prototype, "tag");
__decorateClass$k([
  n$1({ type: String })
], Heading.prototype, "size");
__decorateClass$k([
  n$1({ type: String })
], Heading.prototype, "weight");
__decorateClass$k([
  n$1({ type: Boolean })
], Heading.prototype, "centered");
__decorateClass$k([
  n$1({ type: Boolean })
], Heading.prototype, "balanced");
const styles$o = ':host {\n  display: block;\n}\n\n:host([status="success"]) {\n  --zw-infobox-status-color: var(--zw-color-success-container);\n  --zw-infobox-color: var(--zw-color-on-success-container);\n  --zw-infobox-icon-color: var(--zw-color-success);\n}\n\n:host([status="info"]) {\n  --zw-infobox-status-color: var(--zw-color-info-container);\n  --zw-infobox-color: var(--zw-color-on-info-container);\n  --zw-infobox-icon-color: var(--zw-color-info);\n}\n\n:host([status="warning"]) {\n  --zw-infobox-status-color: var(--zw-color-warning-container);\n  --zw-infobox-color: var(--zw-color-on-warning-container);\n  --zw-infobox-icon-color: var(--zw-color-warning);\n}\n\n:host([status="error"]) {\n  --zw-infobox-status-color: var(--zw-color-error-container);\n  --zw-infobox-color: var(--zw-color-on-error-container);\n  --zw-infobox-icon-color: var(--zw-color-error);\n}\n\n.zw-infobox {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--zw-spacing-12);\n  border-radius: var(--zw-border-radius-4);\n  padding: var(--zw-spacing-16);\n  font: var(--zw-typography-text-m-regular);\n  color: var(--zw-infobox-color);\n  background-color: var(--zw-infobox-status-color);\n}\n\n.zw-infobox--content {\n  flex-grow: 1;\n}\n\n.zw-infobox--icon {\n  color: var(--zw-infobox-icon-color);\n}\n';
const iconNameByStatus = {
  success: "check_circle",
  warning: "warning",
  error: "error",
  info: "info"
};
const getIconNameByStatus = (status) => iconNameByStatus[status];
var __defProp$j = Object.defineProperty;
var __decorateClass$j = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$j(target, key, result);
  return result;
};
const _Infobox = class _Infobox extends h {
  constructor() {
    super();
    this.withRemoveButton = false;
    this.withoutIcon = false;
    this.removeAutomatically = false;
    this.removeAfter = 3e3;
    this.removeAriaLabel = "Remove infobox";
    defineCustomElementOnce("zw-icon", Icon);
    defineCustomElementOnce("zw-button", Button);
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.removeAutomatically) {
      setTimeout(() => {
        this.remove();
      }, this.removeAfter);
    }
  }
  render() {
    return ke$1`
      <div class="zw-infobox">
        ${this.iconHTML()}
        <div class="zw-infobox--content">
          <slot></slot>
        </div>
        ${this.removeButtonHTML()}
      </div>
    `;
  }
  iconHTML() {
    if (this.withoutIcon) return null;
    return ke$1`<zw-icon
      class="zw-infobox--icon"
      size="m"
      variant="filled"
      name=${getIconNameByStatus(this.status)}
    ></zw-icon>`;
  }
  removeButtonHTML() {
    if (!this.withRemoveButton) return null;
    return ke$1`<zw-button
      size="m"
      color="${this.status}"
      variant="icon-only"
      aria-label="${this.removeAriaLabel}"
      icon-only
      @click="${this.remove}"
    >
      <zw-icon name="close" size="m"></zw-icon>
    </zw-button>`;
  }
};
_Infobox.styles = [r$3(baseStyles), r$3(styles$o)];
let Infobox = _Infobox;
__decorateClass$j([
  n$1({ reflect: true })
], Infobox.prototype, "status");
__decorateClass$j([
  n$1({ type: Boolean, reflect: true, attribute: "with-remove-button" })
], Infobox.prototype, "withRemoveButton");
__decorateClass$j([
  n$1({ type: Boolean, reflect: true, attribute: "without-icon" })
], Infobox.prototype, "withoutIcon");
__decorateClass$j([
  n$1({ type: Boolean, reflect: true, attribute: "remove-automatically" })
], Infobox.prototype, "removeAutomatically");
__decorateClass$j([
  n$1({ type: Number, reflect: true, attribute: "remove-after" })
], Infobox.prototype, "removeAfter");
__decorateClass$j([
  n$1({ reflect: true, attribute: "remove-aria-label" })
], Infobox.prototype, "removeAriaLabel");
const styles$n = ':host {\n  display: block;\n}\n\n:host([color="primary"]) {\n  --zw-link-color: var(--zw-color-primary);\n  --zw-link-color-hover: var(--zw-color-states-primary-hover);\n  --zw-link-color-active: var(--zw-color-states-primary-focus-press);\n}\n\n:host([color="on-surface"]) {\n  --zw-link-color: var(--zw-color-on-surface);\n  --zw-link-color-hover: var(--zw-color-states-on-surface-hover);\n  --zw-link-color-active: var(--zw-color-states-on-surface-focus-press);\n}\n\n:host([size]) {\n  font: var(--zw-link-font);\n}\n\n:host([size="s"]) {\n  --zw-link-font: var(--zw-typography-text-s-semibold);\n}\n\n:host([size="m"]) {\n  --zw-link-font: var(--zw-typography-text-m-semibold);\n}\n\n:host([size="l"]) {\n  --zw-link-font: var(--zw-typography-text-l-semibold);\n}\n\n:host([size="xl"]) {\n  --zw-link-font: var(--zw-typography-text-xl-semibold);\n}\n\n.zw-link {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--zw-spacing-4);\n  font-size: inherit;\n  color: var(--zw-link-color);\n  align-content: center;\n  justify-content: center;\n  place-content: center;\n}\n\n.zw-link:focus-visible {\n    outline: none;\n  }\n\n.zw-link:focus,.zw-link:hover,.zw-link:active {\n    -webkit-text-decoration: none;\n    text-decoration: none;\n  }\n\n.zw-link[aria-disabled="true"] {\n    --zw-link-color: var(--zw-color-on-surface-variant);\n\n    cursor: default;\n  }\n\n.zw-link:not([aria-disabled="true"]):hover {\n      color: var(--zw-link-color-hover);\n    }\n\n.zw-link:not([aria-disabled="true"]):active {\n      color: var(--zw-link-color-active);\n    }\n\n.zw-link:not([aria-disabled="true"]):focus .zw-link--content {\n    box-shadow: 0 2px 0 0 var(--zw-link-color);\n  }\n\n.zw-link:not([aria-disabled="true"]):hover .zw-link--content {\n    box-shadow: 0 2px 0 0 var(--zw-link-color-hover);\n  }\n\n.zw-link:not([aria-disabled="true"]):active .zw-link--content {\n    box-shadow: 0 2px 0 0 var(--zw-link-color-active);\n  }\n';
var __defProp$i = Object.defineProperty;
var __decorateClass$i = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$i(target, key, result);
  return result;
};
const _Link = class _Link extends h {
  constructor() {
    super(...arguments);
    this.color = "primary";
    this.disabled = false;
  }
  render() {
    return ke$1`
      <a class="zw-link" href=${this.disabled ? D : this.href} aria-disabled=${this.disabled}>
        <slot name="leading-icon"></slot>
        <span class="zw-link--content">
          <slot></slot>
        </span>
        <slot name="trailing-icon"></slot>
      </a>
    `;
  }
};
_Link.styles = [r$3(baseStyles), r$3(styles$n)];
let Link = _Link;
__decorateClass$i([
  n$1({ reflect: true })
], Link.prototype, "href");
__decorateClass$i([
  n$1({ reflect: true })
], Link.prototype, "color");
__decorateClass$i([
  n$1({ reflect: true })
], Link.prototype, "size");
__decorateClass$i([
  n$1({ reflect: true, type: Boolean })
], Link.prototype, "disabled");
const styles$m = ":host {\n  display: block;\n}\n\n.zw-list-item--button,\n.zw-list-item--link {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  inline-size: 100%;\n  border-block-end: 1px solid var(--zw-color-outline-variant-low);\n  padding-block: var(--zw-spacing-8);\n  padding-inline: var(--zw-spacing-16);\n  font: var(--zw-typography-text-l-semibold);\n  color: var(--zw-color-on-surface);\n  background-color: var(--zw-color-surface);\n}\n\n.zw-list-item--button:active {\n    -webkit-text-decoration: none;\n    text-decoration: none;\n  }\n\n.zw-list-item--link:active {\n    -webkit-text-decoration: none;\n    text-decoration: none;\n  }\n\n.zw-list-item--button:focus,.zw-list-item--link:focus,.zw-list-item--button:hover,.zw-list-item--link:hover {\n    -webkit-text-decoration: none;\n    text-decoration: none;\n  }\n\n.zw-list-item--button:focus-visible {\n    outline: 2px solid var(--zw-color-on-surface);\n    outline-offset: -2px;\n  }\n\n.zw-list-item--link:focus-visible {\n    outline: 2px solid var(--zw-color-on-surface);\n    outline-offset: -2px;\n  }\n\n.zw-list-item--button:hover,.zw-list-item--link:hover {\n    background-color: var(--zw-color-surface-container-low);\n  }\n\n.zw-list-item--button:active {\n    background-color: var(--zw-color-surface-container);\n  }\n\n.zw-list-item--link:active {\n    background-color: var(--zw-color-surface-container);\n  }\n\n.zw-list-item--button:disabled {\n    color: var(--zw-color-on-surface-variant);\n    background-color: var(--zw-color-surface);\n  }\n\n.zw-list-item--link:disabled {\n    color: var(--zw-color-on-surface-variant);\n    background-color: var(--zw-color-surface);\n  }\n\n.zw-list-item--button[aria-disabled],.zw-list-item--link[aria-disabled] {\n    color: var(--zw-color-on-surface-variant);\n    background-color: var(--zw-color-surface);\n  }\n";
var __defProp$h = Object.defineProperty;
var __decorateClass$h = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$h(target, key, result);
  return result;
};
const _ListItem = class _ListItem extends h {
  constructor() {
    super(...arguments);
    this.disabled = false;
  }
  render() {
    return ke$1`<div class="zw-list-item" role="listitem">${this.innerComponentHTML()}</div>`;
  }
  innerComponentHTML() {
    if (this.href)
      return ke$1`<a
        class="zw-list-item--link"
        href=${this.disabled ? D : this.href}
        ?aria-disabled=${this.disabled}
      >
        ${this.contentHTML()}
      </a>`;
    return ke$1`<button class="zw-list-item--button" type="button" ?disabled=${this.disabled}>
      ${this.contentHTML()}
    </button>`;
  }
  contentHTML() {
    return ke$1`<slot></slot><slot name="end"></slot>`;
  }
};
_ListItem.styles = [r$3(baseStyles), r$3(styles$m)];
let ListItem = _ListItem;
__decorateClass$h([
  n$1({ type: Boolean, reflect: true })
], ListItem.prototype, "disabled");
__decorateClass$h([
  n$1({ reflect: true })
], ListItem.prototype, "href");
const styles$l = ':host {\n  display: inline-block;\n}\n\n:host([color="primary"]) {\n  --zw-loading-indicator-circle-color: var(--zw-color-primary-container);\n  --zw-loading-indicator-circle-color-highlight: var(--zw-color-primary);\n}\n\n:host([color="secondary"]) {\n  --zw-loading-indicator-circle-color: var(--zw-color-secondary-container);\n  --zw-loading-indicator-circle-color-highlight: var(--zw-color-secondary);\n}\n\n:host([color="tertiary"]) {\n  --zw-loading-indicator-circle-color: var(--zw-color-tertiary-container);\n  --zw-loading-indicator-circle-color-highlight: var(--zw-color-tertiary);\n}\n\n:host([color="neutral"]) {\n  --zw-loading-indicator-circle-color: var(--zw-color-transparent-transparent-on-surface-5);\n  --zw-loading-indicator-circle-color-highlight: var(\n    --zw-color-transparent-transparent-on-surface-11\n  );\n}\n\n:host([color="neutral-inverse"]) {\n  --zw-loading-indicator-circle-color: var(--zw-color-transparent-transparent-inverse-on-surface-5);\n  --zw-loading-indicator-circle-color-highlight: var(\n    --zw-color-transparent-transparent-inverse-on-surface-11\n  );\n}\n\n:host([size="s"]) {\n  --zw-loading-indicator-size: 1.5rem;\n}\n\n:host([size="m"]) {\n  --zw-loading-indicator-size: 2rem;\n}\n\n:host([size="l"]) {\n  --zw-loading-indicator-size: 2.5rem;\n}\n\n.zw-loading-indicator {\n  display: block;\n  inline-size: var(--zw-loading-indicator-size);\n  block-size: var(--zw-loading-indicator-size);\n}\n\n.zw-loading-indicator--circle {\n  stroke: var(--zw-loading-indicator-circle-color);\n}\n\n.zw-loading-indicator--circle-highlight {\n  stroke: var(--zw-loading-indicator-circle-color-highlight);\n}\n';
var __defProp$g = Object.defineProperty;
var __decorateClass$g = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$g(target, key, result);
  return result;
};
const _LoadingIndicator = class _LoadingIndicator extends h {
  constructor() {
    super(...arguments);
    this.color = "primary";
    this.size = "l";
    this.ariaLabel = "Loading …";
  }
  render() {
    return ke$1`
      <svg
        class="zw-loading-indicator"
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        aria-busy="true"
        aria-live="polite"
        role="progressbar"
        aria-label=${this.ariaLabel}
      >
        <g fill="none" fill-rule="evenodd">
          <g transform="translate(2 2)" stroke-width="4">
            <circle class="zw-loading-indicator--circle" cx="18" cy="18" r="18" />
            <path d="M0 18a18 18 0 0 1 36 0" class="zw-loading-indicator--circle-highlight">
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 18 18"
                to="360 18 18"
                dur="1s"
                repeatCount="indefinite"
              />
            </path>
          </g>
        </g>
      </svg>
    `;
  }
};
_LoadingIndicator.styles = [r$3(baseStyles), r$3(styles$l)];
let LoadingIndicator = _LoadingIndicator;
__decorateClass$g([
  n$1({ reflect: true })
], LoadingIndicator.prototype, "color");
__decorateClass$g([
  n$1({ reflect: true })
], LoadingIndicator.prototype, "size");
__decorateClass$g([
  n$1({ reflect: true, attribute: "aria-label" })
], LoadingIndicator.prototype, "ariaLabel");
const styles$k = ":host {\n  --_zw-modal-inline-size: var(--zw-modal-inline-size, 300px);\n\n  display: block;\n}\n\n.zw-modal {\n  inline-size: var(--_zw-modal-inline-size);\n  max-block-size: 90%;\n  border: none;\n  border-radius: 4px;\n  padding: var(--zw-spacing-24);\n  color: var(--zw-color-on-surface);\n  background-color: var(--zw-color-surface-container-low);\n}\n\n.zw-modal[open] {\n    display: flex;\n    flex-direction: column;\n  }\n\n.zw-modal::backdrop {\n    background-color: var(--zw-color-backdrop);\n  }\n\n.zw-modal--header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-block-start: var(--zw-spacing-4);\n  padding-block-end: var(--zw-spacing-24);\n}\n\n.zw-modal--heading {\n  font: var(--zw-font-heading-3);\n  font-weight: 700;\n}\n\n.zw-modal--close {\n  margin-inline-start: auto;\n}\n\n.zw-modal[data-scroll-main] .zw-modal--main {\n    overflow-y: auto;\n  }\n\n.zw-modal--footer {\n  margin-block-start: var(--zw-spacing-16);\n}\n";
var __defProp$f = Object.defineProperty;
var __decorateClass$f = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$f(target, key, result);
  return result;
};
const _Modal = class _Modal extends h {
  constructor() {
    super();
    this.disableScrollPrevention = false;
    this.closeLabel = "Close";
    this.closeable = false;
    this.alertDialog = false;
    this.open = false;
    defineCustomElementOnce("zw-button", Button);
    defineCustomElementOnce("zw-icon", Icon);
  }
  firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    if (this.open) this.showModal();
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has("open")) {
      if (this.open) {
        this.showModal();
      } else {
        this.close();
      }
    }
  }
  render() {
    return ke$1`
      <slot name="trigger" @click="${this.showModal}" @keydown=${this.handleTriggerKeydown}></slot>
      <dialog
        class="zw-modal"
        role=${to(this.alertDialog ? "alertdialog" : void 0)}
        @keydown=${this.handleModalKeydown}
      >
        ${this.headerHTML()} ${this.mainHTML()} ${this.footerHTML()}
      </dialog>
    `;
  }
  headerHTML() {
    return ke$1`<header class="zw-modal--header">
      <slot name="header"></slot>
      ${this.closeButtonHTML()}
    </header>`;
  }
  mainHTML() {
    return ke$1`<main class="zw-modal--main">
      <slot name="main"></slot>
    </main>`;
  }
  footerHTML() {
    return ke$1`<footer class="zw-modal--footer">
      <slot name="footer"></slot>
    </footer>`;
  }
  closeButtonHTML() {
    if (!this.closeable) return D;
    return ke$1`<div class="zw-modal--close">
      <zw-button
        variant="ghost"
        color="neutral"
        size="xs"
        icon-only
        aria-label="${this.closeLabel}"
        @click="${this.close}"
      >
        <zw-icon name="close"></zw-icon>
      </zw-button>
    </div>`;
  }
  showModal() {
    if (!this.disableScrollPrevention) preventScrolling();
    this.modal.showModal();
    this.open = true;
  }
  close() {
    if (!this.disableScrollPrevention) allowScrolling();
    this.modal.close();
    this.open = false;
  }
  handleModalKeydown(event) {
    if (event.key === Key.Escape) {
      this.close();
    }
  }
  handleTriggerKeydown(event) {
    if (event.key === Key.Enter || event.key === Key.Space) {
      this.showModal();
    }
  }
};
_Modal.styles = [r$3(baseStyles), r$3(styles$k)];
_Modal.shadowRootOptions = {
  ...h.shadowRootOptions,
  delegatesFocus: true
};
let Modal = _Modal;
__decorateClass$f([
  n$1({ reflect: true, type: Boolean, attribute: "disable-scroll-prevention" })
], Modal.prototype, "disableScrollPrevention");
__decorateClass$f([
  n$1({ reflect: true, attribute: "close-label" })
], Modal.prototype, "closeLabel");
__decorateClass$f([
  n$1({ reflect: true, type: Boolean })
], Modal.prototype, "closeable");
__decorateClass$f([
  n$1({ reflect: true, type: Boolean, attribute: "alert-dialog" })
], Modal.prototype, "alertDialog");
__decorateClass$f([
  n$1({ reflect: true, type: Boolean })
], Modal.prototype, "open");
__decorateClass$f([
  e$2(".zw-modal")
], Modal.prototype, "modal");
const styles$j = ':host {\n  display: block;\n}\n\n:host([hidden]) {\n  display: none;\n}\n\n:host([color="primary"]) {\n  --zw-option-highlight-color: var(--zw-color-primary);\n}\n\n:host([color="secondary"]) {\n  --zw-option-highlight-color: var(--zw-color-secondary);\n}\n\n.zw-option {\n  display: flex;\n  align-items: center;\n  gap: var(--zw-spacing-8);\n  position: relative;\n  inline-size: 100%;\n  border: 2px solid transparent;\n  padding-block: var(--zw-spacing-8);\n  padding-inline: var(--zw-spacing-12);\n  font: var(--zw-option-font);\n  cursor: pointer;\n}\n\n.zw-option[data-size="s"] {\n    --zw-option-font: var(--zw-typography-text-s-regular);\n  }\n\n.zw-option[data-size="m"] {\n    --zw-option-font: var(--zw-typography-text-m-regular);\n  }\n\n.zw-option[data-size="l"] {\n    --zw-option-font: var(--zw-typography-text-l-regular);\n  }\n\n.zw-option[aria-disabled="true"] {\n    color: var(--zw-color-on-surface-variant);\n    background-color: var(--zw-color-surface-container-low);\n    cursor: default;\n  }\n\n.zw-option:not([aria-disabled="true"]):focus {\n      outline: none;\n      border: 2px solid var(--zw-color-on-surface);\n    }\n\n.zw-option:not([aria-disabled="true"]):hover,.zw-option:not([aria-disabled="true"]):active,.zw-option[aria-selected="true"]:not([aria-disabled="true"]) {\n      background-color: var(--zw-color-surface-container);\n    }\n\n.zw-option:not([aria-disabled="true"]):hover::before {\n        content: "";\n        display: block;\n        position: absolute;\n        inset-block-start: 0;\n        inset-inline-start: 0;\n        inline-size: 4px;\n        block-size: 100%;\n        background-color: var(--zw-option-highlight-color);\n      }\n\n.zw-option:not([aria-disabled="true"]):active::before {\n        content: "";\n        display: block;\n        position: absolute;\n        inset-block-start: 0;\n        inset-inline-start: 0;\n        inline-size: 4px;\n        block-size: 100%;\n        background-color: var(--zw-option-highlight-color);\n      }\n\n.zw-option[aria-selected="true"]:not([aria-disabled="true"])::before {\n        content: "";\n        display: block;\n        position: absolute;\n        inset-block-start: 0;\n        inset-inline-start: 0;\n        inline-size: 4px;\n        block-size: 100%;\n        background-color: var(--zw-option-highlight-color);\n      }\n\n.zw-option[aria-selected="true"] {\n    background-color: var(--zw-color-surface-container-highest);\n  }\n';
var __defProp$e = Object.defineProperty;
var __decorateClass$e = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$e(target, key, result);
  return result;
};
const _Option = class _Option extends h {
  constructor() {
    super(...arguments);
    this.selected = false;
    this.disabled = false;
    this.color = "primary";
    this.size = "m";
  }
  render() {
    return ke$1`
      <div
        class="zw-option"
        role="option"
        value=${this.value}
        aria-disabled=${this.disabled}
        aria-selected=${this.selected}
        tabindex=${this.selected ? "0" : "-1"}
        data-size=${this.size}
        @click=${this.handleClick}
        @keydown=${this.handleKeydown}
      >
        <slot></slot>
      </div>
    `;
  }
  handleClick(event) {
    event.preventDefault();
    this.dispatchSelected();
  }
  handleKeydown(event) {
    if (event.key === Key.Enter) {
      event.preventDefault();
      this.dispatchSelected();
    }
  }
  dispatchSelected() {
    if (this.disabled) return;
    this.dispatchEvent(
      new CustomEvent("zw-option-click", {
        bubbles: true
      })
    );
  }
};
_Option.styles = [r$3(baseStyles), r$3(styles$j)];
_Option.shadowRootOptions = { ...h.shadowRootOptions, delegatesFocus: true };
let Option = _Option;
__decorateClass$e([
  n$1({ reflect: true })
], Option.prototype, "value");
__decorateClass$e([
  n$1({ reflect: true, type: Boolean })
], Option.prototype, "selected");
__decorateClass$e([
  n$1({ reflect: true, type: Boolean })
], Option.prototype, "disabled");
__decorateClass$e([
  n$1({ reflect: true })
], Option.prototype, "color");
__decorateClass$e([
  n$1({})
], Option.prototype, "size");
const styles$i = ":host {\n  --page-state-logo-size: 10rem;\n  --page-state-max-inline-size: 48rem;\n}\n\n.page-state {\n  display: flex;\n  align-items: center;\n  max-inline-size: var(--page-state-max-inline-size);\n  padding: var(--zw-spacing-24);\n}\n\n.page-state--logo {\n  min-inline-size: var(--page-state-logo-size);\n  block-size: var(--page-state-logo-size);\n}\n\n.page-state--title {\n  text-wrap: balance;\n}\n\n.page-state--description {\n  font: var(--zw-typography-text-m-regular);\n}\n\n@media (min-width: 1728px),(min-width: 1440px) and (max-width: 1727px),(min-width: 1240px) and (max-width: 1439px),(min-width: 1024px) and (max-width: 1239px) {\n  .page-state {\n    gap: var(--zw-spacing-32);\n  }\n\n  .page-state--title {\n    margin-block-end: var(--zw-spacing-8);\n  }\n\n  .page-state--actions {\n    margin-block-start: var(--zw-spacing-24);\n  }\n}\n\n@media (min-width: 640px) and (max-width: 1024px),(max-width: 639px) {\n  .page-state {\n    flex-direction: column;\n    gap: var(--zw-spacing-64);\n    margin-block: var(--zw-spacing-64);\n  }\n\n  .page-state--info {\n    text-align: center;\n  }\n\n  .page-state--title {\n    margin-block-end: var(--zw-spacing-24);\n  }\n\n  .page-state--description {\n    text-wrap: balance;\n  }\n\n  .page-state--actions {\n    margin-block-start: var(--zw-spacing-48);\n  }\n}\n";
const _PageState = class _PageState extends h {
  render() {
    return ke$1`
      <div class="page-state">
        ${this.logoHTML()}
        <div class="page-state--info">
          ${this.titleHTML()} ${this.descriptionHTML()} ${this.actionsHtml()}
        </div>
      </div>
    `;
  }
  logoHTML() {
    if (!hasSlotContent(this, "logo")) return null;
    return ke$1`<div class="page-state--logo">
      <slot name="logo"></slot>
    </div>`;
  }
  titleHTML() {
    if (!hasSlotContent(this, "heading")) return null;
    return ke$1` <div class="page-state--title">
      <slot name="heading"></slot>
    </div>`;
  }
  descriptionHTML() {
    if (!hasSlotContent(this, "description")) return null;
    return ke$1` <div class="page-state--description">
      <slot name="description"></slot>
    </div>`;
  }
  actionsHtml() {
    if (!hasSlotContent(this, "actions")) return null;
    return ke$1` <div class="page-state--actions">
      <slot name="actions"></slot>
    </div>`;
  }
};
_PageState.styles = [r$3(baseStyles), r$3(styles$i)];
let PageState = _PageState;
const styles$h = ':host {\n  display: block;\n}\n\n.zw-pagination {\n  --pagination-size: 2rem;\n\n  font: var(--zw-typography-text-s-regular);\n  font-feature-settings: "tnum";\n  font-variant-numeric: tabular-nums;\n}\n\n.zw-pagination--list {\n  display: flex;\n  align-items: center;\n  gap: var(--zw-spacing-8);\n}\n\n.zw-pagination--link,\n.zw-pagination--gap,\n.zw-pagination--link-add-on {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-inline-size: var(--pagination-size);\n  min-block-size: var(--pagination-size);\n}\n\n.zw-pagination--link,\n.zw-pagination--gap {\n  font-weight: 500;\n}\n\n.zw-pagination--link {\n  padding-inline: var(--zw-spacing-8);\n  text-transform: uppercase;\n}\n\n.zw-pagination--link,\n.zw-pagination--link-add-on {\n  border-radius: var(--zw-spacing-12);\n  color: var(--zw-color-on-primary-container);\n}\n\n.zw-pagination--link:active {\n    -webkit-text-decoration: none;\n    text-decoration: none;\n  }\n\n.zw-pagination--link-add-on:active {\n    -webkit-text-decoration: none;\n    text-decoration: none;\n  }\n\n.zw-pagination--link:focus,.zw-pagination--link-add-on:focus,.zw-pagination--link:hover,.zw-pagination--link-add-on:hover {\n    -webkit-text-decoration: none;\n    text-decoration: none;\n  }\n\n.zw-pagination--link:not([data-disabled]):not([aria-current]):hover,.zw-pagination--link-add-on:not([data-disabled]):not([aria-current]):hover {\n      color: var(--zw-color-on-primary-container);\n      background-color: var(--zw-color-primary-container);\n    }\n\n.zw-pagination--link:not([data-disabled]):not([aria-current]):active {\n      color: var(--zw-color-on-primary);\n      background-color: var(--zw-color-states-primary-focus-press);\n    }\n\n.zw-pagination--link-add-on:not([data-disabled]):not([aria-current]):active {\n      color: var(--zw-color-on-primary);\n      background-color: var(--zw-color-states-primary-focus-press);\n    }\n\n.zw-pagination--link:not([data-disabled]):not([aria-current]):focus,.zw-pagination--link-add-on:not([data-disabled]):not([aria-current]):focus {\n      color: var(--zw-color-on-primary);\n      background-color: var(--zw-color-states-primary-focus-press);\n    }\n\n.zw-pagination--link:disabled {\n    color: var(--zw-color-on-surface-variant);\n    cursor: auto;\n    pointer-events: none;\n  }\n\n.zw-pagination--link-add-on:disabled {\n    color: var(--zw-color-on-surface-variant);\n    cursor: auto;\n    pointer-events: none;\n  }\n\n.zw-pagination--link[data-disabled],.zw-pagination--link-add-on[data-disabled] {\n    color: var(--zw-color-on-surface-variant);\n    cursor: auto;\n    pointer-events: none;\n  }\n\n.zw-pagination--link[aria-current],.zw-pagination--link-add-on[aria-current] {\n    color: var(--zw-color-on-primary);\n    background-color: var(--zw-color-primary);\n  }\n';
const numbersWithEllipsis = (currentPage, totalPages) => {
  if (totalPages < 8) {
    return Array.from(Array(totalPages), (_2, i3) => i3 + 1);
  }
  if (currentPage < 5) return [1, 2, 3, 4, 5, null, totalPages];
  if (currentPage > totalPages - 4)
    return [1, null, totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
  const previousPage = currentPage - 1;
  const nextPage = currentPage + 1;
  const firstAndLastAndWindow = [
    1,
    previousPage,
    currentPage,
    nextPage,
    totalPages
  ];
  if (nextPage < totalPages - 1) {
    firstAndLastAndWindow.splice(-1, 0, null);
  }
  if (previousPage > 2) {
    firstAndLastAndWindow.splice(1, 0, null);
  }
  return firstAndLastAndWindow;
};
var __defProp$d = Object.defineProperty;
var __decorateClass$d = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$d(target, key, result);
  return result;
};
const _Pagination = class _Pagination extends h {
  constructor() {
    super();
    defineCustomElementOnce("zw-icon", Icon);
  }
  get onFirstPage() {
    return this.currentPage === 1;
  }
  get onLastPage() {
    return this.currentPage === this.numberOfPages;
  }
  render() {
    return ke$1`
      <nav class="zw-pagination">
        <ol class="zw-pagination--list" role="list">
          <li class="zw-pagination--list-item">${this.previousPageHtml()}</li>
          ${this.pageLinksHtml()}
          <li class="zw-pagination--list-item">${this.nextPageHtml()}</li>
        </ol>
      </nav>
    `;
  }
  pageLinksHtml() {
    const pageNumbersOrNull = numbersWithEllipsis(this.currentPage, this.numberOfPages);
    return pageNumbersOrNull.map((pageNumberOrNull) => {
      if (pageNumberOrNull) return this.pageNumberHtml(pageNumberOrNull);
      return this.ellipsisHtml();
    });
  }
  pageNumberHtml(pageNumber) {
    const ariaCurrent = this.currentPage === pageNumber ? "page" : D;
    return ke$1`<li class="zw-pagination--list-item">
      <a
        href=${this.hrefForPage(pageNumber)}
        class="zw-pagination--link"
        aria-current=${ariaCurrent}
      >
        ${pageNumber}
      </a>
    </li>`;
  }
  ellipsisHtml() {
    return ke$1`<span v-else class="zw-pagination--gap">…</span>`;
  }
  previousPageHtml() {
    if (this.onFirstPage) {
      return ke$1`
        <span class="zw-pagination--link-add-on" data-disabled>
          ${this.nextOrPreviousPageIconHtml("previous")}
        </span>
      `;
    }
    return ke$1`
      <a
        href="${this.hrefForPage(this.currentPage - 1)}"
        class="zw-pagination--link-add-on"
        aria-label=${this.previousPageText}
      >
        ${this.nextOrPreviousPageIconHtml("previous")}
      </a>
    `;
  }
  nextPageHtml() {
    if (this.onLastPage) {
      return ke$1`
        <span class="zw-pagination--link-add-on" data-disabled>
          ${this.nextOrPreviousPageIconHtml("next")}
        </span>
      `;
    }
    return ke$1`
      <a
        href="${this.hrefForPage(this.currentPage + 1)}"
        class="zw-pagination--link-add-on"
        aria-label=${this.nextPageText}
      >
        ${this.nextOrPreviousPageIconHtml("next")}
      </a>
    `;
  }
  nextOrPreviousPageIconHtml(nextOrPrevious) {
    const iconName = nextOrPrevious === "next" ? "chevron_right" : "chevron_left";
    return ke$1` <zw-icon name=${iconName}></zw-icon> `;
  }
  hrefForPage(pageNumber) {
    return `${this.pageUrlStub}${pageNumber}`;
  }
};
_Pagination.styles = [r$3(baseStyles), r$3(styles$h)];
let Pagination = _Pagination;
__decorateClass$d([
  n$1({ reflect: true, attribute: "current-page", type: Number })
], Pagination.prototype, "currentPage");
__decorateClass$d([
  n$1({ reflect: true, attribute: "number-of-pages", type: Number })
], Pagination.prototype, "numberOfPages");
__decorateClass$d([
  n$1({ reflect: true, attribute: "previous-page-text" })
], Pagination.prototype, "previousPageText");
__decorateClass$d([
  n$1({ reflect: true, attribute: "next-page-text" })
], Pagination.prototype, "nextPageText");
__decorateClass$d([
  n$1({ reflect: true, attribute: "page-url-stub" })
], Pagination.prototype, "pageUrlStub");
const styles$g = ":host {\n  --zw-pagination-bar-background-color: var(--zw-color-surface);\n\n  display: block;\n}\n\n.zw-pagination-bar {\n  border-block-start: 1px solid var(--zw-color-outline);\n  padding: var(--zw-spacing-24);\n  background-color: var(--zw-pagination-bar-background-color);\n}\n\n.zw-pagination-bar--end {\n  margin-inline-start: auto;\n}\n";
const _PaginationBar = class _PaginationBar extends h {
  render() {
    return ke$1`
      <div class="zw-pagination-bar | zw-repel">
        ${this.paginationBarStartHTML()} ${this.paginationBarEndHTML()}
      </div>
    `;
  }
  paginationBarStartHTML() {
    if (!hasSlotContent(this, "pagination-bar-start")) return null;
    return ke$1`<div class="zw-pagination-bar--start">
      <slot name="pagination-bar-start"></slot>
    </div>`;
  }
  paginationBarEndHTML() {
    if (!hasSlotContent(this, "pagination-bar-end")) return null;
    return ke$1`<div class="zw-pagination-bar--end">
      <slot name="pagination-bar-end"></slot>
    </div>`;
  }
};
_PaginationBar.styles = [r$3(baseStyles), r$3(repelStyles), r$3(styles$g)];
let PaginationBar = _PaginationBar;
var __defProp$c = Object.defineProperty;
var __decorateClass$c = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$c(target, key, result);
  return result;
};
class PasswordField extends TextField {
  constructor() {
    super(...arguments);
    this.type = "password";
    this.showPasswordLabel = "Show password";
    this.hidePasswordLabel = "Hide password";
  }
  get toggleVisibilityLabel() {
    return this.type === "password" ? this.showPasswordLabel : this.hidePasswordLabel;
  }
  get iconName() {
    return this.type === "password" ? "visibility" : "visibility_off";
  }
  get visibilityButtonSize() {
    return this.size === "l" ? "s" : "xs";
  }
  toggleInputType() {
    this.type = this.type === "password" ? "text" : "password";
  }
  // Overwrites the method from the text field
  afterInputSlotHTML() {
    return ke$1`
      <zw-tooltip text=${this.toggleVisibilityLabel} has-arrow allowed-placements="top bottom">
        <zw-button
          type="button"
          variant="icon-only"
          color="neutral"
          size=${this.visibilityButtonSize}
          icon-only
          aria-label=${this.toggleVisibilityLabel}
          @click=${this.toggleInputType}
        >
          <zw-icon name=${this.iconName} variant="filled" size=${this.size}></zw-icon>
        </zw-button>
      </zw-tooltip>
    `;
  }
}
__decorateClass$c([
  n$1({ reflect: true })
], PasswordField.prototype, "type");
__decorateClass$c([
  n$1({ attribute: "show-password-label" })
], PasswordField.prototype, "showPasswordLabel");
__decorateClass$c([
  n$1({ attribute: "hide-password-label" })
], PasswordField.prototype, "hidePasswordLabel");
const styles$f = '/* Keep the styles similar to the Checkbox component */\n\n:host {\n  --zw-radio-button-color: var(--zw-color-on-surface);\n  --zw-radio-button-text-color: var(--zw-color-on-surface);\n  --zw-radio-button-outline-color: var(--zw-color-on-surface);\n  --zw-radio-button-line-height: 1.25;\n\n  display: inline-flex;\n  align-items: center;\n}\n\n:host([color="primary"]) {\n  --zw-radio-button-checked-color: var(--zw-color-primary);\n  --zw-radio-button-hover-color: var(--zw-color-primary-container);\n  --zw-radio-button-active-color: var(--zw-color-states-primary-focus-press);\n}\n\n:host([color="secondary"]) {\n  --zw-radio-button-checked-color: var(--zw-color-secondary);\n  --zw-radio-button-hover-color: var(--zw-color-secondary-container);\n  --zw-radio-button-active-color: var(--zw-color-states-secondary-focus-press);\n}\n\n:host([errored]) {\n  --zw-radio-button-color: var(--zw-color-error);\n  --zw-radio-button-checked-color: var(--zw-color-error);\n  --zw-radio-button-hover-color: var(--zw-color-error-container);\n  --zw-radio-button-active-color: var(--zw-color-states-error-focus-press);\n}\n\n:host([disabled]) {\n  --zw-radio-button-color: var(--zw-color-on-surface-variant);\n  --zw-radio-button-checked-color: var(--zw-color-on-surface-variant);\n}\n\n.zw-radio-button--label {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--zw-spacing-8);\n\n  /* Create a new stacking context, so RadioButton does not blend into other components */\n  isolation: isolate;\n  padding-inline-end: var(--zw-spacing-2);\n  font: var(--zw-typography-text-m-regular);\n\n  /* Line height should match RadioButton size */\n  line-height: var(--zw-radio-button-line-height);\n  color: var(--zw-radio-button-text-color);\n}\n\n.zw-radio-button--input:disabled + .zw-radio-button--label {\n    cursor: not-allowed;\n  }\n\n.zw-radio-button--input:focus-visible + .zw-radio-button--label {\n    outline: 2px solid var(--zw-radio-button-outline-color);\n    border-radius: var(--zw-border-radius-4);\n  }\n\n.zw-radio-button--icon {\n  position: relative;\n  z-index: var(--zw-z-index-above);\n}\n\n.zw-radio-button--input:not(:disabled):hover ~ .zw-radio-button--label > .zw-radio-button--icon::before,.zw-radio-button--input:not(:disabled):active ~ .zw-radio-button--label > .zw-radio-button--icon::before {\n    content: "";\n    position: absolute;\n    z-index: var(--zw-z-index-below);\n    inset-block-start: 50%;\n    inset-inline-start: 50%;\n    border-radius: var(--zw-border-radius-1000);\n    padding: var(--zw-spacing-16);\n    transform: translate(-50%, -50%);\n  }\n\n.zw-radio-button--input:not(:disabled):hover ~ .zw-radio-button--label > .zw-radio-button--icon::before {\n    background-color: var(--zw-radio-button-hover-color);\n  }\n\n.zw-radio-button--icon-checked {\n  color: var(--zw-radio-button-checked-color);\n}\n\n.zw-radio-button--input:not(:disabled):active ~ .zw-radio-button--label .zw-radio-button--icon-checked {\n    color: var(--zw-radio-button-active-color);\n  }\n\n.zw-radio-button--icon-unchecked {\n  color: var(--zw-radio-button-color);\n}\n\n.zw-radio-button--input:not(:disabled):active ~ .zw-radio-button--label .zw-radio-button--icon-unchecked {\n    color: var(--zw-radio-button-active-color);\n  }\n';
var __defProp$b = Object.defineProperty;
var __decorateClass$b = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$b(target, key, result);
  return result;
};
const _RadioButton = class _RadioButton extends h {
  constructor() {
    super();
    this.internals = this.attachInternals();
    this.color = "primary";
    this.value = "on";
    this.disabled = false;
    this.errored = false;
    this.name = "";
    this.required = false;
    this.readonly = false;
    this.checked = false;
    this.radioButtonId = getUniqueId("zw-radio-button");
    defineCustomElementOnce("zw-icon", Icon);
  }
  firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    const { input } = this;
    if (!input) return;
    if (this.internals.setFormValue && this.checked) this.internals.setFormValue(this.value);
    if (this.internals.setValidity)
      this.internals.setValidity(input.validity, input.validationMessage, input);
  }
  update(changedProperties) {
    super.update(changedProperties);
    const { input } = this;
    if (!input) return;
    if (changedProperties.has("checked")) {
      input.checked = this.checked;
      if (this.internals.setFormValue && !input.checked) {
        this.internals.setFormValue(null);
      }
      if (this.internals.setValidity)
        this.internals.setValidity(input.validity, input.validationMessage, input);
    }
    if (changedProperties.has("value")) {
      input.value = this.value;
      if (this.internals.setValidity)
        this.internals.setValidity(input.validity, input.validationMessage, input);
    }
  }
  handleClick(event) {
    if (this.readonly) {
      event.preventDefault();
    }
  }
  handleChange() {
    if (this.readonly) return;
    const { checked } = this.input;
    this.checked = checked;
    this.internals.setFormValue(this.checked ? this.value : null);
    this.dispatchEvent(
      new Event("change", {
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    return ke$1` <div class="zw-radio-button">${this.inputHTML()} ${this.labelHTML()}</div>`;
  }
  inputHTML() {
    return ke$1`<input
      id=${this.radioButtonId}
      class="zw-radio-button--input | sr-only"
      type="radio"
      ?checked=${this.checked}
      ?disabled=${this.disabled}
      ?readonly=${this.readonly}
      @change=${this.handleChange}
      @click=${this.handleClick}
    />`;
  }
  labelHTML() {
    return ke$1`<label class="zw-radio-button--label" for=${this.radioButtonId}>
      <div class="zw-radio-button--icon">${this.iconHTML()}</div>
      <span>${this.label}</span>
    </label>`;
  }
  getIconName() {
    if (!this.checked) return "radio_button_unchecked";
    return "radio_button_checked";
  }
  iconHTML() {
    const classes = this.checked ? "zw-radio-button--icon-checked" : "zw-radio-button--icon-unchecked";
    return ke$1`<zw-icon class=${classes} name=${this.getIconName()} size="m" variant="filled">
    </zw-icon>`;
  }
};
_RadioButton.styles = [r$3(baseStyles), r$3(styles$f)];
_RadioButton.formAssociated = true;
let RadioButton = _RadioButton;
__decorateClass$b([
  e$2("input")
], RadioButton.prototype, "input");
__decorateClass$b([
  n$1({ reflect: true })
], RadioButton.prototype, "color");
__decorateClass$b([
  n$1({ reflect: true })
], RadioButton.prototype, "value");
__decorateClass$b([
  n$1({ type: Boolean, reflect: true })
], RadioButton.prototype, "disabled");
__decorateClass$b([
  n$1({ reflect: true, type: Boolean })
], RadioButton.prototype, "errored");
__decorateClass$b([
  n$1({ reflect: true, type: String })
], RadioButton.prototype, "name");
__decorateClass$b([
  n$1({ reflect: true })
], RadioButton.prototype, "label");
__decorateClass$b([
  n$1({ type: Boolean, reflect: true })
], RadioButton.prototype, "required");
__decorateClass$b([
  n$1({ type: Boolean, reflect: true })
], RadioButton.prototype, "readonly");
__decorateClass$b([
  n$1({ type: Boolean, reflect: true, attribute: "checked" })
], RadioButton.prototype, "checked");
const styles$e = "/* Keep the styles similar to the CheckboxGroup component */\n\n.zw-radio-button-group {\n  margin: 0;\n  border: 0;\n  padding: 0;\n}\n\n.zw-radio-button-group--items {\n  display: flex;\n  gap: var(--zw-spacing-8);\n}\n\n:host([inline]) .zw-radio-button-group--items {\n    gap: var(--zw-spacing-24);\n  }\n\n:host(:not([inline])) .zw-radio-button-group--items {\n    flex-direction: column;\n  }\n";
var __defProp$a = Object.defineProperty;
var __decorateClass$a = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$a(target, key, result);
  return result;
};
const HintElement$2 = HintMixin(h);
const ErrorElement$2 = ErrorMixin(HintElement$2);
const LabeledElement$1 = LabelMixin(ErrorElement$2);
const _RadioButtonGroup = class _RadioButtonGroup extends LabeledElement$1 {
  constructor() {
    super(...arguments);
    this.size = "m";
    this.inline = false;
    this.required = false;
    this.disabled = false;
    this.errored = false;
  }
  // If multiple radio buttons are checked by default, select the last one
  firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    const checkedRadioButton = this.radioButtons.findLast(
      (radioButton) => radioButton.hasAttribute("checked")
    );
    if (checkedRadioButton) {
      this.radioButtons.forEach((radioButton) => radioButton.removeAttribute("checked"));
      checkedRadioButton.setAttribute("checked", "");
    }
    this.radioButtons.forEach(
      (radioButton) => radioButton.addEventListener("keydown", (event) => {
        handleFocusableElements(event, this.radioButtons);
      })
    );
  }
  handleChange(event) {
    const selectedRadioButton = event.target;
    this.radioButtons.forEach((radioButton) => {
      if (radioButton !== selectedRadioButton) {
        radioButton.removeAttribute("checked");
      }
    });
  }
  render() {
    return ke$1`
      <fieldset class="zw-radio-button-group" ?disabled=${this.disabled}>
        ${this.labelHtml({
      tag: "legend",
      required: this.required,
      size: this.size,
      disabled: this.disabled
    })}

        <div class="zw-radio-button-group--items">
          <slot @change=${this.handleChange}></slot>
        </div>
        ${this.hintHTML({ showErrorMessage: this.showErrorMessage })} ${this.errorMessageHTML()}
      </fieldset>
    `;
  }
};
_RadioButtonGroup.styles = [
  r$3(baseStyles),
  r$3(styles$e),
  HintElement$2.styles,
  ErrorElement$2.styles,
  LabeledElement$1.styles
];
let RadioButtonGroup = _RadioButtonGroup;
__decorateClass$a([
  n$1({ reflect: true })
], RadioButtonGroup.prototype, "size");
__decorateClass$a([
  n$1({ reflect: true, type: Boolean })
], RadioButtonGroup.prototype, "inline");
__decorateClass$a([
  n$1({ reflect: true, type: Boolean })
], RadioButtonGroup.prototype, "required");
__decorateClass$a([
  n$1({ reflect: true, type: Boolean })
], RadioButtonGroup.prototype, "disabled");
__decorateClass$a([
  n$1({ reflect: true, type: Boolean })
], RadioButtonGroup.prototype, "errored");
__decorateClass$a([
  n$1({ reflect: true, attribute: "error-message" })
], RadioButtonGroup.prototype, "errorMessage");
__decorateClass$a([
  n$1({ reflect: true })
], RadioButtonGroup.prototype, "hint");
__decorateClass$a([
  o()
], RadioButtonGroup.prototype, "radioButtons");
const styles$d = ":host {\n  display: block;\n  overflow: auto;\n  inline-size: 100%;\n  max-inline-size: 100vw;\n  block-size: 100%;\n  max-block-size: 100vh;\n  -webkit-overflow-scrolling: touch;\n}\n";
const _ScrollBox = class _ScrollBox extends h {
  render() {
    return ke$1`<slot></slot>`;
  }
};
_ScrollBox.styles = [r$3(baseStyles), r$3(styles$d)];
let ScrollBox = _ScrollBox;
const styles$c = ":host {\n  --zw-select-max-inline-size: none;\n  --zw-select-z-index: var(--z-index-select, var(--zw-z-index-select));\n\n  display: block;\n}\n\n.zw-select {\n  position: relative;\n  inline-size: 100%;\n  max-inline-size: var(--zw-select-max-inline-size);\n  padding-block-end: var(--zw-spacing-2);\n}\n\n.zw-select--listbox {\n  display: none;\n  overflow-y: auto;\n  position: absolute;\n  z-index: var(--zw-select-z-index);\n  inset-block-end: 0;\n  inset-inline-start: 0;\n  inline-size: 100%;\n  max-block-size: 300px;\n  box-shadow: var(--zw-elevation-bottom-m);\n  transform: translateY(100%);\n  background-color: var(--zw-color-surface);\n}\n\n.zw-select[data-open] .zw-select--listbox {\n    display: block;\n  }\n";
const styles$b = ':host {\n  display: block;\n}\n\n:host([data-full-width]) {\n  flex: 1;\n}\n\n:host([color="neutral"]) {\n  --zw-tab-item-background-color-hover: var(--zw-color-surface-container-low);\n  --zw-tab-item-background-color-active: var(--zw-color-surface-container-high);\n}\n\n:host([color="primary"]) {\n  --zw-tab-item-background-color-hover: var(--zw-color-primary-container);\n  --zw-tab-item-background-color-active: var(--zw-color-states-primary-container-hover);\n}\n\n.zw-tab-item {\n  --zw-tab-item-indicator-height: 3px;\n  --zw-tab-item-indicator-color: transparent;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--zw-spacing-2);\n  color: var(--zw-color-on-surface);\n  background-color: var(--zw-color-fixed-transparent);\n}\n\n.zw-tab-item:focus-visible,.zw-tab-item:hover {\n    background-color: var(--zw-tab-item-background-color-hover);\n  }\n\n.zw-tab-item:active {\n    background-color: var(--zw-tab-item-background-color-active);\n  }\n\n.zw-tab-item:disabled {\n    color: var(--zw-color-on-surface-variant);\n    background-color: var(--zw-color-fixed-transparent);\n  }\n\n.zw-tab-item[data-has-icon] {\n    padding-block-start: var(--zw-spacing-4);\n    padding-block-end: 0;\n  }\n\n:host([data-full-width]) .zw-tab-item {\n    inline-size: 100%;\n  }\n\n.zw-tab-item--text {\n  position: relative;\n  inline-size: 100%;\n  padding: var(--zw-spacing-16);\n  font: var(--zw-typography-text-s-medium);\n}\n\n.zw-tab-item[data-has-icon] .zw-tab-item--text {\n    inline-size: auto;\n    margin-inline: var(--zw-spacing-8);\n    padding: 0;\n    padding-block-end: var(--zw-spacing-4);\n  }\n\n.zw-tab-item[data-has-icon] .zw-tab-item--text::after {\n    border-radius: var(--zw-border-radius-4) var(--zw-border-radius-4) 0 0;\n  }\n\n.zw-tab-item[aria-selected="true"] .zw-tab-item--text::after {\n    content: "";\n    display: block;\n    position: absolute;\n    inset-block-end: 0;\n    inset-inline-start: 0;\n    inline-size: 100%;\n    block-size: var(--zw-tab-item-indicator-height);\n    background-color: var(--zw-color-primary);\n  }\n\n.zw-tab-item[aria-selected="true"]:disabled .zw-tab-item--text::after {\n    background-color: var(--zw-color-on-surface-variant);\n  }\n';
var __defProp$9 = Object.defineProperty;
var __decorateClass$9 = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$9(target, key, result);
  return result;
};
const _TabItem = class _TabItem extends h {
  constructor() {
    super();
    this.icon = "";
    this.color = "primary";
    this.disabled = false;
    this.selected = false;
    defineCustomElementOnce("zw-icon", Icon);
  }
  iconHtml() {
    if (!this.icon) return null;
    return ke$1`<zw-icon size="l" name=${this.icon}></zw-icon>`;
  }
  render() {
    return ke$1`
      <button
        class="zw-tab-item"
        role="tab"
        type="button"
        aria-selected=${this.selected}
        ?disabled=${this.disabled}
        ?data-has-icon=${this.icon}
      >
        ${this.iconHtml()}

        <span class="zw-tab-item--text">
          <slot></slot>
        </span>
      </button>
    `;
  }
};
_TabItem.styles = [r$3(baseStyles), r$3(styles$b)];
let TabItem = _TabItem;
__decorateClass$9([
  n$1({ reflect: true })
], TabItem.prototype, "icon");
__decorateClass$9([
  n$1({ reflect: true })
], TabItem.prototype, "color");
__decorateClass$9([
  n$1({ reflect: true, type: Boolean })
], TabItem.prototype, "disabled");
__decorateClass$9([
  n$1({ reflect: true, type: Boolean })
], TabItem.prototype, "selected");
const isZwOptionElement = (element) => element instanceof Option;
const isZwTabElement = (element) => element instanceof TabItem;
const getFallbackElement = (elements, value) => {
  const optionElements = elements.filter((element) => isZwOptionElement(element));
  const tabElements = elements.filter((element) => isZwTabElement(element));
  if (optionElements.length === 0 && tabElements.length === 0)
    throw new Error("No fallback element found");
  if (optionElements.length > 0) {
    const enabledOptionElements = optionElements.filter((element) => !element.disabled);
    return enabledOptionElements.find((element) => element.selected) ?? enabledOptionElements.find((element) => element.value === value) ?? enabledOptionElements.at(0);
  }
  const enabledTabElements = tabElements.filter((element) => !element.disabled);
  if (enabledTabElements.length === 0) {
    return tabElements.at(0);
  }
  return enabledTabElements.find((element) => element.selected) ?? enabledTabElements.at(0);
};
var __defProp$8 = Object.defineProperty;
var __decorateClass$8 = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$8(target, key, result);
  return result;
};
const HintElement$1 = HintMixin(h);
const ErrorElement$1 = ErrorMixin(HintElement$1);
const _Select = class _Select extends ErrorElement$1 {
  constructor() {
    super();
    this.internals = this.attachInternals();
    this.value = "";
    this.color = "primary";
    this.open = false;
    this.name = "";
    this.disabled = false;
    this.hiddenLabel = false;
    this.required = false;
    this.size = "m";
    this.toggleSelectLabel = "Toggle Select";
    this.noResultsLabel = "No results";
    this.labelId = getUniqueId("zw-select-label");
    this.listboxId = getUniqueId("zw-listbox");
    defineCustomElementOnce("zw-option", Option);
    defineCustomElementOnce("zw-icon", Icon);
    defineCustomElementOnce("zw-text-field", TextField);
    defineCustomElementOnce("zw-button", Button);
  }
  firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    if (!this.options.length) console.error("No options available");
    this.updateOptionColors();
    this.updateOptionSizes();
    this.selectFallbackOption(false);
  }
  update(changedProperties) {
    if (changedProperties.has("color")) this.updateOptionColors();
    if (changedProperties.has("size")) this.updateOptionSizes();
    if (changedProperties.has("value")) {
      this.removeSelectedFromOptions();
      this.selectFallbackOption(false);
    }
    super.update(changedProperties);
  }
  render() {
    return ke$1`
      <div
        class="zw-select"
        data-size=${this.size}
        ?data-open=${this.open}
        @focusout=${this.onFocusOut}
      >
        ${this.labelHtml()}
        <zw-text-field
          id="combobox"
          role="combobox"
          label=${this.label}
          aria-labelledby=${this.labelId}
          aria-haspopup="listbox"
          aria-expanded=${this.open}
          aria-controls=${this.listboxId}
          color=${this.color}
          ?hidden-label=${this.hiddenLabel}
          ?required=${this.required}
          ?disabled=${this.disabled}
          ?errored=${this.errored}
          hint=${to(this.open ? void 0 : this.hint)}
          error-message=${to(this.open ? void 0 : this.errorMessage)}
          size=${this.size}
          @click=${this.onComboboxClick}
          @focus=${this.openListbox}
          @keydown=${this.handleComboboxKeydown}
          @change=${this.handleComboboxChange}
          @input=${this.handleComboboxInput}
        >
          <zw-button
            size=${this.size}
            color="neutral"
            variant="icon-only"
            aria-label=${this.toggleSelectLabel}
            slot="after-input"
            ?disabled=${this.disabled}
            icon-only
            @click=${this.handleCaretClick}
            tabindex="-1"
          >
            <zw-icon
              name="${this.open ? "expand_less" : "expand_more"}"
              size=${this.size}
            ></zw-icon>
          </zw-button>
        </zw-text-field>

        <div
          class="zw-select--listbox"
          role="listbox"
          id=${this.listboxId}
          aria-labelledby=${this.labelId}
        >
          <slot
            @zw-option-click="${this.handleOptionClick}"
            @keydown="${this.handleOptionKeydown}"
            @slotchange=${this.handleSlotChange}
          ></slot>
          <!-- This empty options just selects nothing and closes the dropdown -->
          <zw-option hidden id="no-results-option">
            <zw-icon name="close"></zw-icon>
            ${this.noResultsLabel}
          </zw-option>
        </div>
      </div>
    `;
  }
  labelHtml() {
    return ke$1`<span id=${this.labelId} class="sr-only"> ${this.label} </span>`;
  }
  selectInput() {
    var _a2, _b;
    (_b = (_a2 = this.combobox.shadowRoot) == null ? void 0 : _a2.querySelector("input")) == null ? void 0 : _b.select();
  }
  onComboboxClick() {
    this.selectInput();
    this.openListbox();
  }
  onFocusOut(event) {
    if (event.relatedTarget != null && (event.relatedTarget === this.combobox || this.options.includes(event.relatedTarget) || this.caret === event.relatedTarget))
      return;
    this.closeListbox();
    this.selectOptionBySearch();
  }
  selectOptionBySearch() {
    var _a2;
    const searchTerm = (_a2 = this.combobox.value) == null ? void 0 : _a2.toString().toLowerCase().trim();
    const option = this.options.filter((o2) => !o2.disabled).find((o2) => {
      var _a3;
      return ((_a3 = o2.innerText) == null ? void 0 : _a3.toLowerCase().trim()) === searchTerm;
    });
    if (option) {
      this.selectOption(option);
      return;
    }
    this.selectFallbackOption(false);
    this.closeListbox();
  }
  handleCaretClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.open) {
      this.closeListbox();
      this.selectOptionBySearch();
    } else {
      this.openListbox();
    }
  }
  openListbox() {
    if (this.open) return;
    this.open = true;
  }
  closeListbox() {
    if (!this.open) return;
    this.open = false;
    this.resetSearch();
  }
  async openListboxAndFocus(fallbackIndex) {
    this.openListbox();
    const focusableOptions = this.options.filter((o2) => !o2.hidden && !o2.disabled);
    const option = focusableOptions.find((o2) => o2.hasAttribute("selected")) || focusableOptions.at(fallbackIndex);
    await this.updateComplete;
    option == null ? void 0 : option.focus();
  }
  async handleOptionClick(event) {
    this.selectOption(event.target);
    await this.updateComplete;
    this.selectInput();
    this.closeListbox();
  }
  handleOptionKeydown(event) {
    if (event.key === Key.Escape) {
      this.selectInput();
      this.closeListbox();
    }
    handleFocusableElements(
      event,
      this.options.filter((o2) => !o2.hidden)
    );
  }
  handleComboboxChange(event) {
    event.stopPropagation();
    this.handleComboboxInput();
  }
  handleComboboxInput() {
    if (!this.open) this.openListbox();
    const searchTerm = this.combobox.value.toString().toLowerCase().trim();
    this.searchOptions(searchTerm);
  }
  handleComboboxKeydown(event) {
    if (this.disabled) return;
    if (event.key === Key.Escape) {
      this.unselectOption();
      this.resetSearch();
      this.selectInput();
    }
    if (event.key === Key.ArrowDown) {
      event.preventDefault();
      this.openListboxAndFocus(0);
    }
    if (event.key === Key.ArrowUp) {
      event.preventDefault();
      this.openListboxAndFocus(-1);
    }
  }
  // Triggered when the options inside the default slot change.
  // Example use cases:
  // - All select options are replaced when another select is changed.
  // - A single option is added or removed.
  handleSlotChange() {
    this.selectFallbackOption(true);
  }
  filterOptionsBySearchTerm(searchTerm) {
    if (searchTerm === "") return this.options;
    return this.options.filter((option) => {
      var _a2;
      return (_a2 = option.innerText) == null ? void 0 : _a2.toLowerCase().includes(searchTerm);
    });
  }
  updateOptionVisibility(optionsToShow) {
    this.options.forEach((option) => {
      if (optionsToShow.includes(option)) {
        option.removeAttribute("hidden");
        return;
      }
      option.setAttribute("hidden", "");
    });
  }
  displayNoResultsOption(shouldShow) {
    this.noResultsOption.hidden = !shouldShow;
  }
  searchOptions(searchTerm) {
    const matchedOptions = this.filterOptionsBySearchTerm(searchTerm);
    this.updateOptionVisibility(matchedOptions);
    this.displayNoResultsOption(!matchedOptions.length);
  }
  resetSearch() {
    this.noResultsOption.setAttribute("hidden", "");
    this.options.forEach((option) => {
      option.removeAttribute("hidden");
    });
  }
  selectFallbackOption(triggerChangeEvent) {
    if (this.options.length === 0) return;
    const fallbackOption = getFallbackElement(this.options, this.value);
    if (!isZwOptionElement(fallbackOption)) return;
    this.selectOption(fallbackOption, triggerChangeEvent);
  }
  selectOption(selectedOption, triggerChangeEvent = true) {
    var _a2;
    if (!selectedOption) return;
    const selectedOptionValue = selectedOption.value;
    const valueChanged = this.value !== selectedOptionValue;
    this.removeSelectedFromOptions();
    selectedOption.setAttribute("selected", "");
    this.combobox.value = ((_a2 = selectedOption.innerText) == null ? void 0 : _a2.trim()) ?? "";
    this.value = selectedOptionValue;
    if (this.internals.setFormValue) this.internals.setFormValue(selectedOptionValue);
    if (triggerChangeEvent && valueChanged) {
      const changeEvent = new Event("change", { bubbles: true, composed: true });
      this.dispatchEvent(changeEvent);
    }
  }
  unselectOption() {
    this.removeSelectedFromOptions();
    this.combobox.value = "";
    this.selectFallbackOption(true);
  }
  removeSelectedFromOptions() {
    this.options.forEach((option) => {
      option.removeAttribute("selected");
    });
  }
  updateOptionSizes() {
    this.options.forEach((option) => {
      option.size = this.size;
    });
  }
  updateOptionColors() {
    this.options.forEach((option) => {
      option.color = this.color;
    });
  }
};
_Select.styles = [
  r$3(baseStyles),
  r$3(styles$c),
  HintElement$1.styles,
  ErrorElement$1.styles
];
_Select.formAssociated = true;
let Select = _Select;
__decorateClass$8([
  n$1()
], Select.prototype, "value");
__decorateClass$8([
  n$1({ reflect: true })
], Select.prototype, "color");
__decorateClass$8([
  o()
], Select.prototype, "options");
__decorateClass$8([
  e$2("#combobox")
], Select.prototype, "combobox");
__decorateClass$8([
  e$2("#no-results-option")
], Select.prototype, "noResultsOption");
__decorateClass$8([
  e$2(".zw-select--listbox")
], Select.prototype, "listbox");
__decorateClass$8([
  e$2("zw-button")
], Select.prototype, "caret");
__decorateClass$8([
  n$1({ type: Boolean })
], Select.prototype, "open");
__decorateClass$8([
  n$1({ reflect: true })
], Select.prototype, "name");
__decorateClass$8([
  n$1({ reflect: true })
], Select.prototype, "label");
__decorateClass$8([
  n$1({ reflect: true, type: Boolean })
], Select.prototype, "disabled");
__decorateClass$8([
  n$1({ reflect: true, type: Boolean, attribute: "hidden-label" })
], Select.prototype, "hiddenLabel");
__decorateClass$8([
  n$1({ reflect: true, type: Boolean })
], Select.prototype, "required");
__decorateClass$8([
  n$1({ reflect: true })
], Select.prototype, "size");
__decorateClass$8([
  n$1({ reflect: true, attribute: "toggle-select-label" })
], Select.prototype, "toggleSelectLabel");
__decorateClass$8([
  n$1({ reflect: true, attribute: "no-results-label" })
], Select.prototype, "noResultsLabel");
const styles$a = ':host {\n  display: block;\n}\n\n:host([status="info"]) {\n  --zw-snackbar-text-color: var(--zw-color-on-info-container);\n  --zw-snackbar-container-color: var(--zw-color-info-container);\n  --zw-snackbar-icon-color: var(--zw-color-info);\n}\n\n:host([status="warning"]) {\n  --zw-snackbar-text-color: var(--zw-color-on-warning-container);\n  --zw-snackbar-container-color: var(--zw-color-warning-container);\n  --zw-snackbar-icon-color: var(--zw-color-warning);\n}\n\n:host([status="error"]) {\n  --zw-snackbar-text-color: var(--zw-color-on-error-container);\n  --zw-snackbar-container-color: var(--zw-color-error-container);\n  --zw-snackbar-icon-color: var(--zw-color-error);\n}\n\n:host([status="success"]) {\n  --zw-snackbar-text-color: var(--zw-color-on-success-container);\n  --zw-snackbar-container-color: var(--zw-color-success-container);\n  --zw-snackbar-icon-color: var(--zw-color-success);\n}\n\n.zw-snackbar {\n  display: inline-flex;\n  justify-content: space-between;\n  gap: var(--zw-spacing-8);\n  border-radius: var(--zw-border-radius-8);\n  padding: var(--zw-spacing-16);\n  font: var(--zw-typography-text-m-regular);\n  background-color: var(--zw-snackbar-container-color);\n  animation: fade-out-to-top 0.3s forwards;\n}\n\n.zw-snackbar[data-full-width] {\n    inline-size: 100%;\n  }\n\n.zw-snackbar[data-has-actions] {\n    padding-block: var(--zw-spacing-8);\n  }\n\n.zw-snackbar[data-visible] {\n    animation: fade-in-from-bottom 0.3s forwards;\n  }\n\n.zw-snackbar--description,\n.zw-snackbar--actions {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--zw-spacing-8);\n}\n\n.zw-snackbar--description {\n  font: var(--zw-typography-text-m-regular);\n  color: var(--zw-snackbar-text-color);\n}\n\n.zw-snackbar--leading-icon {\n  color: var(--zw-snackbar-icon-color);\n}\n';
var StatusIconMapping = /* @__PURE__ */ ((StatusIconMapping2) => {
  StatusIconMapping2["info"] = "info";
  StatusIconMapping2["warning"] = "warning";
  StatusIconMapping2["error"] = "error";
  StatusIconMapping2["success"] = "check_circle";
  return StatusIconMapping2;
})(StatusIconMapping || {});
var __defProp$7 = Object.defineProperty;
var __decorateClass$7 = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$7(target, key, result);
  return result;
};
const _Snackbar = class _Snackbar extends h {
  constructor() {
    super();
    this.fullWidth = false;
    this.removeAriaLabel = "Remove";
    this.removeable = false;
    this.removeAfter = void 0;
    this.isVisible = true;
    defineCustomElementOnce("zw-icon", Icon);
    defineCustomElementOnce("zw-button", Button);
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.removeAfter) {
      setTimeout(() => {
        this.removeSnackbar();
      }, this.removeAfter);
    }
  }
  removeSnackbar() {
    this.isVisible = false;
    setTimeout(() => {
      this.remove();
    }, 500);
  }
  render() {
    const hasActions = hasSlotContent(this, "actions");
    return ke$1`
      <div
        class="zw-snackbar"
        ?data-full-width=${this.fullWidth}
        ?data-has-actions=${hasActions}
        role="alert"
        aria-live="polite"
        ?data-visible=${this.isVisible}
      >
        ${this.descriptionHTML()} ${this.actionsHTML()}
      </div>
    `;
  }
  actionsHTML() {
    return ke$1`<div class="zw-snackbar--actions">
      <slot name="actions"></slot>
      ${this.removeIconHTML()}
    </div>`;
  }
  descriptionHTML() {
    return ke$1`<div class="zw-snackbar--description">
      <zw-icon
        class="zw-snackbar--leading-icon"
        name="${StatusIconMapping[this.status]}"
        variant="filled"
        size="m"
      >
      </zw-icon>
      <slot></slot>
    </div>`;
  }
  removeIconHTML() {
    if (!this.removeable) return D;
    return ke$1`<zw-button
      aria-label="${this.removeAriaLabel}"
      color="neutral"
      icon-only
      variant="icon-only"
      size="xs"
      @click=${this.removeSnackbar}
    >
      <zw-icon name="close" size="s"></zw-icon>
    </zw-button>`;
  }
};
_Snackbar.styles = [r$3(baseStyles), r$3(animations), r$3(styles$a)];
let Snackbar = _Snackbar;
__decorateClass$7([
  n$1({ reflect: true })
], Snackbar.prototype, "status");
__decorateClass$7([
  n$1({ reflect: true, attribute: "full-width", type: Boolean })
], Snackbar.prototype, "fullWidth");
__decorateClass$7([
  n$1({ reflect: true, attribute: "remove-aria-label" })
], Snackbar.prototype, "removeAriaLabel");
__decorateClass$7([
  n$1({ reflect: true, type: Boolean })
], Snackbar.prototype, "removeable");
__decorateClass$7([
  n$1({ reflect: true, attribute: "remove-after", type: Number })
], Snackbar.prototype, "removeAfter");
__decorateClass$7([
  r()
], Snackbar.prototype, "isVisible");
const styles$9 = ":host {\n  display: block;\n}\n\n.zw-tab-row {\n  display: flex;\n  border-block-end: 1px solid var(--zw-color-outline-variant-low);\n}\n";
const isHTMLElement = (element) => !!element && element instanceof HTMLElement;
const getHtmlElements = (tagName, elementNodeList) => {
  const htmlElements = [];
  elementNodeList.forEach((elementNode) => {
    var _a2;
    const element = (_a2 = elementNode.shadowRoot) == null ? void 0 : _a2.querySelector(tagName);
    if (isHTMLElement(element)) {
      htmlElements.push(element);
    }
  });
  return htmlElements;
};
const selectTab = (tab) => {
  tab.setAttribute("aria-selected", "true");
  tab.setAttribute("tabindex", "0");
};
const unselectTab = (tab) => {
  tab.setAttribute("aria-selected", "false");
  tab.setAttribute("tabindex", "-1");
};
const setAriaAttributes = (tabItems, tabPanels) => {
  tabItems.forEach((control, index) => {
    const tabPanel = tabPanels[index];
    const controlId = getUniqueId("a11y-tab");
    const panelId = getUniqueId("a11y-panel");
    control.setAttribute("id", controlId);
    control.setAttribute("aria-controls", panelId);
    tabPanel.setAttribute("id", panelId);
    tabPanel.setAttribute("aria-labelledby", controlId);
  });
};
const registerListeners = (tabItems, tabPanels, tabItem, index) => {
  tabItem.addEventListener("click", () => {
    tabItems.forEach((control) => {
      unselectTab(control);
    });
    selectTab(tabItem);
    tabPanels == null ? void 0 : tabPanels.forEach((panel) => {
      panel.setAttribute("hidden", "");
    });
    const tabPanel = tabPanels[index];
    tabPanel == null ? void 0 : tabPanel.removeAttribute("hidden");
  });
  tabItem.addEventListener("keydown", (event) => {
    handleFocusableElements(event, tabItems);
  });
};
const setupTabs = (shadowRoot, tabsProcessed) => {
  var _a2;
  if (!shadowRoot) return true;
  if (tabsProcessed) return true;
  const tabItemSlot = shadowRoot.querySelector("slot[name='row']");
  const tabPanelSlot = shadowRoot.querySelector("slot[name='panel']");
  const tabItemElements = tabItemSlot == null ? void 0 : tabItemSlot.assignedElements();
  const tabPanelElements = tabPanelSlot == null ? void 0 : tabPanelSlot.assignedElements();
  if (!tabItemElements || !tabPanelElements) return true;
  const tabItems = getHtmlElements(".zw-tab-item", tabItemElements);
  const tabPanels = getHtmlElements(".zw-tab-panel", tabPanelElements);
  setAriaAttributes(tabItems, tabPanels);
  tabPanels.forEach((panel) => {
    panel.setAttribute("hidden", "");
  });
  tabItems.forEach((tabItem, index) => {
    registerListeners(tabItems, tabPanels, tabItem, index);
    unselectTab(tabItem);
  });
  const selectedTabElement = getFallbackElement(tabItemElements);
  if (tabItems.length > 0 && selectedTabElement) {
    const selectedTabItem = (_a2 = selectedTabElement.shadowRoot) == null ? void 0 : _a2.querySelector(".zw-tab-item");
    if (isHTMLElement(selectedTabItem)) {
      selectTab(selectedTabItem);
      const tabIndex = tabItems.findIndex((tabItem) => tabItem === selectedTabItem);
      tabPanels[tabIndex].removeAttribute("hidden");
    }
  }
  return true;
};
var __defProp$6 = Object.defineProperty;
var __decorateClass$6 = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$6(target, key, result);
  return result;
};
const _TabGroup = class _TabGroup extends h {
  constructor() {
    super(...arguments);
    this.tabsProcessed = false;
    this.fullWidth = false;
  }
  setFullWidthForItems(event) {
    if (!this.fullWidth) return;
    const target = event == null ? void 0 : event.target;
    if (!target) return;
    const items = Array.from(target.assignedElements());
    if (!items.length) return;
    items.forEach((item) => {
      item.setAttribute("data-full-width", "");
    });
  }
  handleItemsSlotChange(event) {
    this.tabsProcessed = setupTabs(this.shadowRoot, this.tabsProcessed);
    this.setFullWidthForItems(event);
  }
  handlePanelSlotChange() {
    this.tabsProcessed = setupTabs(this.shadowRoot, this.tabsProcessed);
  }
  render() {
    return ke$1`
      <div class="zw-tab-row" role="tablist">
        <slot name="row" @slotchange=${this.handleItemsSlotChange}></slot>
      </div>

      <slot name="panel" @slotchange=${this.handlePanelSlotChange}></slot>
    `;
  }
};
_TabGroup.styles = [r$3(baseStyles), r$3(styles$9)];
let TabGroup = _TabGroup;
__decorateClass$6([
  n$1({ reflect: true, type: Boolean, attribute: "full-width" })
], TabGroup.prototype, "fullWidth");
const styles$8 = ".zw-tab-panel {\n  padding: var(--zw-spacing-24);\n}\n";
const _TabPanel = class _TabPanel extends h {
  // eslint-disable-next-line class-methods-use-this
  render() {
    return ke$1`
      <div class="zw-tab-panel" role="tabpanel">
        <slot></slot>
      </div>
    `;
  }
};
_TabPanel.styles = [r$3(baseStyles), r$3(styles$8)];
let TabPanel = _TabPanel;
const styles$7 = ':host {\n  display: block;\n}\n\nzw-table {\n  --cell-spacing: var(--zw-spacing-16);\n}\n\nzw-table table {\n    border-collapse: collapse;\n    inline-size: 100%;\n    max-block-size: 100%;\n    font: var(--zw-typography-text-s-regular);\n    -webkit-hyphens: auto;\n            hyphens: auto;\n    word-break: break-word;\n    color: var(--zw-color-on-surface);\n    background-color: var(--zw-color-surface);\n  }\n\nzw-table th {\n    padding: var(--cell-spacing);\n\n    /* Using a border does not work, as it does not stick with the header */\n    box-shadow: inset 0 -2px var(--zw-color-outline);\n    text-align: start;\n    white-space: nowrap;\n    background-color: var(--zw-color-surface);\n\n    /* TODO: Improve naming (start/end instead of right) */\n  }\n\nzw-table th[data-right-aligned] {\n      text-align: end;\n    }\n\nzw-table[variant="borders"] th:not(:last-of-type) {\n      border-inline-end: 1px solid var(--zw-color-outline);\n    }\n\nzw-table[variant="vertical-borders"] th:not(:last-of-type) {\n      border-inline-end: 1px solid var(--zw-color-outline);\n    }\n\nzw-table[sticky-header] th {\n    position: sticky;\n    z-index: var(--zw-z-index-above);\n\n    /* Let the header scroll a little bit before becoming sticky */\n    inset-block-start: calc(-1 * var(--zw-spacing-8));\n    padding-block-start: var(--zw-spacing-24);\n  }\n\nzw-table[variant="borders"] tr:not(:last-of-type) {\n      border-block-end: 1px solid var(--zw-color-outline-variant-low);\n    }\n\nzw-table[variant="horizontal-borders"] tr:not(:last-of-type) {\n      border-block-end: 1px solid var(--zw-color-outline-variant-low);\n    }\n\nzw-table[variant="zebra-striped"] tr:nth-child(odd) {\n      background-color: var(--zw-color-surface-container-low);\n    }\n\nzw-table td {\n    min-inline-size: 8rem;\n    padding: var(--cell-spacing);\n    text-align: start;\n  }\n\nzw-table td[data-numeric] {\n      font: var(--zw-typography-table-digits-s-regular);\n      font-feature-settings: "tnum";\n      font-variant-numeric: tabular-nums;\n    }\n\nzw-table[variant="borders"] td:not(:last-of-type) {\n      border-inline-end: 1px solid var(--zw-color-outline-variant-low);\n    }\n\nzw-table[variant="vertical-borders"] td:not(:last-of-type) {\n      border-inline-end: 1px solid var(--zw-color-outline-variant-low);\n    }\n\ntd[data-right-aligned] {\n    text-align: end;\n  }\n';
var __defProp$5 = Object.defineProperty;
var __decorateClass$5 = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$5(target, key, result);
  return result;
};
const zwTableSheet = new CSSStyleSheet();
if (zwTableSheet.replaceSync) {
  zwTableSheet.replaceSync(styles$7);
}
if (document.adoptedStyleSheets) document.adoptedStyleSheets.push(zwTableSheet);
class Table extends h {
  constructor() {
    super(...arguments);
    this.variant = "plain";
    this.stickyHeader = false;
  }
  createRenderRoot() {
    return this;
  }
  render() {
    return ke$1`<slot></slot>`;
  }
}
__decorateClass$5([
  n$1({ reflect: true })
], Table.prototype, "variant");
__decorateClass$5([
  n$1({ type: Boolean, reflect: true })
], Table.prototype, "stickyHeader");
const styles$6 = ':host {\n  display: inline-block;\n}\n\n:host([status="success"]) {\n  --zw-tag-status-color: var(--zw-color-on-success-container);\n  --zw-tag-status-background-color: var(--zw-color-success-container);\n  --zw-tag-status-dot-color: var(--zw-color-success);\n}\n\n:host([status="warning"]) {\n  --zw-tag-status-color: var(--zw-color-on-warning-container);\n  --zw-tag-status-background-color: var(--zw-color-warning-container);\n  --zw-tag-status-dot-color: var(--zw-color-warning);\n}\n\n:host([status="info"]) {\n  --zw-tag-status-color: var(--zw-color-on-info-container);\n  --zw-tag-status-background-color: var(--zw-color-info-container);\n  --zw-tag-status-dot-color: var(--zw-color-info);\n}\n\n:host([status="error"]) {\n  --zw-tag-status-color: var(--zw-color-on-error-container);\n  --zw-tag-status-background-color: var(--zw-color-error-container);\n  --zw-tag-status-dot-color: var(--zw-color-error);\n}\n\n:host([status="neutral"]) {\n  --zw-tag-status-color: var(--zw-color-on-surface);\n  --zw-tag-status-background-color: var(--zw-color-surface-container-low);\n  --zw-tag-status-dot-color: var(--zw-color-on-surface-variant);\n}\n\n:host([status="neutral-inverted"]) {\n  --zw-tag-status-color: var(--zw-color-on-surface);\n  --zw-tag-status-background-color: var(--zw-color-surface);\n  --zw-tag-status-dot-color: var(--zw-color-on-surface-variant);\n}\n\n:host([size="s"]) {\n  --zw-tag-padding-block: var(--zw-spacing-2);\n  --zw-tag-padding-inline: var(--zw-spacing-4);\n  --zw-tag-typography: var(--zw-typography-text-s-regular);\n  --zw-tag-status-dot-size: 0.5rem;\n}\n\n:host([size="m"]) {\n  --zw-tag-padding-block: var(--zw-spacing-4);\n  --zw-tag-padding-inline: var(--zw-spacing-8);\n  --zw-tag-typography: var(--zw-typography-text-m-regular);\n  --zw-tag-status-dot-size: 0.625rem;\n}\n\n:host([size="l"]) {\n  --zw-tag-padding-block: var(--zw-spacing-8);\n  --zw-tag-padding-inline: var(--zw-spacing-12);\n  --zw-tag-typography: var(--zw-typography-text-l-regular);\n  --zw-tag-status-dot-size: 0.75rem;\n}\n\n.zw-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--zw-spacing-4);\n  border-radius: var(--zw-spacing-8);\n  padding-block: var(--zw-tag-padding-block);\n  padding-inline: var(--zw-tag-padding-inline);\n  font: var(--zw-tag-typography);\n  color: var(--zw-tag-status-color);\n  background-color: var(--zw-tag-status-background-color);\n}\n\n.zw-tag[data-has-status-dot]::before {\n    content: "";\n    display: block;\n    inline-size: var(--zw-tag-status-dot-size);\n    aspect-ratio: 1;\n    margin: calc(var(--zw-tag-status-dot-size) / 2);\n    border-radius: var(--zw-border-radius-1000);\n    background: var(--zw-tag-status-dot-color);\n  }\n';
var TagAddons = /* @__PURE__ */ ((TagAddons2) => {
  TagAddons2["TextOnly"] = "text-only";
  TagAddons2["StatusDot"] = "status-dot";
  TagAddons2["Icon"] = "icon";
  return TagAddons2;
})(TagAddons || {});
var __defProp$4 = Object.defineProperty;
var __decorateClass$4 = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$4(target, key, result);
  return result;
};
const _Tag = class _Tag extends h {
  constructor() {
    super();
    this.size = "m";
    this.addon = "text-only";
    this.iconVariant = "outlined";
    defineCustomElementOnce("zw-icon", Icon);
  }
  render() {
    return ke$1`<div class="zw-tag" ?data-has-status-dot=${this.addon === TagAddons.StatusDot}>
      ${this.iconHTML()}<slot></slot>
    </div>`;
  }
  iconHTML() {
    if (this.addon === TagAddons.Icon && this.iconName)
      return ke$1`<zw-icon
        name=${this.iconName}
        variant=${this.iconVariant}
        size=${this.size}
      ></zw-icon>`;
    if (this.addon === TagAddons.Icon)
      console.warn("Missing icon. Please provide a valid icon name.");
    return null;
  }
};
_Tag.styles = [r$3(baseStyles), r$3(styles$6)];
let Tag = _Tag;
__decorateClass$4([
  n$1({ reflect: true })
], Tag.prototype, "status");
__decorateClass$4([
  n$1({ reflect: true })
], Tag.prototype, "size");
__decorateClass$4([
  n$1({ reflect: true })
], Tag.prototype, "addon");
__decorateClass$4([
  n$1({ reflect: true, attribute: "icon-variant" })
], Tag.prototype, "iconVariant");
__decorateClass$4([
  n$1({ reflect: true, attribute: "icon-name" })
], Tag.prototype, "iconName");
const styles$5 = ':host {\n  --zw-text-area-max-inline-size: none;\n  --zw-text-area-color: var(--zw-color-on-surface);\n  --zw-text-area-color-background: var(--zw-color-surface-container-lowest);\n  --zw-text-area-border-color: var(--zw-color-outline);\n  --zw-text-area-color-focus-outline: var(--zw-color-on-surface);\n\n  display: block;\n}\n\n:host[hidden] {\n  display: none;\n}\n\n:host([color="primary"]) {\n  --zw-text-area-border-color-hover: var(--zw-color-primary-container);\n  --zw-text-area-color-background-hover: var(--zw-color-primary-container);\n}\n\n:host([color="secondary"]) {\n  --zw-text-area-border-color-hover: var(--zw-color-secondary-container);\n  --zw-text-area-color-background-hover: var(--zw-color-secondary-container);\n}\n\n:host([size="s"]) {\n  font: var(--zw-typography-text-s-regular);\n}\n\n:host([size="m"]) {\n  font: var(--zw-typography-text-m-regular);\n}\n\n:host([size="l"]) {\n  font: var(--zw-typography-text-l-regular);\n}\n\n.zw-text-area--field {\n  position: relative;\n}\n\n.zw-text-area--input {\n  inline-size: 100%;\n  max-inline-size: var(--zw-text-area-max-inline-size);\n  border: 1px solid var(--zw-text-area-border-color);\n  border-radius: var(--zw-border-radius-4);\n  padding-block: var(--zw-spacing-8);\n  padding-inline: var(--zw-spacing-8) var(--zw-spacing-32);\n  color: var(--zw-text-area-color);\n  background-color: var(--zw-text-area-color-background);\n}\n\n:host([fixed-size]) .zw-text-area--input {\n    resize: none;\n  }\n\n.zw-text-area--input:focus {\n    outline: none;\n  }\n\n.zw-text-area--input:not(:disabled):not(:-moz-read-only):focus-visible {\n      outline: 2px solid var(--zw-text-area-color-focus-outline);\n    }\n\n.zw-text-area--input:not(:disabled):not(:read-only):focus-visible {\n      outline: 2px solid var(--zw-text-area-color-focus-outline);\n    }\n\n.zw-text-area--input:not(:disabled):not(:-moz-read-only):hover {\n      --zw-text-area-color-background: var(--zw-text-area-color-background-hover);\n    }\n\n.zw-text-area--input:not(:disabled):not(:read-only):hover {\n      --zw-text-area-color-background: var(--zw-text-area-color-background-hover);\n    }\n\n:host([errored]) .zw-text-area--input:not(:disabled):not(:-moz-read-only) {\n    --zw-text-area-color-focus-outline: var(--zw-color-error);\n    --zw-text-area-color-background-hover: var(--zw-color-error-container);\n  }\n\n:host([errored]) .zw-text-area--input:not(:disabled):not(:read-only) {\n    --zw-text-area-color-focus-outline: var(--zw-color-error);\n    --zw-text-area-color-background-hover: var(--zw-color-error-container);\n  }\n\n.zw-text-area--input:-moz-read-only {\n    --zw-text-area-color: var(--zw-color-on-surface-variant);\n    --zw-text-area-color-background: var(--zw-color-surface-container-bright);\n  }\n\n.zw-text-area--input:read-only {\n    --zw-text-area-color: var(--zw-color-on-surface-variant);\n    --zw-text-area-color-background: var(--zw-color-surface-container-bright);\n  }\n\n.zw-text-area--input:disabled {\n    --zw-text-area-color: var(--zw-color-on-surface-variant);\n    --zw-text-area-color-background: var(--zw-color-surface-container);\n  }\n\n:host([errored]) .zw-text-area--input {\n    /* Styles should be applied even when disabled, so apply styles after disabled styles */\n    --zw-text-area-border-color: var(--zw-color-error);\n    --zw-text-area-color: var(--zw-color-on-error-container);\n  }\n\n.zw-text-area--characters {\n  font: var(--zw-typography-text-xs-regular);\n  color: var(--zw-color-on-surface-variant);\n}\n\n.zw-text-area--addon {\n  position: absolute;\n  inset-block-start: var(--zw-spacing-8);\n  inset-inline-end: var(--zw-spacing-8);\n}\n';
var __defProp$3 = Object.defineProperty;
var __decorateClass$3 = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$3(target, key, result);
  return result;
};
const HintElement = HintMixin(h);
const ErrorElement = ErrorMixin(HintElement);
const LabeledElement = LabelMixin(ErrorElement);
const _TextArea = class _TextArea extends LabeledElement {
  constructor() {
    super();
    this.internals = this.attachInternals();
    this.textAreaId = getUniqueId("zw-text-area");
    this.size = "m";
    this.color = "primary";
    this.disabled = false;
    this.required = false;
    this.readonly = false;
    this.spellcheck = false;
    this.value = "";
    defineCustomElementOnce("zw-icon", Icon);
  }
  firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    const { textArea } = this;
    if (!textArea) return;
    if (this.internals.setFormValue) this.internals.setFormValue(this.value);
    if (this.internals.setValidity)
      this.internals.setValidity(textArea.validity, textArea.validationMessage, textArea);
  }
  update(changedProperties) {
    super.update(changedProperties);
    const { textArea } = this;
    if (!textArea) return;
    if (changedProperties.has("value")) {
      textArea.value = this.value;
      if (this.internals.setValidity)
        this.internals.setValidity(textArea.validity, textArea.validationMessage, textArea);
    }
  }
  get lengthHint() {
    return `${this.value.length} / ${this.maxlength}`;
  }
  render() {
    return ke$1`
      <div class="zw-text-area">
        ${this.labelHtml({
      forId: this.textAreaId,
      required: this.required,
      size: this.size,
      disabled: this.disabled
    })}

        <div class="zw-text-area--field">
          ${this.textAreaHtml()} ${this.errorIconWithAddonHTML()}
        </div>

        ${this.hintHTML({ showErrorMessage: this.showErrorMessage })} ${this.errorMessageHTML()}
      </div>
    `;
  }
  labelAdditions() {
    if (!this.maxlength) return null;
    return ke$1` <span class="zw-text-area--characters"> ${this.lengthHint} </span>`;
  }
  textAreaHtml() {
    return ke$1`<textarea
      autocomplete=${to(this.autocomplete)}
      id="${this.textAreaId}"
      class="zw-text-area--input"
      placeholder="${to(this.placeholder)}"
      minlength=${to(this.minlength)}
      maxlength=${to(this.maxlength)}
      rows=${to(this.rows)}
      ?disabled=${this.disabled}
      ?readonly=${this.readonly}
      ?spellcheck=${this.spellcheck}
      @input=${this.handleInput}
      @change=${this.handleChangeEvent}
    ></textarea>`;
  }
  errorIconWithAddonHTML() {
    const errorHTML = this.errorIconHTML({ size: this.size, disabled: this.disabled });
    if (!errorHTML) return null;
    return ke$1` <div class="zw-text-area--addon">${errorHTML}</div>`;
  }
  handleInput() {
    const { textArea } = this;
    if (!textArea) return;
    const { value } = textArea;
    this.value = value;
    if (this.internals.setFormValue) this.internals.setFormValue(value);
    if (this.internals.setValidity)
      this.internals.setValidity(textArea.validity, textArea.validationMessage, textArea);
  }
  handleChangeEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    const { textArea } = this;
    if (!textArea) return;
    const changeEvent = new Event("change", { bubbles: true, composed: true });
    this.dispatchEvent(changeEvent);
  }
};
_TextArea.styles = [
  r$3(baseStyles),
  r$3(styles$5),
  HintElement.styles,
  ErrorElement.styles,
  LabeledElement.styles
];
_TextArea.formAssociated = true;
let TextArea = _TextArea;
__decorateClass$3([
  e$2("textarea")
], TextArea.prototype, "textArea");
__decorateClass$3([
  n$1({ reflect: true })
], TextArea.prototype, "size");
__decorateClass$3([
  n$1({ reflect: true })
], TextArea.prototype, "icon");
__decorateClass$3([
  n$1({ reflect: true })
], TextArea.prototype, "color");
__decorateClass$3([
  n$1({ reflect: true, type: Boolean, attribute: "fixed-size" })
], TextArea.prototype, "fixedSize");
__decorateClass$3([
  n$1()
], TextArea.prototype, "autocomplete");
__decorateClass$3([
  n$1({ type: Boolean })
], TextArea.prototype, "disabled");
__decorateClass$3([
  n$1({ type: Number })
], TextArea.prototype, "minlength");
__decorateClass$3([
  n$1({ type: Number })
], TextArea.prototype, "maxlength");
__decorateClass$3([
  n$1({ type: Number })
], TextArea.prototype, "rows");
__decorateClass$3([
  n$1({ reflect: true })
], TextArea.prototype, "name");
__decorateClass$3([
  n$1()
], TextArea.prototype, "placeholder");
__decorateClass$3([
  n$1({ type: Boolean })
], TextArea.prototype, "required");
__decorateClass$3([
  n$1({ type: Boolean })
], TextArea.prototype, "readonly");
__decorateClass$3([
  n$1({ type: Boolean })
], TextArea.prototype, "spellcheck");
__decorateClass$3([
  n$1()
], TextArea.prototype, "value");
const styles$4 = ":host {\n  display: contents;\n}\n\n.zw-toast {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--zw-spacing-8);\n  border-radius: var(--zw-border-radius-1000);\n  padding: var(--zw-spacing-16);\n  font: var(--zw-typography-text-m-medium);\n  color: var(--zw-color-inverse-on-surface);\n  background-color: var(--zw-color-inverse-surface);\n  animation: fade-out-to-top 0.3s forwards;\n}\n\n.zw-toast[data-visible] {\n    animation: fade-in-from-bottom 0.3s forwards;\n  }\n";
var __defProp$2 = Object.defineProperty;
var __decorateClass$2 = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$2(target, key, result);
  return result;
};
const _Toast = class _Toast extends h {
  constructor() {
    super();
    this.removeAriaLabel = "Remove";
    this.removeable = false;
    this.isVisible = true;
    defineCustomElementOnce("zw-button", Button);
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.removeAfter) {
      setTimeout(() => {
        this.removeToast();
      }, this.removeAfter);
    }
  }
  removeToast() {
    this.isVisible = false;
    setTimeout(() => {
      this.remove();
    }, 500);
  }
  removeIconHTML() {
    if (!this.removeable) return D;
    return ke$1`<zw-button
      aria-label="${this.removeAriaLabel}"
      color="neutral-inverse"
      variant="icon-only"
      size="m"
      icon-only
      @click=${this.removeToast}
    >
      <zw-icon name="close" size="m"></zw-icon>
    </zw-button>`;
  }
  render() {
    return ke$1`
      <div class="zw-toast" role="alert" aria-live="polite" ?data-visible=${this.isVisible}>
        <slot></slot>
        ${this.removeIconHTML()}
      </div>
    `;
  }
};
_Toast.styles = [r$3(baseStyles), r$3(animations), r$3(styles$4)];
let Toast = _Toast;
__decorateClass$2([
  n$1({ reflect: true, attribute: "remove-aria-label" })
], Toast.prototype, "removeAriaLabel");
__decorateClass$2([
  n$1({ type: Boolean, reflect: true })
], Toast.prototype, "removeable");
__decorateClass$2([
  n$1({ type: Number, attribute: "remove-after" })
], Toast.prototype, "removeAfter");
__decorateClass$2([
  r()
], Toast.prototype, "isVisible");
const styles$3 = "[popover] {\n  overflow: visible;\n  overflow: initial;\n  inset: unset;\n  margin: 0;\n  border: none;\n  padding: 0;\n}\n\n:host {\n  --zw-tooltip-max-inline-size: 15rem;\n  --zw-tooltip--arrow-size: 0.75rem;\n\n  display: inline-block;\n}\n\n.zw-tooltip {\n  position: relative;\n  inline-size: -moz-max-content;\n  inline-size: max-content;\n  max-inline-size: var(--zw-tooltip-max-inline-size);\n  padding-block: var(--zw-spacing-12);\n  padding-inline: var(--zw-spacing-8);\n  box-shadow: var(--zw-elevation-bottom-m);\n  font: var(--zw-typography-text-s-regular);\n  text-align: left;\n  text-align: initial;\n  color: var(--zw-color-inverse-on-surface);\n  background-color: var(--zw-color-on-surface);\n}\n\n.zw-tooltip--title {\n  margin-block-end: var(--zw-spacing-4);\n  font: var(--zw-typography-text-s-semibold);\n}\n\n.zw-tooltip--arrow {\n  position: absolute;\n  inline-size: var(--zw-tooltip--arrow-size);\n  aspect-ratio: 1;\n  background-color: var(--zw-color-on-surface);\n}\n";
const OPPOSITE_SIDE = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
};
function updatePosition(triggerElement, tooltip, tooltipArrow, preferredPlacement, withArrow) {
  if (!triggerElement) return null;
  const arrowLength = (tooltipArrow == null ? void 0 : tooltipArrow.offsetWidth) ?? 0;
  return autoUpdate(
    triggerElement,
    tooltip,
    () => {
      computePosition(triggerElement, tooltip, {
        placement: preferredPlacement,
        middleware: [shift(), flip(), offset(16), withArrow && arrow({ element: tooltipArrow })]
      }).then(({ x: x2, y: y2, middlewareData, placement }) => {
        Object.assign(tooltip.style, {
          left: `${x2}px`,
          top: `${y2}px`
        });
        const side = placement.split("-")[0];
        const oppositeSide = OPPOSITE_SIDE[side];
        if (!oppositeSide) throw new Error("Invalid side");
        if (middlewareData.arrow) {
          const { x: arrowX, y: arrowY } = middlewareData.arrow;
          Object.assign(tooltipArrow.style, {
            // Use != to check for null or undefined.
            left: arrowX != null ? `${arrowX}px` : "",
            top: arrowY != null ? `${arrowY}px` : "",
            // Ensure the opposite side gets unset when
            // flipping to other placements' axes.
            right: "",
            bottom: "",
            [oppositeSide]: `${-arrowLength / 2}px`,
            transform: "rotate(45deg)"
          });
        }
      });
    },
    { animationFrame: true }
  );
}
var __defProp$1 = Object.defineProperty;
var __decorateClass$1 = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp$1(target, key, result);
  return result;
};
const _Tooltip = class _Tooltip extends h {
  constructor() {
    super(...arguments);
    this.visible = false;
    this.withArrow = false;
    this.placement = "top";
  }
  update(changedProperties) {
    super.update(changedProperties);
    if (changedProperties.has("text") || changedProperties.has("tooltipTitle")) {
      this.updateInlineSize();
    }
  }
  hide() {
    var _a2;
    if (document.activeElement === this.triggerElement || !this.visible) return;
    this.visible = false;
    this.tooltip.hidePopover();
    (_a2 = this.cleanup) == null ? void 0 : _a2.call(this);
  }
  show() {
    if (this.visible) return;
    this.visible = true;
    this.tooltip.showPopover();
    this.updateInlineSize();
    updatePosition(
      this.triggerElement,
      this.tooltip,
      this.tooltipArrow,
      this.placement,
      this.withArrow
    );
  }
  get triggerElement() {
    const assignedElements = this.triggerSlot.assignedElements();
    return assignedElements.length > 0 ? assignedElements[0] : null;
  }
  addListenersToTriggerElement() {
    var _a2, _b, _c, _d;
    (_a2 = this.triggerElement) == null ? void 0 : _a2.addEventListener("focus", this.show.bind(this));
    (_b = this.triggerElement) == null ? void 0 : _b.addEventListener("blur", this.hide.bind(this));
    (_c = this.triggerElement) == null ? void 0 : _c.addEventListener("mouseover", this.show.bind(this));
    (_d = this.triggerElement) == null ? void 0 : _d.addEventListener("mouseleave", this.hide.bind(this));
  }
  // The popover has a max inline size inside which the title and/or text will be wrapped.
  // This will often lead to a lot of empty space on the right side, which is removed here.
  // Based on https://stackoverflow.com/a/73706430/4469336
  updateInlineSize() {
    var _a2, _b, _c, _d;
    if (!this.visible) return;
    (_a2 = this.titleElement) == null ? void 0 : _a2.style.removeProperty("inline-size");
    (_b = this.textElement) == null ? void 0 : _b.style.removeProperty("inline-size");
    const size1 = this.determineInlineSize(this.titleElement);
    const size2 = this.determineInlineSize(this.textElement);
    const size = Math.max(size1, size2);
    (_c = this.titleElement) == null ? void 0 : _c.style.setProperty("inline-size", `${size}px`);
    (_d = this.textElement) == null ? void 0 : _d.style.setProperty("inline-size", `${size}px`);
  }
  determineInlineSize(wrapper) {
    if (!wrapper) return 0;
    const isTextNode = (node) => node.nodeType === 3;
    const textNode = Array.from(wrapper.childNodes).find(isTextNode);
    if (!textNode) return 0;
    const range = document.createRange();
    range.setStartBefore(textNode);
    range.setEndAfter(textNode);
    const rect = range.getBoundingClientRect();
    return rect.width;
  }
  render() {
    return ke$1`
      <slot @slotchange=${this.addListenersToTriggerElement}></slot>

      ${""}
      <div
        class="zw-tooltip"
        popover="manual"
        id="${this.id}"
        role="tooltip"
        aria-live=${this.visible ? "polite" : "off"}
      >
        ${this.arrowHTML()} ${this.tooltipTitleHTML()} ${this.textHTML()}
      </div>
    `;
  }
  arrowHTML() {
    if (!this.withArrow) return D;
    return ke$1`<span class="zw-tooltip--arrow"></span>`;
  }
  tooltipTitleHTML() {
    if (!this.tooltipTitle) return D;
    return ke$1`<div class="zw-tooltip--title">${this.tooltipTitle}</div>`;
  }
  textHTML() {
    return ke$1`<div class="zw-tooltip--text">${this.text}</div>`;
  }
};
_Tooltip.styles = [r$3(baseStyles), r$3(styles$3)];
let Tooltip = _Tooltip;
__decorateClass$1([
  r()
], Tooltip.prototype, "visible");
__decorateClass$1([
  n$1({ type: Boolean, reflect: true, attribute: "with-arrow" })
], Tooltip.prototype, "withArrow");
__decorateClass$1([
  n$1({ reflect: true, attribute: "tooltip-title" })
], Tooltip.prototype, "tooltipTitle");
__decorateClass$1([
  n$1({ reflect: true })
], Tooltip.prototype, "text");
__decorateClass$1([
  n$1({ reflect: false })
], Tooltip.prototype, "id");
__decorateClass$1([
  n$1({ reflect: true })
], Tooltip.prototype, "placement");
__decorateClass$1([
  e$2("slot")
], Tooltip.prototype, "triggerSlot");
__decorateClass$1([
  e$2(".zw-tooltip")
], Tooltip.prototype, "tooltip");
__decorateClass$1([
  e$2(".zw-tooltip--arrow")
], Tooltip.prototype, "tooltipArrow");
__decorateClass$1([
  e$2(".zw-tooltip--title")
], Tooltip.prototype, "titleElement");
__decorateClass$1([
  e$2(".zw-tooltip--text")
], Tooltip.prototype, "textElement");
const styles$2 = ":host {\n  display: block;\n}\n\n.zw-top-navigation {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--zw-spacing-4);\n  box-shadow: inset 0 -1px 0 0 var(--zw-color-outline-variant-low);\n  background-color: var(--zw-color-surface);\n}\n\n@media (min-width: 1240px) and (max-width: 1439px),(min-width: 1440px) and (max-width: 1727px),(min-width: 1728px) {\n\n.zw-top-navigation {\n    padding-inline: var(--zw-spacing-40);\n}\n  }\n\n@media (min-width: 640px) and (max-width: 1024px),(min-width: 1024px) and (max-width: 1239px) {\n\n.zw-top-navigation {\n    padding-inline: var(--zw-spacing-24);\n}\n  }\n\n@media (max-width: 639px) {\n\n.zw-top-navigation {\n    padding-inline: var(--zw-spacing-16);\n}\n  }\n";
const _TopNavigation = class _TopNavigation extends h {
  render() {
    return ke$1`
      <header class="zw-top-navigation"><slot name="left"></slot><slot name="right"></slot></header>
    `;
  }
};
_TopNavigation.styles = [r$3(baseStyles), r$3(styles$2)];
let TopNavigation = _TopNavigation;
const styles$1 = ':host {\n  --zw-top-navigation-item-box-shadow-color: transparent;\n\n  display: inline-block;\n}\n\n.zw-top-navigation-item--button,\n.zw-top-navigation-item--link {\n  display: inline-block;\n  padding-inline: var(--zw-spacing-8);\n}\n\n.zw-top-navigation-item--button[aria-current="page"],.zw-top-navigation-item--link[aria-current="page"] {\n    --zw-top-navigation-item-color: var(--zw-color-primary);\n    --zw-top-navigation-item-box-shadow-color: var(--zw-color-primary);\n  }\n\n.zw-top-navigation-item--button:active {\n    -webkit-text-decoration: none;\n    text-decoration: none;\n  }\n\n.zw-top-navigation-item--link:active {\n    -webkit-text-decoration: none;\n    text-decoration: none;\n  }\n\n.zw-top-navigation-item--button:focus,.zw-top-navigation-item--link:focus,.zw-top-navigation-item--button:hover,.zw-top-navigation-item--link:hover {\n    -webkit-text-decoration: none;\n    text-decoration: none;\n  }\n\n.zw-top-navigation-item--button:focus-visible {\n    --zw-top-navigation-item-color: var(--zw-color-on-surface);\n    --zw-top-navigation-item-box-shadow-color: transparent;\n\n    outline: 2px solid var(--zw-color-on-surface);\n    outline-offset: -2px;\n  }\n\n.zw-top-navigation-item--link:focus-visible {\n    --zw-top-navigation-item-color: var(--zw-color-on-surface);\n    --zw-top-navigation-item-box-shadow-color: transparent;\n\n    outline: 2px solid var(--zw-color-on-surface);\n    outline-offset: -2px;\n  }\n\n.zw-top-navigation-item--button:hover,.zw-top-navigation-item--link:hover {\n    --zw-top-navigation-item-color: var(--zw-color-states-primary-hover);\n    --zw-top-navigation-item-box-shadow-color: var(--zw-color-states-primary-hover);\n  }\n\n.zw-top-navigation-item--button:active {\n    --zw-top-navigation-item-color: var(--zw-color-states-primary-focus-press);\n    --zw-top-navigation-item-box-shadow-color: var(--zw-color-states-primary-focus-press);\n  }\n\n.zw-top-navigation-item--link:active {\n    --zw-top-navigation-item-color: var(--zw-color-states-primary-focus-press);\n    --zw-top-navigation-item-box-shadow-color: var(--zw-color-states-primary-focus-press);\n  }\n\n.zw-top-navigation-item--button:disabled {\n    --zw-top-navigation-item-color: var(--zw-color-on-surface-variant);\n    --zw-top-navigation-item-box-shadow-color: transparent;\n\n    cursor: not-allowed;\n  }\n\n.zw-top-navigation-item--link:disabled {\n    --zw-top-navigation-item-color: var(--zw-color-on-surface-variant);\n    --zw-top-navigation-item-box-shadow-color: transparent;\n\n    cursor: not-allowed;\n  }\n\n.zw-top-navigation-item--button[aria-disabled],.zw-top-navigation-item--link[aria-disabled] {\n    --zw-top-navigation-item-color: var(--zw-color-on-surface-variant);\n    --zw-top-navigation-item-box-shadow-color: transparent;\n\n    cursor: not-allowed;\n  }\n\n.zw-top-navigation-item--content {\n  display: flex;\n  align-items: center;\n  gap: var(--zw-spacing-4);\n  padding-block: var(--zw-spacing-24);\n  box-shadow: inset 0 -2px 0 0 var(--zw-top-navigation-item-box-shadow-color);\n  font: var(--zw-typography-button-m-medium);\n  color: var(--zw-top-navigation-item-color);\n}\n';
var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i3 = decorators.length - 1, decorator; i3 >= 0; i3--)
    if (decorator = decorators[i3])
      result = decorator(target, key, result) || result;
  if (result) __defProp(target, key, result);
  return result;
};
const _TopNavigationItem = class _TopNavigationItem extends h {
  constructor() {
    super(...arguments);
    this.current = false;
    this.disabled = false;
  }
  get ariaCurrent() {
    return this.current ? "page" : null;
  }
  render() {
    return ke$1`<div class="zw-top-navigation-item" role="listitem">
      ${this.innerComponentHTML()}
    </div>`;
  }
  innerComponentHTML() {
    if (this.href)
      return ke$1`<a
        class="zw-top-navigation-item--link"
        aria-label=${to(this.ariaLabel)}
        href=${this.disabled ? D : this.href}
        aria-current=${to(this.ariaCurrent)}
        ?aria-disabled=${this.disabled}
      >
        ${this.contentHTML()}
      </a>`;
    return ke$1`<button
      class="zw-top-navigation-item--button"
      type="button"
      ?disabled=${this.disabled}
      aria-current=${to(this.ariaCurrent)}
    >
      ${this.contentHTML()}
    </button>`;
  }
  contentHTML() {
    return ke$1`<span class="zw-top-navigation-item--content"><slot></slot></span>`;
  }
};
_TopNavigationItem.styles = [r$3(baseStyles), r$3(styles$1)];
_TopNavigationItem.shadowRootOptions = { ...h.shadowRootOptions, delegatesFocus: true };
let TopNavigationItem = _TopNavigationItem;
__decorateClass([
  n$1({ type: Boolean, reflect: true })
], TopNavigationItem.prototype, "current");
__decorateClass([
  n$1({ type: Boolean, reflect: true })
], TopNavigationItem.prototype, "disabled");
__decorateClass([
  n$1({ reflect: true })
], TopNavigationItem.prototype, "href");
const styles = ":host {\n  display: inline-block;\n}\n";
const _TopNavigationList = class _TopNavigationList extends h {
  render() {
    return ke$1`<div class="zw-top-navigation-list" role="list">
      <slot></slot>
    </div>`;
  }
};
_TopNavigationList.styles = [r$3(baseStyles), r$3(styles)];
let TopNavigationList = _TopNavigationList;
const registerAllComponents = () => {
  defineCustomElementOnce("zw-accordion", Accordion);
  defineCustomElementOnce("zw-avatar", Avatar);
  defineCustomElementOnce("zw-badge", Badge);
  defineCustomElementOnce("zw-breadcrumb-item", BreadcrumbItem);
  defineCustomElementOnce("zw-breadcrumbs", Breadcrumbs);
  defineCustomElementOnce("zw-button", Button);
  defineCustomElementOnce("zw-card", Card);
  defineCustomElementOnce("zw-checkbox", Checkbox);
  defineCustomElementOnce("zw-checkbox-group", CheckboxGroup);
  defineCustomElementOnce("zw-chip", Chip);
  defineCustomElementOnce("zw-datetime-field", DatetimeField);
  defineCustomElementOnce("zw-divider", Divider);
  defineCustomElementOnce("zw-drawer", Drawer);
  defineCustomElementOnce("zw-dropdown", Dropdown);
  defineCustomElementOnce("zw-dropdown-item", DropdownItem);
  defineCustomElementOnce("zw-dropdown-item-group", DropdownItemGroup);
  defineCustomElementOnce("zw-dropdown-menu", DropdownMenu);
  defineCustomElementOnce("zw-file-drop-zone", FileDropZone);
  defineCustomElementOnce("zw-file-upload", FileUpload);
  defineCustomElementOnce("zw-file-upload-list", FileUploadList);
  defineCustomElementOnce("zw-heading", Heading);
  defineCustomElementOnce("zw-icon", Icon);
  defineCustomElementOnce("zw-infobox", Infobox);
  defineCustomElementOnce("zw-infobox", Infobox);
  defineCustomElementOnce("zw-link", Link);
  defineCustomElementOnce("zw-list-item", ListItem);
  defineCustomElementOnce("zw-loading-indicator", LoadingIndicator);
  defineCustomElementOnce("zw-modal", Modal);
  defineCustomElementOnce("zw-option", Option);
  defineCustomElementOnce("zw-page-state", PageState);
  defineCustomElementOnce("zw-pagination-bar", PaginationBar);
  defineCustomElementOnce("zw-pagination", Pagination);
  defineCustomElementOnce("zw-password-field", PasswordField);
  defineCustomElementOnce("zw-payment-method-icon", PaymentMethodIcon);
  defineCustomElementOnce("zw-radio-button", RadioButton);
  defineCustomElementOnce("zw-radio-button-group", RadioButtonGroup);
  defineCustomElementOnce("zw-scroll-box", ScrollBox);
  defineCustomElementOnce("zw-select", Select);
  defineCustomElementOnce("zw-snackbar", Snackbar);
  defineCustomElementOnce("zw-tab-group", TabGroup);
  defineCustomElementOnce("zw-tab-item", TabItem);
  defineCustomElementOnce("zw-tab-panel", TabPanel);
  defineCustomElementOnce("zw-table", Table);
  defineCustomElementOnce("zw-tag", Tag);
  defineCustomElementOnce("zw-text-area", TextArea);
  defineCustomElementOnce("zw-text-field", TextField);
  defineCustomElementOnce("zw-toast", Toast);
  defineCustomElementOnce("zw-tooltip", Tooltip);
  defineCustomElementOnce("zw-top-navigation", TopNavigation);
  defineCustomElementOnce("zw-top-navigation-item", TopNavigationItem);
  defineCustomElementOnce("zw-top-navigation-list", TopNavigationList);
};
export {
  Accordion as ZwAccordion,
  Avatar as ZwAvatar,
  Badge as ZwBadge,
  BreadcrumbItem as ZwBreadcrumbItem,
  Breadcrumbs as ZwBreadcrumbs,
  Button as ZwButton,
  Card as ZwCard,
  Checkbox as ZwCheckbox,
  CheckboxGroup as ZwCheckboxGroup,
  Chip as ZwChip,
  DatetimeField as ZwDatetimeField,
  Divider as ZwDivider,
  Drawer as ZwDrawer,
  Dropdown as ZwDropdown,
  DropdownItem as ZwDropdownItem,
  DropdownItemGroup as ZwDropdownItemGroup,
  DropdownMenu as ZwDropdownMenu,
  FileDropZone as ZwFileDropZone,
  FileUpload as ZwFileUpload,
  FileUploadList as ZwFileUploadList,
  Heading as ZwHeading,
  Icon as ZwIcon,
  Infobox as ZwInfobox,
  Link as ZwLink,
  ListItem as ZwListItem,
  LoadingIndicator as ZwLoadingIndicator,
  Modal as ZwModal,
  Option as ZwOption,
  PageState as ZwPageState,
  Pagination as ZwPagination,
  PaginationBar as ZwPaginationBar,
  PasswordField as ZwPasswordField,
  PaymentMethodIcon as ZwPaymentMethodIcon,
  RadioButton as ZwRadioButton,
  RadioButtonGroup as ZwRadioButtonGroup,
  ScrollBox as ZwScrollBox,
  Select as ZwSelect,
  Snackbar as ZwSnackbar,
  TabGroup as ZwTabGroup,
  TabItem as ZwTabItem,
  TabPanel as ZwTabPanel,
  Table as ZwTable,
  Tag as ZwTag,
  TextArea as ZwTextArea,
  TextField as ZwTextField,
  Toast as ZwToast,
  Tooltip as ZwTooltip,
  TopNavigation as ZwTopNavigation,
  TopNavigationItem as ZwTopNavigationItem,
  TopNavigationList as ZwTopNavigationList,
  registerAllComponents
};
